
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequirefc28"];
var parcelRegister = parcelRequire.register;
parcelRegister("LOjqb", function(module, exports) {
$parcel$export(module.exports, "useSmartLinkAnalyticsContext", () => $995e730e772a1589$export$ac28ada90c4970b7);

var $bSJIT = parcelRequire("bSJIT");

var $6bOBo = parcelRequire("6bOBo");

var $bLV8M = parcelRequire("bLV8M");

var $8AAWw = parcelRequire("8AAWw");
const $995e730e772a1589$export$ac28ada90c4970b7 = ({ display: display, id: id, source: source, url: url })=>{
    const { store: store } = (0, $6bOBo.useSmartLinkContext)();
    const state = store ? (0, $bLV8M.getUrl)(store, url) : undefined;
    return (0, $bSJIT.useMemo)(()=>{
        return (0, $8AAWw.getSmartLinkAnalyticsContext)({
            display: display,
            id: id,
            response: state === null || state === void 0 ? void 0 : state.details,
            source: source,
            status: state === null || state === void 0 ? void 0 : state.status,
            url: url,
            error: state === null || state === void 0 ? void 0 : state.error
        });
    }, [
        display,
        id,
        source,
        state === null || state === void 0 ? void 0 : state.details,
        state === null || state === void 0 ? void 0 : state.status,
        url,
        state === null || state === void 0 ? void 0 : state.error
    ]);
};

});

parcelRegister("83rwn", function(module, exports) {
$parcel$export(module.exports, "isFlexibleUiCard", () => $91f21e57acde4bf7$export$3c94e0f4719f5c2a);

var $bSJIT = parcelRequire("bSJIT");

var $5tQXW = parcelRequire("5tQXW");
const $91f21e57acde4bf7$export$3c94e0f4719f5c2a = (children, ui)=>{
    if (ui !== null && ui !== void 0 && ui.removeBlockRestriction) {
        var _React$Children$toArr;
        return children && ((_React$Children$toArr = (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).Children.toArray(children)) === null || _React$Children$toArr === void 0 ? void 0 : _React$Children$toArr.length) > 0 ? true : false;
    }
    if (children && (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).Children.toArray(children).some((child)=>(0, $5tQXW.isFlexibleUiTitleBlock)(child))) return true;
    return false;
};

});
parcelRegister("5tQXW", function(module, exports) {
$parcel$export(module.exports, "isFlexibleUiTitleBlock", () => $159b06b565011764$export$df0092b19156b140);

var $bSJIT = parcelRequire("bSJIT");

var $iD4XW = parcelRequire("iD4XW");

var $eaAgR = parcelRequire("eaAgR");
const $159b06b565011764$export$df0092b19156b140 = (node)=>{
    if (!/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).isValidElement(node)) return false;
    if (node.type === (0, $iD4XW.default)) return true;
    if ((0, $eaAgR.isStyleCacheProvider)(node)) {
        // Component wrapped with compiled at runtime, check for children
        let isChildrenValid = true;
        (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).Children.map(node.props.children, (child)=>{
            var _child$type;
            if (!/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).isValidElement(child)) {
                isChildrenValid = false;
                return;
            }
            if (typeof child.type !== 'string' && ((_child$type = child.type) === null || _child$type === void 0 ? void 0 : _child$type.name) !== 'Style') isChildrenValid = $159b06b565011764$export$df0092b19156b140(child);
        });
        return isChildrenValid;
    }
    return false;
};

});
parcelRegister("iD4XW", function(module, exports) {
$parcel$export(module.exports, "default", () => $f08f1d2f017388d9$export$2e2bcd8739ae039);
/* eslint-disable @repo/internal/deprecations/deprecation-ticket-required -- VOLTC-139 tracks removal of these deprecated re-export shims. */ /**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $hTuwG = parcelRequire("hTuwG");
var $f08f1d2f017388d9$export$2e2bcd8739ae039 = (0, $hTuwG.TitleBlock);

});
parcelRegister("hTuwG", function(module, exports) {
$parcel$export(module.exports, "TitleBlock", () => $d53a958daf089658$export$ccf187e9bb6e68c);
/* TitleBlock.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $bSJIT = parcelRequire("bSJIT");

var $9fU1q = parcelRequire("9fU1q");

var $gdUUy = parcelRequire("gdUUy");

var $5kJPq = parcelRequire("5kJPq");

var $e6VxI = parcelRequire("e6VxI");

var $eAoOt = parcelRequire("eAoOt");

var $7XNox = parcelRequire("7XNox");

var $goesr = parcelRequire("goesr");

var $bUztx = parcelRequire("bUztx");

var $aHHqC = parcelRequire("aHHqC");

var $ay88c = parcelRequire("ay88c");
const $d53a958daf089658$var$actionStyles = null;
const $d53a958daf089658$var$getTitleBlockViewComponent = (status)=>{
    switch(status){
        case (0, $5kJPq.SmartLinkStatus).Pending:
        case (0, $5kJPq.SmartLinkStatus).Resolving:
            return 0, $ay88c.default;
        case (0, $5kJPq.SmartLinkStatus).Resolved:
            return 0, $aHHqC.default;
        case (0, $5kJPq.SmartLinkStatus).Unauthorized:
        case (0, $5kJPq.SmartLinkStatus).Forbidden:
        case (0, $5kJPq.SmartLinkStatus).NotFound:
        case (0, $5kJPq.SmartLinkStatus).Errored:
        case (0, $5kJPq.SmartLinkStatus).Fallback:
        default:
            return 0, $bUztx.default;
    }
};
const $d53a958daf089658$export$ccf187e9bb6e68c = ({ actions: actions = [], anchorTarget: anchorTarget, hideTitleTooltip: hideTitleTooltip, maxLines: maxLines, onActionMenuOpenChange: onActionMenuOpenChange, showActionOnHover: showActionOnHover, testId: testId = 'smart-block-title', text: text, icon: icon, hideRetry: hideRetry, metadataPosition: metadataPosition, hideIcon: hideIcon = false, className: className, anchorRef: anchorRef, CompetitorPrompt: CompetitorPrompt, url: url, hideIconLoadingSkeleton: hideIconLoadingSkeleton, ...props })=>{
    var _cardContext$navigati;
    const cardContext = (0, $eAoOt.useFlexibleCardContext)();
    const { status: status = (0, $5kJPq.SmartLinkStatus).Fallback, ui: ui } = cardContext || {};
    const [actionDropdownOpen, setActionDropdownOpen] = (0, $bSJIT.useState)(false);
    const onDropdownOpenChange = (0, $bSJIT.useCallback)((isOpen)=>{
        setActionDropdownOpen(isOpen);
        if (onActionMenuOpenChange) onActionMenuOpenChange({
            isOpen: isOpen
        });
    }, [
        onActionMenuOpenChange
    ]);
    const actionGroup = actions.length > 0 && /*#__PURE__*/ $bSJIT.createElement((0, $goesr.default), {
        items: actions,
        visibleButtonsNum: showActionOnHover ? 1 : 2,
        onDropdownOpenChange: onDropdownOpenChange
    });
    const overrideText = !!text ? {
        text: text
    } : {};
    const onMouseDown = (0, $e6VxI.useMouseDownEvent)();
    const title = /*#__PURE__*/ $bSJIT.createElement((0, $7XNox.default), {
        hideTooltip: hideTitleTooltip,
        maxLines: maxLines,
        onMouseDown: onMouseDown,
        target: (0, $gdUUy.fg)('confluence_ep_shim_macro_links_v2') ? anchorTarget ?? (cardContext === null || cardContext === void 0 || (_cardContext$navigati = cardContext.navigation) === null || _cardContext$navigati === void 0 ? void 0 : _cardContext$navigati.target) : anchorTarget,
        theme: ui === null || ui === void 0 ? void 0 : ui.theme,
        anchorRef: anchorRef,
        ...overrideText
    });
    const Component = $d53a958daf089658$var$getTitleBlockViewComponent(status);
    return /*#__PURE__*/ $bSJIT.createElement(Component, {
        ...props,
        actionGroup: actionGroup,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
        className: (0, $9fU1q.default)([
            showActionOnHover && !actionDropdownOpen && "_1bfhidpf _wn5xkb7n _h157kb7n",
            className
        ]),
        testId: testId,
        title: title,
        metadataPosition: metadataPosition,
        hideIcon: hideIcon,
        hideRetry: hideRetry,
        icon: icon,
        hideIconLoadingSkeleton: hideIconLoadingSkeleton,
        size: props.size ?? (ui === null || ui === void 0 ? void 0 : ui.size),
        CompetitorPrompt: CompetitorPrompt,
        url: url
    });
};

});
parcelRegister("eAoOt", function(module, exports) {
$parcel$export(module.exports, "useFlexibleCardContext", () => $ac8b8a227f9714cc$export$a8c4167e4e9f26ab);

var $bSJIT = parcelRequire("bSJIT");

var $7avPz = parcelRequire("7avPz");
const $ac8b8a227f9714cc$export$a8c4167e4e9f26ab = ()=>(0, $bSJIT.useContext)((0, $7avPz.FlexibleCardContext));

});
parcelRegister("7avPz", function(module, exports) {
$parcel$export(module.exports, "FlexibleCardContext", () => $f42298cf453f229f$export$13dde4423ab71d62);

var $bSJIT = parcelRequire("bSJIT");
const $f42298cf453f229f$export$13dde4423ab71d62 = (0, $bSJIT.createContext)(undefined);

});


parcelRegister("7XNox", function(module, exports) {
$parcel$export(module.exports, "default", () => $0eba995ea1ceb007$export$2e2bcd8739ae039);

var $bSJIT = parcelRequire("bSJIT");

var $gdUUy = parcelRequire("gdUUy");

var $5kJPq = parcelRequire("5kJPq");

var $eAoOt = parcelRequire("eAoOt");

var $lwqfz = parcelRequire("lwqfz");
const $0eba995ea1ceb007$var$TitleElement = (props)=>{
    var _context$data, _context$navigation;
    const context = (0, $eAoOt.useFlexibleCardContext)();
    const data = context === null || context === void 0 || (_context$data = context.data) === null || _context$data === void 0 ? void 0 : _context$data.linkTitle;
    return data ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $lwqfz.default), {
        ...data,
        url: (0, $gdUUy.fg)('confluence_ep_shim_macro_links_v2') ? (context === null || context === void 0 || (_context$navigation = context.navigation) === null || _context$navigation === void 0 ? void 0 : _context$navigation.url) ?? data.url : data.url,
        ...props,
        name: (0, $5kJPq.ElementName).Title
    }) : null;
};
var $0eba995ea1ceb007$export$2e2bcd8739ae039 = $0eba995ea1ceb007$var$TitleElement;

});
parcelRegister("lwqfz", function(module, exports) {
$parcel$export(module.exports, "default", () => $2f2ab6e228a6b740$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v3.0.2 */ /* eslint-disable @compiled/shorthand-property-sorting */ /* eslint-disable @atlaskit/design-system/use-tokens-typography */ 
var $9fU1q = parcelRequire("9fU1q");

var $bSJIT = parcelRequire("bSJIT");

var $lavtv = parcelRequire("lavtv");

var $5kJPq = parcelRequire("5kJPq");

var $e6VxI = parcelRequire("e6VxI");

var $ep7BO = parcelRequire("ep7BO");
const $2f2ab6e228a6b740$var$DEFAULT_MAX_LINES = 2;
const $2f2ab6e228a6b740$var$MAXIMUM_MAX_LINES = 2;
const $2f2ab6e228a6b740$var$MINIMUM_MAX_LINES = 1;
const $2f2ab6e228a6b740$var$containerStyles = null;
const $2f2ab6e228a6b740$var$getMaxLines = (maxLines)=>{
    if (maxLines > $2f2ab6e228a6b740$var$MAXIMUM_MAX_LINES) return $2f2ab6e228a6b740$var$DEFAULT_MAX_LINES;
    if (maxLines < $2f2ab6e228a6b740$var$MINIMUM_MAX_LINES) return $2f2ab6e228a6b740$var$MINIMUM_MAX_LINES;
    return maxLines;
};
const $2f2ab6e228a6b740$var$withTooltip = (trigger, content, testId)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $lavtv.default), {
        content: content,
        testId: `${testId}-tooltip`,
        tag: "span"
    }, trigger);
const $2f2ab6e228a6b740$var$linkStyleSizeMap = {
    xlarge: "_11c81af2 _k48pi7a9 _vwz41k8s",
    large: "_11c8fhey _k48pi7a9 _vwz41j6v",
    medium: "_11c8fhey _k48pi7a9 _vwz41j6v",
    small: "_11c8wadc _k48pi7a9 _vwz41j6v"
};
const $2f2ab6e228a6b740$var$baseAnchorStyle = null;
const $2f2ab6e228a6b740$var$workBreakStyleMap = {
    true: "_1nmz1hna",
    false: "_1nmz9jpi"
};
const $2f2ab6e228a6b740$var$anchorConstantsStyles = null;
const $2f2ab6e228a6b740$var$anchorLineClampMap = {
    1: "_1yyjkb7n",
    2: "_1yyjcs5v"
};
const $2f2ab6e228a6b740$var$anchorLinkLineHeight1Map = {
    xlarge: "_102k1k8s",
    large: "_102k1j6v",
    medium: "_102k1j6v",
    small: "_102k1j6v"
};
const $2f2ab6e228a6b740$var$anchorLinkLineHeight2Map = {
    xlarge: "_102k1wto",
    large: "_102kviql",
    medium: "_102kviql",
    small: "_102kviql"
};
const $2f2ab6e228a6b740$var$themeStyleMap = {
    grey: "_fjv61r31 _93u91r31 _g2lk1r31 _pnzf1r31 _hlwq8stv _1e2m8stv _1l4b8stv _ue8d8stv _yni7nqa1 _1bianqa1 _93jhnqa1 _64n6nqa1 _1ray1rpy _dlb71rpy _rnxt1rpy _1h4d1rpy _10uewadc _ye101rpy",
    black: "_syazazsu _1nrm1r31 _1a3b1r31 _9oik1r31 _1ydc1r31 _c2wa8stv _4fpr8stv _1bnx8stv _1x288stv _1iohnqa1 _5goinqa1 _jf4cnqa1 _1726nqa1 _9h8hazsu _f8pjazsu _30l3azsu _1053azsu",
    link: "_syaz13af _9oik1r31 _1bnx8stv _jf4cnqa1 _30l313af _9h8h12zz"
};
/**
 * A base element that represent an anchor.
 * @internal
 * @param {BaseLinkElementProps} BaseLinkElementProps - The props necessary for the Link element.
 * @see LinkIcon
 */ const $2f2ab6e228a6b740$var$BaseLinkElement = ({ hideTooltip: hideTooltip, maxLines: maxLines = $2f2ab6e228a6b740$var$DEFAULT_MAX_LINES, name: name, className: className, size: size = (0, $5kJPq.SmartLinkSize).Medium, testId: testId = 'smart-element-link', text: text, theme: theme = (0, $5kJPq.SmartLinkTheme).Link, url: url, onClick: onClick, onAuxClick: onAuxClick, onContextMenu: onContextMenu, target: target = '_blank', anchorRef: anchorRef })=>{
    const onMouseDown = (0, $e6VxI.useMouseDownEvent)();
    const hasSpace = (0, $bSJIT.useMemo)(()=>text ? (0, $ep7BO.hasWhiteSpace)(text) : false, [
        text
    ]);
    const anchor = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement("a", {
        "data-smart-element": name,
        "data-smart-element-link": true,
        "data-testid": testId,
        onClick: onClick,
        onAuxClick: onAuxClick,
        onContextMenu: onContextMenu,
        onMouseDown: onMouseDown,
        href: url,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
        className: (0, $9fU1q.default)([
            "_16jlkb7n _1o9zkb7n _i0dl1wug",
            $2f2ab6e228a6b740$var$linkStyleSizeMap[size],
            $2f2ab6e228a6b740$var$anchorLineClampMap[$2f2ab6e228a6b740$var$getMaxLines(maxLines)],
            "_1reo15vq _18m915vq _1e0ccj1k _1bto1l2s _sudp1e54",
            $2f2ab6e228a6b740$var$workBreakStyleMap[hasSpace ? 'true' : 'false'],
            $2f2ab6e228a6b740$var$getMaxLines(maxLines) === 1 && $2f2ab6e228a6b740$var$anchorLinkLineHeight1Map[size],
            $2f2ab6e228a6b740$var$getMaxLines(maxLines) === 2 && $2f2ab6e228a6b740$var$anchorLinkLineHeight2Map[size],
            $2f2ab6e228a6b740$var$themeStyleMap[theme],
            className
        ]),
        ...target !== '_self' && {
            target: target
        },
        ref: anchorRef
    }, text);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement("span", {
        className: (0, $9fU1q.default)([
            "_16jlkb7n _1o9zkb7n _i0dl1wug"
        ])
    }, hideTooltip || text === undefined ? anchor : $2f2ab6e228a6b740$var$withTooltip(anchor, url !== null && url !== void 0 && url.includes(text) ? url : text, testId));
};
var $2f2ab6e228a6b740$export$2e2bcd8739ae039 = $2f2ab6e228a6b740$var$BaseLinkElement;

});
parcelRegister("ep7BO", function(module, exports) {
$parcel$export(module.exports, "hasWhiteSpace", () => $9d2dd83e458c7d96$export$619e376a425cb759);
const $9d2dd83e458c7d96$export$619e376a425cb759 = (str)=>{
    return str.search(/\s/) >= 0;
};

});



parcelRegister("goesr", function(module, exports) {
$parcel$export(module.exports, "default", () => $ca58460764075814$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v3.0.2 */ /* eslint-disable @atlaskit/ui-styling-standard/no-nested-selectors */ 
var $bSJIT = parcelRequire("bSJIT");

var $9fU1q = parcelRequire("9fU1q");

var $5cKiX = parcelRequire("5cKiX");

var $f1bHg = parcelRequire("f1bHg");

var $4TRbS = parcelRequire("4TRbS");

var $lkSXl = parcelRequire("lkSXl");

var $iabGk = parcelRequire("iabGk");

var $lavtv = parcelRequire("lavtv");

var $5kJPq = parcelRequire("5kJPq");

var $7wYyA = parcelRequire("7wYyA");

var $7Z1Fb = parcelRequire("7Z1Fb");

var $3P7qX = parcelRequire("3P7qX");

var $cUXyD = parcelRequire("cUXyD");

var $4xVXc = parcelRequire("4xVXc");

var $jSDhC = parcelRequire("jSDhC");

var $bOMDA = parcelRequire("bOMDA");
const $ca58460764075814$var$styles = null;
const $ca58460764075814$var$FULL_ACTIONS_SIZE = 450;
const $ca58460764075814$var$REDUCED_ACTIONS_SIZE = 360;
const $ca58460764075814$var$ICON_ONLY_ACTIONS_SIZE = 200;
const $ca58460764075814$var$OVERFLOW_ONLY_ACTIONS_SIZE = 100;
const $ca58460764075814$var$renderActionItems = (items = [], size = (0, $5kJPq.SmartLinkSize).Medium, appearance, asDropDownItems, onActionItemClick)=>items.map((item, idx)=>/*#__PURE__*/ $bSJIT.createElement((0, $bOMDA.default), {
            item: item,
            key: idx,
            size: size,
            appearance: appearance,
            asDropDownItems: asDropDownItems,
            onActionItemClick: onActionItemClick
        }));
/**
 * Creates a group of Action components. Accepts an array of Actions, in addition to some styling
 * preferences.
 * @internal
 * @param {ActionGroupProps} ActionGroupProps
 * @see Action
 */ const $ca58460764075814$var$ActionGroup = ({ items: items = [], size: size = (0, $5kJPq.SmartLinkSize).Medium, appearance: appearance, visibleButtonsNum: visibleButtonsNum = 2, onDropdownOpenChange: onDropdownOpenChange, containerWidth: containerWidth = Infinity })=>{
    var _context$actions;
    const context = (0, $7Z1Fb.useFlexibleUiContext)();
    const ui = (0, $3P7qX.useFlexibleUiOptionContext)();
    const { product: product } = (0, $cUXyD.default)();
    const [isOpen, setIsOpen] = (0, $bSJIT.useState)(false);
    const renderableActionItems = (0, $bSJIT.useMemo)(()=>(0, $jSDhC.filterActionItems)(items, context, product), [
        context,
        items,
        product
    ]);
    const isMoreThenTwoItems = renderableActionItems.length > visibleButtonsNum;
    const rovoChatAction = context === null || context === void 0 || (_context$actions = context.actions) === null || _context$actions === void 0 ? void 0 : _context$actions[(0, $5kJPq.ActionName).RovoChatAction];
    const isRovoActionsEnabled = (0, $bSJIT.useMemo)(()=>{
        return !!rovoChatAction && rovoChatAction.product === 'CONFLUENCE' && items.some((action)=>action.name === 'RovoChatAction');
    }, [
        rovoChatAction,
        items
    ]);
    const onOpenChange = (0, $bSJIT.useCallback)((attrs)=>{
        setIsOpen(attrs.isOpen);
        if (onDropdownOpenChange) onDropdownOpenChange(attrs.isOpen);
    }, [
        onDropdownOpenChange
    ]);
    const onActionItemClick = (0, $bSJIT.useCallback)(()=>{
        if (isOpen) onOpenChange({
            isOpen: false
        });
    }, [
        isOpen,
        onOpenChange
    ]);
    const actionButtons = (0, $bSJIT.useMemo)(()=>{
        if (isRovoActionsEnabled) {
            const rovoActions = [
                ...containerWidth >= $ca58460764075814$var$REDUCED_ACTIONS_SIZE ? renderableActionItems.slice(0, visibleButtonsNum - 1) : [],
                ...containerWidth >= $ca58460764075814$var$OVERFLOW_ONLY_ACTIONS_SIZE ? [
                    {
                        name: (0, $5kJPq.ActionName).RovoChatAction,
                        prompts: [
                            (0, $4xVXc.RovoChatPromptKey).ASK_ROVO_ANYTHING
                        ],
                        iconSize: 'small',
                        cardAppearance: (0, $5kJPq.CardDisplay).Block,
                        hideContent: containerWidth < $ca58460764075814$var$FULL_ACTIONS_SIZE && containerWidth >= $ca58460764075814$var$REDUCED_ACTIONS_SIZE || containerWidth < $ca58460764075814$var$ICON_ONLY_ACTIONS_SIZE && containerWidth >= $ca58460764075814$var$OVERFLOW_ONLY_ACTIONS_SIZE
                    },
                    {
                        name: (0, $5kJPq.ActionName).CopyLinkAction,
                        hideContent: true,
                        iconSize: 'small'
                    },
                    {
                        name: (0, $5kJPq.ActionName).PreviewAction,
                        hideContent: true,
                        iconSize: 'small'
                    }
                ] : []
            ];
            return $ca58460764075814$var$renderActionItems(rovoActions, size, appearance, false, onActionItemClick);
        }
        const actionItems = isMoreThenTwoItems ? renderableActionItems.slice(0, visibleButtonsNum - 1) : renderableActionItems;
        return $ca58460764075814$var$renderActionItems(actionItems, size, appearance, false, onActionItemClick);
    }, [
        appearance,
        isMoreThenTwoItems,
        onActionItemClick,
        renderableActionItems,
        size,
        visibleButtonsNum,
        isRovoActionsEnabled,
        containerWidth
    ]);
    const moreActionDropdown = (0, $bSJIT.useMemo)(()=>{
        let actionItems;
        if (isRovoActionsEnabled && containerWidth < $ca58460764075814$var$OVERFLOW_ONLY_ACTIONS_SIZE) actionItems = [
            ...renderableActionItems,
            {
                name: (0, $5kJPq.ActionName).RovoChatAction,
                prompts: [
                    (0, $4xVXc.RovoChatPromptKey).ASK_ROVO_ANYTHING
                ],
                iconSize: 'small',
                cardAppearance: (0, $5kJPq.CardDisplay).Block
            },
            {
                name: (0, $5kJPq.ActionName).CopyLinkAction,
                iconSize: 'small'
            },
            {
                name: (0, $5kJPq.ActionName).PreviewAction,
                iconSize: 'small'
            }
        ];
        else if (isRovoActionsEnabled && containerWidth < $ca58460764075814$var$REDUCED_ACTIONS_SIZE) actionItems = renderableActionItems;
        else actionItems = isMoreThenTwoItems ? renderableActionItems.slice(visibleButtonsNum - 1) : [];
        if (actionItems.length > 0) {
            const formatMessage = /*#__PURE__*/ $bSJIT.createElement((0, $5cKiX.default), (0, $7wYyA.messages).more_actions);
            const moreIconAppearance = appearance !== 'subtle' ? 'default' : appearance;
            return /*#__PURE__*/ $bSJIT.createElement((0, $lkSXl.default), {
                isOpen: isOpen,
                onOpenChange: onOpenChange,
                trigger: ({ triggerRef: triggerRef, ...props })=>/*#__PURE__*/ $bSJIT.createElement((0, $lavtv.default), {
                        content: formatMessage,
                        hideTooltipOnClick: true,
                        testId: "action-group-more-button-tooltip",
                        tag: "span"
                    }, /*#__PURE__*/ $bSJIT.createElement((0, $4TRbS.default), {
                        ...props,
                        spacing: size === (0, $5kJPq.SmartLinkSize).XLarge ? 'default' : 'compact',
                        testId: "action-group-more-button",
                        icon: (0, (/*@__PURE__*/$parcel$interopDefault($iabGk))),
                        ref: triggerRef,
                        label: "more",
                        color: "currentColor",
                        ...isRovoActionsEnabled ? {
                            appearance: moreIconAppearance
                        } : {}
                    })),
                testId: "action-group-dropdown",
                zIndex: ui === null || ui === void 0 ? void 0 : ui.zIndex
            }, $ca58460764075814$var$renderActionItems(actionItems, size, appearance, true, onActionItemClick));
        }
        return null;
    }, [
        appearance,
        isMoreThenTwoItems,
        isOpen,
        onActionItemClick,
        onOpenChange,
        renderableActionItems,
        size,
        ui === null || ui === void 0 ? void 0 : ui.zIndex,
        visibleButtonsNum,
        isRovoActionsEnabled,
        containerWidth
    ]);
    return renderableActionItems.length > 0 ? /*#__PURE__*/ $bSJIT.createElement("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: (0, $9fU1q.default)([
            "_1e0c116y _dzc21h6o _1ilq1i6y",
            "actions-button-group"
        ]),
        "data-action-open": isOpen
    }, /*#__PURE__*/ $bSJIT.createElement((0, $f1bHg.default), null, actionButtons, moreActionDropdown)) : null;
};
var $ca58460764075814$export$2e2bcd8739ae039 = $ca58460764075814$var$ActionGroup;

});
parcelRegister("7Z1Fb", function(module, exports) {
$parcel$export(module.exports, "useFlexibleUiContext", () => $bddb39fbb742324a$export$61d7957a243df7aa);

var $eAoOt = parcelRequire("eAoOt");
const $bddb39fbb742324a$export$61d7957a243df7aa = ()=>{
    var _useFlexibleCardConte;
    return (_useFlexibleCardConte = (0, $eAoOt.useFlexibleCardContext)()) === null || _useFlexibleCardConte === void 0 ? void 0 : _useFlexibleCardConte.data;
};

});

parcelRegister("3P7qX", function(module, exports) {
$parcel$export(module.exports, "useFlexibleUiOptionContext", () => $22711eadc6ee0c1f$export$e6b5ad18b56e8f51);

var $eAoOt = parcelRequire("eAoOt");
const $22711eadc6ee0c1f$export$e6b5ad18b56e8f51 = ()=>{
    var _useFlexibleCardConte;
    return (_useFlexibleCardConte = (0, $eAoOt.useFlexibleCardContext)()) === null || _useFlexibleCardConte === void 0 ? void 0 : _useFlexibleCardConte.ui;
};

});

parcelRegister("cUXyD", function(module, exports) {
$parcel$export(module.exports, "default", () => $da3ad2dfd033cfda$export$2e2bcd8739ae039);

var $bSJIT = parcelRequire("bSJIT");

var $6bOBo = parcelRequire("6bOBo");
const $da3ad2dfd033cfda$var$useRovoConfig = ()=>{
    const { rovoOptions: rovoOptions, product: product } = (0, $6bOBo.useSmartLinkContext)();
    return (0, $bSJIT.useMemo)(()=>({
            rovoOptions: rovoOptions,
            product: product
        }), [
        rovoOptions,
        product
    ]);
};
var $da3ad2dfd033cfda$export$2e2bcd8739ae039 = $da3ad2dfd033cfda$var$useRovoConfig;

});

parcelRegister("4xVXc", function(module, exports) {
$parcel$export(module.exports, "RovoChatPromptKey", () => $87b6c3de92ffcb40$export$a9f8723a23072cb8);
$parcel$export(module.exports, "getPromptAction", () => $87b6c3de92ffcb40$export$35d7b8e732470f9f);

var $bSJIT = parcelRequire("bSJIT");

var $jIn8I = parcelRequire("jIn8I");

var $6sLTn = parcelRequire("6sLTn");

var $9H9S7 = parcelRequire("9H9S7");

var $3Vt8T = parcelRequire("3Vt8T");

var $fAjRj = parcelRequire("fAjRj");

var $5kJPq = parcelRequire("5kJPq");

var $7wYyA = parcelRequire("7wYyA");

var $4phF2 = parcelRequire("4phF2");

var $ey534 = parcelRequire("ey534");

var $djpCR = parcelRequire("djpCR");
var $87b6c3de92ffcb40$export$a9f8723a23072cb8 = /*#__PURE__*/ function(RovoChatPromptKey) {
    RovoChatPromptKey["SUMMARIZE_LINK"] = "summarize-link";
    RovoChatPromptKey["KEY_HIGHLIGHTS"] = "key-highlights";
    RovoChatPromptKey["ASK_ROVO_ANYTHING"] = "ask-rovo-anything";
    RovoChatPromptKey["IDENTIFY_KEY_POINTS"] = "identify-key-points";
    RovoChatPromptKey["IDENTIFY_KEY_TRENDS"] = "identify-key-trends";
    RovoChatPromptKey["FIND_OPEN_QUESTIONS"] = "find-open-questions";
    RovoChatPromptKey["HIGHLIGHT_RELEVANT_CONTENT"] = "highlight-relevant-content";
    RovoChatPromptKey["SUMMARIZE_THIS_FOR_ME"] = "summarize-this-for-me";
    RovoChatPromptKey["ASK_A_SPECIFIC_QUESTION"] = "ask-a-specific-question";
    RovoChatPromptKey["SHOW_ME_WHATS_RELEVANT"] = "show-me-whats-relevant";
    RovoChatPromptKey["SUMMARIZE_DOCUMENT"] = "summarize-document";
    RovoChatPromptKey["SUMMARIZE_PRESENTATION"] = "summarize-presentation";
    RovoChatPromptKey["EXPLAIN_CODE"] = "explain-code";
    RovoChatPromptKey["CATCH_UP"] = "catch-up";
    RovoChatPromptKey["SALESFORCE_PREP"] = "salesforce-prep";
    return RovoChatPromptKey;
}({});
const $87b6c3de92ffcb40$var$getContext = (intl, product)=>{
    switch(product){
        case 'CONFLUENCE':
            return {
                contextLong: intl.formatMessage((0, $7wYyA.messages).rovo_prompt_context_confluence_page)
            };
        case 'JSW':
        case 'JWM':
        case 'JSM':
        case 'JPD':
            return {
                contextLong: intl.formatMessage((0, $7wYyA.messages).rovo_prompt_context_jira_work_item)
            };
    }
};
const $87b6c3de92ffcb40$export$35d7b8e732470f9f = ({ promptKey: promptKey, intl: intl, url: url = '', product: product, iconSize: iconSize, cardAppearance: cardAppearance, provider: provider })=>{
    const { contextLong: contextLong } = $87b6c3de92ffcb40$var$getContext(intl, product) ?? {
        contextLong: intl.formatMessage((0, $7wYyA.messages).rovo_prompt_context_generic)
    };
    switch(promptKey){
        case "summarize-link":
            const label_summarize = intl.formatMessage((0, $7wYyA.messages).ai_summarize);
            const html_summarize = intl.formatMessage((0, $7wYyA.messages).rovo_prompt_message_summarize, {
                url: url
            }, {
                ignoreTag: true
            });
            return {
                icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($6sLTn))), {
                    label: label_summarize,
                    size: iconSize
                }),
                content: label_summarize,
                tooltipMessage: label_summarize,
                data: {
                    name: label_summarize,
                    dialogues: [],
                    prompt: (0, $djpCR.default)(html_summarize),
                    mode: {
                        fastModeEnabled: true
                    }
                }
            };
        case "summarize-this-for-me":
            const label_summarize_this_for_me = intl.formatMessage((0, $7wYyA.messages).rovo_prompt_button_summarize_this);
            const html_summarize_this_for_me = intl.formatMessage((0, $7wYyA.messages).rovo_prompt_message_summarize, {
                url: url
            }, {
                ignoreTag: true
            });
            return {
                icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($9H9S7))), {
                    label: label_summarize_this_for_me
                }),
                content: label_summarize_this_for_me,
                tooltipMessage: label_summarize_this_for_me,
                data: {
                    name: label_summarize_this_for_me,
                    dialogues: [],
                    prompt: (0, $djpCR.default)(html_summarize_this_for_me),
                    mode: {
                        fastModeEnabled: true
                    }
                }
            };
        case "highlight-relevant-content":
            const label_highlight_relevant_content = intl.formatMessage((0, $7wYyA.messages).rovo_prompt_button_highlight_relevant_content);
            const html_highlight_relevant_content = intl.formatMessage((0, $7wYyA.messages).rovo_prompt_message_highlight_relevant_content, {
                context: contextLong,
                url: url
            }, {
                ignoreTag: true
            });
            return {
                icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $4phF2.default), null),
                content: label_highlight_relevant_content,
                tooltipMessage: label_highlight_relevant_content,
                data: {
                    name: label_highlight_relevant_content,
                    dialogues: [],
                    prompt: (0, $djpCR.default)(html_highlight_relevant_content),
                    mode: {
                        fastModeEnabled: true
                    }
                }
            };
        case "ask-rovo-anything":
            const label_ask_rovo_anything = intl.formatMessage((0, $7wYyA.messages).rovo_prompt_button_ask_rovo_anything);
            const prompt_ask_rovo_anything = intl.formatMessage((0, $7wYyA.messages).rovo_prompt_message_ask_rovo_anything, {
                url: url
            });
            return {
                icon: cardAppearance === (0, $5kJPq.CardDisplay).Block && !!product && product === 'CONFLUENCE' ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $fAjRj.RovoIcon), {
                    label: label_ask_rovo_anything,
                    size: 'xxsmall'
                }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $ey534.default), null),
                content: label_ask_rovo_anything,
                tooltipMessage: label_ask_rovo_anything,
                data: {
                    name: label_ask_rovo_anything,
                    dialogues: [],
                    prompt: prompt_ask_rovo_anything,
                    isPromptPlaceholder: true,
                    placeholderType: 'generic'
                }
            };
        case "ask-a-specific-question":
            const label_ask_a_specific_question = intl.formatMessage((0, $7wYyA.messages).rovo_prompt_button_ask_a_specific_question);
            const prompt_ask_a_specific_question = intl.formatMessage((0, $7wYyA.messages).rovo_prompt_message_ask_rovo_anything, {
                url: url
            });
            return {
                icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($3Vt8T))), {
                    label: label_ask_a_specific_question
                }),
                content: label_ask_a_specific_question,
                tooltipMessage: label_ask_a_specific_question,
                data: {
                    name: label_ask_a_specific_question,
                    dialogues: [],
                    prompt: prompt_ask_a_specific_question,
                    isPromptPlaceholder: true,
                    placeholderType: 'generic'
                }
            };
        case "key-highlights":
            const label_key_highlights = intl.formatMessage((0, $7wYyA.messages).rovo_prompt_button_key_highlights);
            const html_key_highlights = intl.formatMessage((0, $7wYyA.messages).rovo_prompt_message_key_highlights, {
                context: contextLong,
                url: url
            }, {
                ignoreTag: true
            });
            return {
                icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($6sLTn))), {
                    label: label_key_highlights,
                    size: iconSize
                }),
                content: label_key_highlights,
                tooltipMessage: label_key_highlights,
                data: {
                    name: label_key_highlights,
                    dialogues: [],
                    prompt: (0, $djpCR.default)(html_key_highlights)
                }
            };
        case "show-me-whats-relevant":
            const label_show_me_whats_relevant = intl.formatMessage((0, $7wYyA.messages).rovo_prompt_button_show_me_whats_relevant);
            const html_show_me_whats_relevant = intl.formatMessage((0, $7wYyA.messages).rovo_prompt_message_highlight_relevant_content, {
                context: contextLong,
                url: url
            }, {
                ignoreTag: true
            });
            return {
                icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($jIn8I))), {
                    label: label_show_me_whats_relevant
                }),
                content: label_show_me_whats_relevant,
                tooltipMessage: label_show_me_whats_relevant,
                data: {
                    name: label_show_me_whats_relevant,
                    dialogues: [],
                    prompt: (0, $djpCR.default)(html_show_me_whats_relevant)
                }
            };
        case "identify-key-trends":
            const label_identify_key_trends = intl.formatMessage((0, $7wYyA.messages).rovo_prompt_button_identify_key_trends);
            const html_identify_key_trends = intl.formatMessage((0, $7wYyA.messages).rovo_prompt_message_identify_key_trends, {
                url: url
            }, {
                ignoreTag: true
            });
            return {
                icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($6sLTn))), {
                    label: label_identify_key_trends,
                    size: iconSize
                }),
                content: label_identify_key_trends,
                tooltipMessage: label_identify_key_trends,
                data: {
                    name: label_identify_key_trends,
                    dialogues: [],
                    prompt: (0, $djpCR.default)(html_identify_key_trends)
                }
            };
        case "identify-key-points":
            const label_identify_key_points = intl.formatMessage((0, $7wYyA.messages).rovo_prompt_button_identify_key_points);
            const html_identify_key_points = intl.formatMessage((0, $7wYyA.messages).rovo_prompt_message_identify_key_points, {
                url: url
            }, {
                ignoreTag: true
            });
            return {
                icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($6sLTn))), {
                    label: label_identify_key_points,
                    size: iconSize
                }),
                content: label_identify_key_points,
                tooltipMessage: label_identify_key_points,
                data: {
                    name: label_identify_key_points,
                    dialogues: [],
                    prompt: (0, $djpCR.default)(html_identify_key_points)
                }
            };
        case "find-open-questions":
            const label_find_open_questions = intl.formatMessage((0, $7wYyA.messages).rovo_prompt_button_find_open_questions);
            const html_find_open_questions = intl.formatMessage((0, $7wYyA.messages).rovo_prompt_message_find_open_questions, {
                url: url
            }, {
                ignoreTag: true
            });
            return {
                icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($6sLTn))), {
                    label: label_find_open_questions,
                    size: iconSize
                }),
                content: label_find_open_questions,
                tooltipMessage: label_find_open_questions,
                data: {
                    name: label_find_open_questions,
                    dialogues: [],
                    prompt: (0, $djpCR.default)(html_find_open_questions)
                }
            };
        case "summarize-document":
            const label_summarize_document = intl.formatMessage((0, $7wYyA.messages).ai_summarize);
            const html_summarize_document = intl.formatMessage((0, $7wYyA.messages).rovo_prompt_message_summarize_document, {
                url: url
            }, {
                ignoreTag: true
            });
            return {
                content: label_summarize_document,
                tooltipMessage: label_summarize_document,
                data: {
                    name: label_summarize_document,
                    dialogues: [],
                    prompt: (0, $djpCR.default)(html_summarize_document)
                },
                icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($9H9S7))), {
                    label: label_summarize_document,
                    size: iconSize
                })
            };
        case "summarize-presentation":
            const label_summarize_presentation = intl.formatMessage((0, $7wYyA.messages).ai_summarize);
            const html_summarize_presentation = intl.formatMessage((0, $7wYyA.messages).rovo_prompt_message_summarize_presentation, {
                url: url
            }, {
                ignoreTag: true
            });
            return {
                content: label_summarize_presentation,
                tooltipMessage: label_summarize_presentation,
                data: {
                    name: label_summarize_presentation,
                    dialogues: [],
                    prompt: (0, $djpCR.default)(html_summarize_presentation)
                },
                icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($9H9S7))), {
                    label: label_summarize_presentation,
                    size: iconSize
                })
            };
        case "explain-code":
            const label_explain_code = intl.formatMessage((0, $7wYyA.messages).rovo_prompt_button_explain_code);
            const html_explain_code = intl.formatMessage((0, $7wYyA.messages).rovo_prompt_message_explain_code, {
                url: url
            }, {
                ignoreTag: true
            });
            return {
                content: label_explain_code,
                tooltipMessage: label_explain_code,
                data: {
                    name: label_explain_code,
                    dialogues: [],
                    prompt: (0, $djpCR.default)(html_explain_code)
                },
                icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($9H9S7))), {
                    label: label_explain_code,
                    size: iconSize
                })
            };
        case "catch-up":
            const label_catch_up = intl.formatMessage((0, $7wYyA.messages).rovo_prompt_button_catch_up);
            const html_catch_up = intl.formatMessage((0, $7wYyA.messages).rovo_prompt_message_catch_up, {
                url: url,
                provider: provider
            }, {
                ignoreTag: true
            });
            return {
                content: label_catch_up,
                tooltipMessage: label_catch_up,
                data: {
                    name: label_catch_up,
                    dialogues: [],
                    prompt: (0, $djpCR.default)(html_catch_up)
                },
                icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($9H9S7))), {
                    label: label_catch_up,
                    size: iconSize
                })
            };
        case "salesforce-prep":
            const label_overview = intl.formatMessage((0, $7wYyA.messages).rovo_prompt_button_salesforce_prep);
            const html_overview = intl.formatMessage((0, $7wYyA.messages).rovo_prompt_message_salesforce_prep, {
                url: url
            }, {
                ignoreTag: true
            });
            return {
                content: label_overview,
                tooltipMessage: label_overview,
                data: {
                    name: label_overview,
                    dialogues: [],
                    prompt: (0, $djpCR.default)(html_overview)
                },
                icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($9H9S7))), {
                    label: label_overview,
                    size: iconSize
                })
            };
    }
};

});
parcelRegister("jIn8I", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::28569a1ba0e49d9b1ede9e97db5921f7>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $e5a41365e2f4aa4b$var$_react = $e5a41365e2f4aa4b$var$_interopRequireDefault((parcelRequire("bSJIT")));

var $e5a41365e2f4aa4b$var$_iconNew = $e5a41365e2f4aa4b$var$_interopRequireDefault((parcelRequire("gHJ0W")));
function $e5a41365e2f4aa4b$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "AiSearch".
 * Category: single-purpose
 * Location: @atlaskit/icon-lab/core/ai-search
 * Usage guidance:
 * Reserved for search interactions powered by Rovo/AI.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $e5a41365e2f4aa4b$var$AiSearchIcon = (props)=>/*#__PURE__*/ $e5a41365e2f4aa4b$var$_react.default.createElement($e5a41365e2f4aa4b$var$_iconNew.default, Object.assign({
        name: "AiSearchIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" d="M6 2.612A4.501 4.501 0 0 0 7 11.5a4.48 4.48 0 0 0 3.182-1.318A4.5 4.5 0 0 0 11.387 8h1.53a6 6 0 0 1-1.179 2.678l3.292 3.292-1.06 1.06-3.292-3.292A6 6 0 1 1 6 1.084z"/><path fill="currentcolor" d="M14 3.25a.75.75 0 0 1-.493.705l-1.285.469a.5.5 0 0 0-.298.298l-.469 1.285a.75.75 0 0 1-1.41 0l-.469-1.285a.5.5 0 0 0-.298-.298l-1.285-.469a.75.75 0 0 1-.484-.589L7.5 3.25l.009-.116a.75.75 0 0 1 .484-.59l1.285-.468a.5.5 0 0 0 .298-.298l.469-1.285.049-.106A.75.75 0 0 1 10.749 0l.116.009a.75.75 0 0 1 .541.378l.05.106.468 1.285a.5.5 0 0 0 .298.298l1.285.469A.75.75 0 0 1 14 3.25"/>`
    }, props));
$e5a41365e2f4aa4b$var$AiSearchIcon.displayName = 'AiSearchIcon';
var $e5a41365e2f4aa4b$var$_default = module.exports.default = $e5a41365e2f4aa4b$var$AiSearchIcon;

});

parcelRegister("4phF2", function(module, exports) {
$parcel$export(module.exports, "default", () => $47d9d453dfbcb8e7$export$2e2bcd8739ae039);
/* ai-chapter-icon.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $bSJIT = parcelRequire("bSJIT");

var $9fU1q = parcelRequire("9fU1q");
const $47d9d453dfbcb8e7$var$style = {
    foreignObject: "_11q7hndj _4t3i1osq _1bsb1osq _tzy4kb7n"
};
const $47d9d453dfbcb8e7$var$AiChapterIcon = (props)=>/*#__PURE__*/ $bSJIT.createElement("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props
    }, /*#__PURE__*/ $bSJIT.createElement("g", {
        clipPath: "url(#paint0_angular_1804_15128_clip_path)",
        "data-figma-skip-parse": "true"
    }, /*#__PURE__*/ $bSJIT.createElement("g", {
        transform: "matrix(0.008 -0.00939228 0.0100184 0.0075 12 12.5)"
    }, /*#__PURE__*/ $bSJIT.createElement("foreignObject", {
        x: "-1047.5",
        y: "-1047.5",
        width: "2095.01",
        height: "2095.01"
    }, /*#__PURE__*/ $bSJIT.createElement("div", {
        className: (0, $9fU1q.default)([
            $47d9d453dfbcb8e7$var$style.foreignObject
        ])
    })))), /*#__PURE__*/ $bSJIT.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M5.5 6.5V16.5H11.2495V18H5.375C4.61561 18 4 17.3844 4 16.625V6.375C4 5.6175 4.61251 5 5.37379 5L8.8749 5.00001C10.1576 5.00001 11.2947 5.6232 11.9999 6.58333C12.7053 5.62319 13.8425 5.00001 15.1251 5.00001L18.6253 5C19.3874 5 20 5.61967 20 6.37637V12.25H18.5V6.50082L15.1251 6.50001C13.8134 6.50001 12.7499 7.56337 12.7499 8.87496V14H11.2499V8.87498C11.2499 7.56332 10.1866 6.50001 8.8749 6.50001L5.5 6.5ZM17.2495 10H14.4995V8.5H17.2495V10ZM6.75049 8.50001H9.50049V10H6.75049V8.50001ZM6.75049 11H9.50049V12.5H6.75049V11ZM15.7945 13.4943C15.9025 13.1982 16.184 13.0013 16.4991 13.0013C16.8142 13.0013 17.0962 13.1982 17.2042 13.4943L17.8193 15.1807L19.5057 15.7958C19.8017 15.9038 19.9987 16.1853 19.9987 16.5004C19.9987 16.8155 19.8017 17.0975 19.5057 17.2055L17.8193 17.8206L17.2042 19.507C17.0962 19.803 16.8147 20 16.4996 20C16.1845 20 15.9025 19.803 15.7945 19.507L15.1794 17.8206L13.493 17.2055C13.197 17.0975 13 16.816 13 16.5009C13 16.1858 13.197 15.9038 13.493 15.7958L15.1794 15.1807L15.7945 13.4943Z",
        "data-figma-gradient-fill": '{"type":"GRADIENT_ANGULAR","stops":[{"color":{"r":0.98823529481887817,"g":0.65490198135375977,"b":0.0,"a":1.0},"position":0.0},{"color":{"r":0.98823529481887817,"g":0.65490198135375977,"b":0.0,"a":1.0},"position":0.20192027091979980},{"color":{"r":0.41662007570266724,"g":0.60310000181198120,"b":0.13690000772476196,"a":1.0},"position":0.20202027261257172},{"color":{"r":0.41662007570266724,"g":0.60310000181198120,"b":0.13690000772476196,"a":1.0},"position":0.46637400984764099},{"color":{"r":0.094117648899555206,"g":0.40784314274787903,"b":0.85882353782653809,"a":1.0},"position":0.46647399663925171},{"color":{"r":0.094117648899555206,"g":0.40784314274787903,"b":0.85882353782653809,"a":1.0},"position":0.70185315608978271},{"color":{"r":0.68627452850341797,"g":0.34901961684226990,"b":0.87843137979507446,"a":1.0},"position":0.70195317268371582},{"color":{"r":0.68627452850341797,"g":0.34901961684226990,"b":0.87843137979507446,"a":1.0},"position":1.0}],"stopsVar":[{"color":{"r":0.98823529481887817,"g":0.65490198135375977,"b":0.0,"a":1.0},"position":0.0},{"color":{"r":0.98823529481887817,"g":0.65490198135375977,"b":0.0,"a":1.0},"position":0.20192027091979980},{"color":{"r":0.41662007570266724,"g":0.60310000181198120,"b":0.13690000772476196,"a":1.0},"position":0.20202027261257172},{"color":{"r":0.41662007570266724,"g":0.60310000181198120,"b":0.13690000772476196,"a":1.0},"position":0.46637400984764099},{"color":{"r":0.094117648899555206,"g":0.40784314274787903,"b":0.85882353782653809,"a":1.0},"position":0.46647399663925171},{"color":{"r":0.094117648899555206,"g":0.40784314274787903,"b":0.85882353782653809,"a":1.0},"position":0.70185315608978271},{"color":{"r":0.68627452850341797,"g":0.34901961684226990,"b":0.87843137979507446,"a":1.0},"position":0.70195317268371582},{"color":{"r":0.68627452850341797,"g":0.34901961684226990,"b":0.87843137979507446,"a":1.0},"position":1.0}],"transform":{"m00":16.000001907348633,"m01":20.036861419677734,"m02":-6.0184345245361328,"m10":-18.784559249877930,"m11":15.000002861022949,"m12":14.392276763916016},"opacity":1.0,"blendMode":"NORMAL","visible":true}'
    }), /*#__PURE__*/ $bSJIT.createElement("defs", null, /*#__PURE__*/ $bSJIT.createElement("clipPath", {
        id: "paint0_angular_1804_15128_clip_path"
    }, /*#__PURE__*/ $bSJIT.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M5.5 6.5V16.5H11.2495V18H5.375C4.61561 18 4 17.3844 4 16.625V6.375C4 5.6175 4.61251 5 5.37379 5L8.8749 5.00001C10.1576 5.00001 11.2947 5.6232 11.9999 6.58333C12.7053 5.62319 13.8425 5.00001 15.1251 5.00001L18.6253 5C19.3874 5 20 5.61967 20 6.37637V12.25H18.5V6.50082L15.1251 6.50001C13.8134 6.50001 12.7499 7.56337 12.7499 8.87496V14H11.2499V8.87498C11.2499 7.56332 10.1866 6.50001 8.8749 6.50001L5.5 6.5ZM17.2495 10H14.4995V8.5H17.2495V10ZM6.75049 8.50001H9.50049V10H6.75049V8.50001ZM6.75049 11H9.50049V12.5H6.75049V11ZM15.7945 13.4943C15.9025 13.1982 16.184 13.0013 16.4991 13.0013C16.8142 13.0013 17.0962 13.1982 17.2042 13.4943L17.8193 15.1807L19.5057 15.7958C19.8017 15.9038 19.9987 16.1853 19.9987 16.5004C19.9987 16.8155 19.8017 17.0975 19.5057 17.2055L17.8193 17.8206L17.2042 19.507C17.0962 19.803 16.8147 20 16.4996 20C16.1845 20 15.9025 19.803 15.7945 19.507L15.1794 17.8206L13.493 17.2055C13.197 17.0975 13 16.816 13 16.5009C13 16.1858 13.197 15.9038 13.493 15.7958L15.1794 15.1807L15.7945 13.4943Z"
    }))));
$47d9d453dfbcb8e7$var$AiChapterIcon.displayName = 'AiChapterIcon';
var $47d9d453dfbcb8e7$export$2e2bcd8739ae039 = $47d9d453dfbcb8e7$var$AiChapterIcon;

});

parcelRegister("ey534", function(module, exports) {
$parcel$export(module.exports, "default", () => $1a7bc41afc7cec97$export$2e2bcd8739ae039);
/* ai-search-icon.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $bSJIT = parcelRequire("bSJIT");

var $9fU1q = parcelRequire("9fU1q");
const $1a7bc41afc7cec97$var$style = {
    foreignObject: "_11q7hndj _4t3i1osq _1bsb1osq _tzy4kb7n"
};
const $1a7bc41afc7cec97$var$AiSearchIcon = (props)=>/*#__PURE__*/ $bSJIT.createElement("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props
    }, /*#__PURE__*/ $bSJIT.createElement("g", {
        clipPath: "url(#paint0_angular_1804_8080_clip_path)",
        "data-figma-skip-parse": "true"
    }, /*#__PURE__*/ $bSJIT.createElement("g", {
        transform: "matrix(0.00701514 -0.00941124 0.00878508 0.00751514 12.0151 11.5151)"
    }, /*#__PURE__*/ $bSJIT.createElement("foreignObject", {
        x: "-1058.95",
        y: "-1058.95",
        width: "2117.91",
        height: "2117.91"
    }, /*#__PURE__*/ $bSJIT.createElement("div", {
        className: (0, $9fU1q.default)([
            $1a7bc41afc7cec97$var$style.foreignObject
        ])
    })))), /*#__PURE__*/ $bSJIT.createElement("path", {
        d: "M10 6.6123C7.9961 7.0671 6.5 8.85847 6.5 11C6.5 13.4853 8.51472 15.5 11 15.5C12.2428 15.5 13.3665 14.9968 14.1816 14.1816C14.7712 13.5921 15.1959 12.8407 15.3867 12H16.917C16.7489 12.9977 16.3336 13.9117 15.7383 14.6777L19.0303 17.9697L17.9697 19.0303L14.6777 15.7383C13.662 16.5276 12.3862 17 11 17C7.68629 17 5 14.3137 5 11C5 8.02706 7.16237 5.56013 10 5.08398V6.6123Z",
        "data-figma-gradient-fill": '{"type":"GRADIENT_ANGULAR","stops":[{"color":{"r":0.98823529481887817,"g":0.65490198135375977,"b":0.0,"a":1.0},"position":0.0},{"color":{"r":0.98823529481887817,"g":0.65490198135375977,"b":0.0,"a":1.0},"position":0.20192027091979980},{"color":{"r":0.41662007570266724,"g":0.60310000181198120,"b":0.13690000772476196,"a":1.0},"position":0.20202027261257172},{"color":{"r":0.41662007570266724,"g":0.60310000181198120,"b":0.13690000772476196,"a":1.0},"position":0.46637400984764099},{"color":{"r":0.094117648899555206,"g":0.40784314274787903,"b":0.85882353782653809,"a":1.0},"position":0.46647399663925171},{"color":{"r":0.094117648899555206,"g":0.40784314274787903,"b":0.85882353782653809,"a":1.0},"position":0.70185315608978271},{"color":{"r":0.68627452850341797,"g":0.34901961684226990,"b":0.87843137979507446,"a":1.0},"position":0.70195317268371582},{"color":{"r":0.68627452850341797,"g":0.34901961684226990,"b":0.87843137979507446,"a":1.0},"position":1.0}],"stopsVar":[{"color":{"r":0.98823529481887817,"g":0.65490198135375977,"b":0.0,"a":1.0},"position":0.0},{"color":{"r":0.98823529481887817,"g":0.65490198135375977,"b":0.0,"a":1.0},"position":0.20192027091979980},{"color":{"r":0.41662007570266724,"g":0.60310000181198120,"b":0.13690000772476196,"a":1.0},"position":0.20202027261257172},{"color":{"r":0.41662007570266724,"g":0.60310000181198120,"b":0.13690000772476196,"a":1.0},"position":0.46637400984764099},{"color":{"r":0.094117648899555206,"g":0.40784314274787903,"b":0.85882353782653809,"a":1.0},"position":0.46647399663925171},{"color":{"r":0.094117648899555206,"g":0.40784314274787903,"b":0.85882353782653809,"a":1.0},"position":0.70185315608978271},{"color":{"r":0.68627452850341797,"g":0.34901961684226990,"b":0.87843137979507446,"a":1.0},"position":0.70195317268371582},{"color":{"r":0.68627452850341797,"g":0.34901961684226990,"b":0.87843137979507446,"a":1.0},"position":1.0}],"transform":{"m00":14.030276298522949,"m01":17.570167541503906,"m02":-3.7850868701934814,"m10":-18.822471618652344,"m11":15.030277252197266,"m12":13.411232948303223},"opacity":1.0,"blendMode":"NORMAL","visible":true}'
    }), /*#__PURE__*/ $bSJIT.createElement("g", {
        clipPath: "url(#paint1_angular_1804_8080_clip_path)",
        "data-figma-skip-parse": "true"
    }, /*#__PURE__*/ $bSJIT.createElement("g", {
        transform: "matrix(0.00701514 -0.00941124 0.00878508 0.00751514 12.0151 11.5151)"
    }, /*#__PURE__*/ $bSJIT.createElement("foreignObject", {
        x: "-1058.95",
        y: "-1058.95",
        width: "2117.91",
        height: "2117.91"
    }, /*#__PURE__*/ $bSJIT.createElement("div", {
        className: (0, $9fU1q.default)([
            $1a7bc41afc7cec97$var$style.foreignObject
        ])
    })))), /*#__PURE__*/ $bSJIT.createElement("path", {
        d: "M18 7.25C18 7.56523 17.803 7.84705 17.5068 7.95508L16.2217 8.42383C16.0833 8.4744 15.9744 8.58332 15.9238 8.72168L15.4551 10.0068C15.3471 10.3029 15.0653 10.5 14.75 10.5C14.4348 10.5 14.1529 10.303 14.0449 10.0068L13.5762 8.72168C13.5256 8.58332 13.4167 8.4744 13.2783 8.42383L11.9932 7.95508C11.7338 7.86049 11.5505 7.63274 11.5088 7.36621L11.5 7.25L11.5088 7.13379C11.5505 6.86715 11.734 6.63947 11.9932 6.54492L13.2783 6.07617C13.4167 6.0256 13.5256 5.91668 13.5762 5.77832L14.0449 4.49316L14.0938 4.38672C14.2242 4.15114 14.4736 4.00036 14.749 4L14.8652 4.00879C15.0941 4.04428 15.2941 4.18415 15.4062 4.38672L15.4551 4.49316L15.9238 5.77832C15.9744 5.91668 16.0833 6.0256 16.2217 6.07617L17.5068 6.54492C17.8031 6.65301 18 6.93494 18 7.25Z",
        "data-figma-gradient-fill": '{"type":"GRADIENT_ANGULAR","stops":[{"color":{"r":0.98823529481887817,"g":0.65490198135375977,"b":0.0,"a":1.0},"position":0.0},{"color":{"r":0.98823529481887817,"g":0.65490198135375977,"b":0.0,"a":1.0},"position":0.20192027091979980},{"color":{"r":0.41662007570266724,"g":0.60310000181198120,"b":0.13690000772476196,"a":1.0},"position":0.20202027261257172},{"color":{"r":0.41662007570266724,"g":0.60310000181198120,"b":0.13690000772476196,"a":1.0},"position":0.46637400984764099},{"color":{"r":0.094117648899555206,"g":0.40784314274787903,"b":0.85882353782653809,"a":1.0},"position":0.46647399663925171},{"color":{"r":0.094117648899555206,"g":0.40784314274787903,"b":0.85882353782653809,"a":1.0},"position":0.70185315608978271},{"color":{"r":0.68627452850341797,"g":0.34901961684226990,"b":0.87843137979507446,"a":1.0},"position":0.70195317268371582},{"color":{"r":0.68627452850341797,"g":0.34901961684226990,"b":0.87843137979507446,"a":1.0},"position":1.0}],"stopsVar":[{"color":{"r":0.98823529481887817,"g":0.65490198135375977,"b":0.0,"a":1.0},"position":0.0},{"color":{"r":0.98823529481887817,"g":0.65490198135375977,"b":0.0,"a":1.0},"position":0.20192027091979980},{"color":{"r":0.41662007570266724,"g":0.60310000181198120,"b":0.13690000772476196,"a":1.0},"position":0.20202027261257172},{"color":{"r":0.41662007570266724,"g":0.60310000181198120,"b":0.13690000772476196,"a":1.0},"position":0.46637400984764099},{"color":{"r":0.094117648899555206,"g":0.40784314274787903,"b":0.85882353782653809,"a":1.0},"position":0.46647399663925171},{"color":{"r":0.094117648899555206,"g":0.40784314274787903,"b":0.85882353782653809,"a":1.0},"position":0.70185315608978271},{"color":{"r":0.68627452850341797,"g":0.34901961684226990,"b":0.87843137979507446,"a":1.0},"position":0.70195317268371582},{"color":{"r":0.68627452850341797,"g":0.34901961684226990,"b":0.87843137979507446,"a":1.0},"position":1.0}],"transform":{"m00":14.030276298522949,"m01":17.570167541503906,"m02":-3.7850868701934814,"m10":-18.822471618652344,"m11":15.030277252197266,"m12":13.411232948303223},"opacity":1.0,"blendMode":"NORMAL","visible":true}'
    }), /*#__PURE__*/ $bSJIT.createElement("defs", null, /*#__PURE__*/ $bSJIT.createElement("clipPath", {
        id: "paint0_angular_1804_8080_clip_path"
    }, /*#__PURE__*/ $bSJIT.createElement("path", {
        d: "M10 6.6123C7.9961 7.0671 6.5 8.85847 6.5 11C6.5 13.4853 8.51472 15.5 11 15.5C12.2428 15.5 13.3665 14.9968 14.1816 14.1816C14.7712 13.5921 15.1959 12.8407 15.3867 12H16.917C16.7489 12.9977 16.3336 13.9117 15.7383 14.6777L19.0303 17.9697L17.9697 19.0303L14.6777 15.7383C13.662 16.5276 12.3862 17 11 17C7.68629 17 5 14.3137 5 11C5 8.02706 7.16237 5.56013 10 5.08398V6.6123Z"
    })), /*#__PURE__*/ $bSJIT.createElement("clipPath", {
        id: "paint1_angular_1804_8080_clip_path"
    }, /*#__PURE__*/ $bSJIT.createElement("path", {
        d: "M18 7.25C18 7.56523 17.803 7.84705 17.5068 7.95508L16.2217 8.42383C16.0833 8.4744 15.9744 8.58332 15.9238 8.72168L15.4551 10.0068C15.3471 10.3029 15.0653 10.5 14.75 10.5C14.4348 10.5 14.1529 10.303 14.0449 10.0068L13.5762 8.72168C13.5256 8.58332 13.4167 8.4744 13.2783 8.42383L11.9932 7.95508C11.7338 7.86049 11.5505 7.63274 11.5088 7.36621L11.5 7.25L11.5088 7.13379C11.5505 6.86715 11.734 6.63947 11.9932 6.54492L13.2783 6.07617C13.4167 6.0256 13.5256 5.91668 13.5762 5.77832L14.0449 4.49316L14.0938 4.38672C14.2242 4.15114 14.4736 4.00036 14.749 4L14.8652 4.00879C15.0941 4.04428 15.2941 4.18415 15.4062 4.38672L15.4551 4.49316L15.9238 5.77832C15.9744 5.91668 16.0833 6.0256 16.2217 6.07617L17.5068 6.54492C17.8031 6.65301 18 6.93494 18 7.25Z"
    }))));
$1a7bc41afc7cec97$var$AiSearchIcon.displayName = 'AiSearchIcon';
var $1a7bc41afc7cec97$export$2e2bcd8739ae039 = $1a7bc41afc7cec97$var$AiSearchIcon;

});

parcelRegister("djpCR", function(module, exports) {
$parcel$export(module.exports, "default", () => $ef03a858b8f241df$export$2e2bcd8739ae039);
/**
 * This is a simplified version of html to adf conversion,
 * used specifically for SL RovoChatAction prompt message,
 * and does not support all ADF offered via @atlaskit/adf-utils
 *
 * Support: p, ul, li, text, b, strong, code, inlineCard (replace a hyperlink)
 */ 
var $1KFRC = parcelRequire("1KFRC");

var $eGCvp = parcelRequire("eGCvp");

var $bhIIN = parcelRequire("bhIIN");

var $38V7l = parcelRequire("38V7l");

var $lIQsf = parcelRequire("lIQsf");

var $aKjrj = parcelRequire("aKjrj");

var $9iy6H = parcelRequire("9iy6H");

var $daHgL = parcelRequire("daHgL");
const $ef03a858b8f241df$var$INLINE_TAG_NAMES = [
    'b',
    'strong',
    'code',
    'a',
    'inlineCard'
];
const $ef03a858b8f241df$var$BLOCK_TAG_NAMES = [
    'p',
    'ul',
    'ol',
    'li'
];
/**
 *   Group      Captures                Example
 *  ━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━
 *   match[1]   Self-closing tag name   br from <br/> or <img src="x"/>
 *   match[2]   Opening tag name        div from <div> or <div class="x">
 *   match[3]   Closing tag name        div from </div>
 *   match[4]   Text content            Hello world
 */ const $ef03a858b8f241df$var$htmlRegex = /<\s*(\w+)[^>]*?\s*\/\s*>|<\s*(\w+)[^>]*>|<\s*\/\s*(\w+)\s*>|([^<]+)/g;
const $ef03a858b8f241df$var$decodeHtmlEntities = (text = '')=>{
    return text.replace(/&nbsp;/g, ' ').replace(/&lt;/g, '<').replace(/&gt;/g, '>').replace(/&amp;/g, '&').replace(/&quot;/g, '"').replace(/&#39;/g, "'");
};
const $ef03a858b8f241df$var$tokenizeHtml = (html)=>{
    const tokens = [];
    let match;
    while((match = $ef03a858b8f241df$var$htmlRegex.exec(html)) !== null){
        const selfClosingTag = match[1];
        const openingTag = match[2];
        const closingTag = match[3];
        const textContent = match[4];
        if (selfClosingTag) tokens.push({
            type: 'selfClosing',
            tagName: selfClosingTag.toLowerCase()
        });
        else if (openingTag) tokens.push({
            type: 'open',
            tagName: openingTag.toLowerCase()
        });
        else if (closingTag) tokens.push({
            type: 'close',
            tagName: closingTag.toLowerCase()
        });
        else if (textContent) {
            if (textContent !== null && textContent !== void 0 && textContent.trim()) tokens.push({
                type: 'text',
                content: $ef03a858b8f241df$var$decodeHtmlEntities(textContent)
            });
        }
    }
    return tokens;
};
const $ef03a858b8f241df$var$buildListItem = (content = [])=>{
    // Check if content has only text/inline elements
    const hasOnlyInlineContent = content.every((node)=>node.type === 'text' || node.type === 'hardBreak' || !node.type);
    if (hasOnlyInlineContent) // Wrap text content in a paragraph
    return (0, $lIQsf.listItem)([
        (0, $aKjrj.paragraph)(...content)
    ]);
    // Content has block elements (like nested lists), use as-is
    return (0, $lIQsf.listItem)(content);
};
const $ef03a858b8f241df$var$blockToAdf = (tagName, content = [])=>{
    switch(tagName){
        case 'p':
            return (0, $aKjrj.paragraph)(...content);
        case 'ul':
            return (0, $1KFRC.bulletList)(...content);
        case 'li':
            return $ef03a858b8f241df$var$buildListItem(content);
    }
};
const $ef03a858b8f241df$var$inlineToAdf = (tagName, content)=>{
    switch(tagName){
        case 'b':
        case 'strong':
            return (0, $9iy6H.strong)(content);
        case 'code':
            return (0, $eGCvp.code)(content);
        case 'a':
        case 'inlineCard':
            return (0, $38V7l.inlineCard)({
                url: content
            });
        default:
            return (0, $daHgL.text)(content);
    }
};
const $ef03a858b8f241df$var$parseTokensToAdf = (tokens)=>{
    const stack = [
        {
            type: 'root',
            content: []
        }
    ];
    let currentMarks = [];
    for(let i = 0; i < tokens.length; i++){
        const token = tokens[i];
        const current = stack[stack.length - 1];
        switch(token.type){
            case 'text':
                if (token.content) {
                    var _currentMarks;
                    const inlineAdfNode = $ef03a858b8f241df$var$inlineToAdf((_currentMarks = currentMarks) === null || _currentMarks === void 0 || (_currentMarks = _currentMarks[0]) === null || _currentMarks === void 0 ? void 0 : _currentMarks.type, token.content);
                    current.content.push(inlineAdfNode);
                }
                break;
            case 'open':
                if ($ef03a858b8f241df$var$INLINE_TAG_NAMES.includes(token.tagName)) currentMarks.push({
                    type: token.tagName
                });
                else if ($ef03a858b8f241df$var$BLOCK_TAG_NAMES.includes(token.tagName)) stack.push({
                    type: token.tagName,
                    content: []
                });
                break;
            case 'close':
                // Inline formatting
                if (token.tagName && $ef03a858b8f241df$var$INLINE_TAG_NAMES.includes(token.tagName)) currentMarks = currentMarks.filter((m)=>m.type !== token.tagName);
                else if (stack.length > 1) {
                    const closed = stack.pop();
                    const parent = stack[stack.length - 1];
                    const adfNode = $ef03a858b8f241df$var$blockToAdf(closed === null || closed === void 0 ? void 0 : closed.type, closed === null || closed === void 0 ? void 0 : closed.content);
                    if (adfNode) parent.content.push(adfNode);
                }
                break;
        }
    }
    // Return root content
    return stack[0].content;
};
/**
 * Convert HTML string to ADF format
 *
 * This is a simplified version specific for RovoChatAction prompt message
 * and does not support all ADF offered via @atlaskit/adf-utils
 */ const $ef03a858b8f241df$var$htmlToAdf = (html)=>{
    try {
        const tokens = $ef03a858b8f241df$var$tokenizeHtml(html);
        const adfContent = $ef03a858b8f241df$var$parseTokensToAdf(tokens);
        return (0, $bhIIN.doc)(...adfContent);
    } catch  {
        return html;
    }
};
var $ef03a858b8f241df$export$2e2bcd8739ae039 = $ef03a858b8f241df$var$htmlToAdf;

});
parcelRegister("1KFRC", function(module, exports) {
$parcel$export(module.exports, "bulletList", () => $5f3ed0bc41a34b3b$export$a140c94e5ea26bee);
const $5f3ed0bc41a34b3b$export$a140c94e5ea26bee = (...content)=>({
        type: 'bulletList',
        content: content
    });

});

parcelRegister("eGCvp", function(module, exports) {
$parcel$export(module.exports, "code", () => $f4fb07e9a7deab4f$export$6565f9f03506010b);

var $amSb9 = parcelRequire("amSb9");
const $f4fb07e9a7deab4f$export$6565f9f03506010b = (maybeNode)=>(0, $amSb9.applyMark)({
        type: 'code'
    }, maybeNode);

});
parcelRegister("amSb9", function(module, exports) {
$parcel$export(module.exports, "applyMark", () => $00e914642f7f793d$export$50d34f59d07755a2);

var $daHgL = parcelRequire("daHgL");

var $hrELW = parcelRequire("hrELW");

var $9NtqN = parcelRequire("9NtqN");
function $00e914642f7f793d$export$50d34f59d07755a2(mark, maybeNode) {
    const node = typeof maybeNode === 'string' ? (0, $daHgL.text)(maybeNode) : maybeNode;
    if ((0, $9NtqN.isDuplicateMark)(node, mark.type)) {
        // eslint-disable-next-line no-console
        console.error((0, $hrELW.duplicateMarkError)(node, mark.type));
        return node;
    }
    node.marks = node.marks || [];
    node.marks.push(mark);
    return node;
}

});
parcelRegister("hrELW", function(module, exports) {
$parcel$export(module.exports, "duplicateMarkError", () => $682983114d86aa5f$export$db1000b9ac08ce57);
// Ignored via go/ees005
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function $682983114d86aa5f$export$db1000b9ac08ce57(node, type) {
    return `Mark with the same name '${type}' already exists on a node: ${JSON.stringify(node)}`;
}

});

parcelRegister("9NtqN", function(module, exports) {
$parcel$export(module.exports, "isDuplicateMark", () => $d57b29013133f059$export$5ec47a80d7cc0dfa);
// Ignored via go/ees005
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function $d57b29013133f059$export$5ec47a80d7cc0dfa(node, type) {
    if (node.marks && node.marks.some((mark)=>mark.type === type)) return true;
    return false;
}

});



parcelRegister("38V7l", function(module, exports) {
$parcel$export(module.exports, "inlineCard", () => $1a4e06b907e23c97$export$cbf8224b64e0d942);
const $1a4e06b907e23c97$export$cbf8224b64e0d942 = (attrs)=>({
        type: 'inlineCard',
        attrs: attrs
    });

});

parcelRegister("lIQsf", function(module, exports) {
$parcel$export(module.exports, "listItem", () => $b075d6d612ee8c91$export$76c7e83ecc9cdf05);
const $b075d6d612ee8c91$export$76c7e83ecc9cdf05 = (content)=>({
        type: 'listItem',
        content: content
    });

});

parcelRegister("9iy6H", function(module, exports) {
$parcel$export(module.exports, "strong", () => $3d9531e2fba18771$export$59ae2c325a998f89);

var $amSb9 = parcelRequire("amSb9");
const $3d9531e2fba18771$export$59ae2c325a998f89 = (maybeNode)=>(0, $amSb9.applyMark)({
        type: 'strong'
    }, maybeNode);

});



parcelRegister("jSDhC", function(module, exports) {
$parcel$export(module.exports, "filterActionItems", () => $0e9ada485084aece$export$adbd04236f07a7d8);

var $5kJPq = parcelRequire("5kJPq");
const $0e9ada485084aece$export$adbd04236f07a7d8 = (items = [], context, product)=>{
    return items.filter((item)=>{
        switch(item.name){
            case (0, $5kJPq.ActionName).DeleteAction:
            case (0, $5kJPq.ActionName).EditAction:
            case (0, $5kJPq.ActionName).CustomAction:
                // Named and custom actions that user defines.
                return Boolean((0, $5kJPq.ActionName)[item.name]);
            case (0, $5kJPq.ActionName).RovoChatAction:
                if (!!product && product === 'CONFLUENCE') return Boolean((0, $5kJPq.ActionName)[item.name]);
                // same as default case below
                if ((context === null || context === void 0 ? void 0 : context.actions) === undefined) return false;
                return Boolean(item.name in context.actions ? context.actions[item.name] : undefined);
            default:
                // Action that require data from the data context to render.
                if ((context === null || context === void 0 ? void 0 : context.actions) === undefined) return false;
                return Boolean(item.name in context.actions ? context.actions[item.name] : undefined);
        }
    });
};

});

parcelRegister("bOMDA", function(module, exports) {
$parcel$export(module.exports, "default", () => $56fb67545c63481d$export$2e2bcd8739ae039);

var $bSJIT = parcelRequire("bSJIT");

var $5kJPq = parcelRequire("5kJPq");

var $8bEg5 = parcelRequire("8bEg5");

var $6mQ6U = parcelRequire("6mQ6U");

var $kop7u = parcelRequire("kop7u");

var $asa4T = parcelRequire("asa4T");

var $14on2 = parcelRequire("14on2");

var $8bLs2 = parcelRequire("8bLs2");

var $6StZP = parcelRequire("6StZP");

var $8zn38 = parcelRequire("8zn38");

var $4iLYG = parcelRequire("4iLYG");

var $4uDT5 = parcelRequire("4uDT5");

var $kXAHP = parcelRequire("kXAHP");

var $j04u5 = parcelRequire("j04u5");
const $56fb67545c63481d$var$Actions = {
    [(0, $5kJPq.ActionName).AutomationAction]: (0, $kop7u.default),
    [(0, $5kJPq.ActionName).CopyLinkAction]: (0, $asa4T.default),
    [(0, $5kJPq.ActionName).CustomAction]: (0, $8bEg5.default),
    [(0, $5kJPq.ActionName).DeleteAction]: (0, $8bLs2.default),
    [(0, $5kJPq.ActionName).DownloadAction]: (0, $6StZP.default),
    [(0, $5kJPq.ActionName).EditAction]: (0, $8zn38.default),
    [(0, $5kJPq.ActionName).FollowAction]: (0, $4iLYG.default),
    [(0, $5kJPq.ActionName).PreviewAction]: (0, $4uDT5.default),
    [(0, $5kJPq.ActionName).RovoChatAction]: (0, $kXAHP.default),
    [(0, $5kJPq.InternalActionName).AISummaryAction]: (0, $6mQ6U.default),
    [(0, $5kJPq.InternalActionName).UnresolvedAction]: (0, $14on2.default),
    [(0, $5kJPq.InternalActionName).ViewRelatedLinksAction]: (0, $j04u5.default)
};
const $56fb67545c63481d$var$ActionGroupItem = ({ item: item, size: size, appearance: appearance, asDropDownItems: asDropDownItems, onActionItemClick: onActionItemClick })=>{
    const { name: name, hideContent: hideContent, hideIcon: hideIcon, onClick: onClick, isDisabled: isDisabled, ...props } = item;
    const handleOnClick = (0, $bSJIT.useCallback)(()=>{
        if (onActionItemClick) onActionItemClick();
        if (onClick) onClick();
    }, [
        onActionItemClick,
        onClick
    ]);
    const Action = name in $56fb67545c63481d$var$Actions ? $56fb67545c63481d$var$Actions[name] : undefined;
    if (!Action) return null;
    const actionProps = {
        ...props
    };
    if (hideContent && !asDropDownItems) actionProps.content = '';
    if (hideIcon) actionProps.icon = undefined;
    if (item !== null && item !== void 0 && item.entryPointWrapper) actionProps.wrapper = item.entryPointWrapper;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement(Action, {
        asDropDownItem: asDropDownItems,
        size: size,
        appearance: appearance,
        onClick: handleOnClick,
        isDisabled: isDisabled,
        ...actionProps
    });
};
var $56fb67545c63481d$export$2e2bcd8739ae039 = $56fb67545c63481d$var$ActionGroupItem;

});
parcelRegister("8bEg5", function(module, exports) {
$parcel$export(module.exports, "default", () => $06b45807ac21c6f2$export$2e2bcd8739ae039);

var $bSJIT = parcelRequire("bSJIT");

var $5kJPq = parcelRequire("5kJPq");

var $1NY7H = parcelRequire("1NY7H");

var $aEzVt = parcelRequire("aEzVt");

var $kmw7d = parcelRequire("kmw7d");

var $aIJT4 = parcelRequire("aIJT4");
/**
 * A base action that can be triggered with an on click.
 * @internal
 * @param {ActionProps} ActionProps - The props necessary for the Action.
 */ const $06b45807ac21c6f2$var$Action = ({ as: as, appearance: appearance = 'subtle', content: content, isLoading: isLoading = false, onClick: onClick, size: size = (0, $5kJPq.SmartLinkSize).Medium, testId: testId = 'smart-action', icon: icon, iconPosition: iconPosition = 'before', spaceInline: spaceInline, tooltipMessage: tooltipMessage, tooltipOnHide: tooltipOnHide, hideTooltip: hideTooltip, hideTooltipOnMouseDown: hideTooltipOnMouseDown, hasNewContentOnTriggerClick: hasNewContentOnTriggerClick, style: style, asDropDownItem: asDropDownItem, className: className, isDisabled: isDisabled, href: href, ariaLabel: ariaLabel, wrapper: Wrapper })=>{
    if (!onClick) return null;
    const isStackItem = as === 'stack-item';
    const isDropdownItem = as === 'dropdown-item' || asDropDownItem;
    const actionIcon = icon ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $kmw7d.default), {
        icon: icon,
        testId: testId
    }) : undefined;
    const iconBefore = icon && iconPosition === 'before' ? actionIcon : undefined;
    const iconAfter = icon && iconPosition === 'after' ? actionIcon : undefined;
    if (isStackItem) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $aIJT4.default), {
        content: content,
        icon: actionIcon,
        space: spaceInline,
        isDisabled: isDisabled,
        isLoading: isLoading,
        onClick: onClick,
        size: size,
        testId: testId,
        tooltipMessage: tooltipMessage || content,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
        style: style,
        tooltipOnHide: tooltipOnHide,
        hideTooltipOnMouseDown: hideTooltipOnMouseDown,
        hasNewContentOnTriggerClick: hasNewContentOnTriggerClick,
        hideTooltip: hideTooltip,
        ariaLabel: ariaLabel
    });
    if (isDropdownItem) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $aEzVt.default), {
        content: content,
        iconAfter: iconAfter,
        iconBefore: iconBefore,
        isLoading: isLoading,
        onClick: onClick,
        testId: testId
    });
    const button = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $1NY7H.default), {
        appearance: appearance,
        content: content,
        iconAfter: iconAfter,
        iconBefore: iconBefore,
        isLoading: isLoading,
        onClick: onClick,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
        className: className,
        size: size,
        testId: testId,
        tooltipMessage: tooltipMessage || content,
        isDisabled: isDisabled,
        href: href,
        ariaLabel: ariaLabel
    });
    return Wrapper !== undefined ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement(Wrapper, null, button) : button;
};
var $06b45807ac21c6f2$export$2e2bcd8739ae039 = $06b45807ac21c6f2$var$Action;

});
parcelRegister("1NY7H", function(module, exports) {
$parcel$export(module.exports, "default", () => $12c49a7b9bdaa83c$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v3.0.2 */ /* index.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $9fU1q = parcelRequire("9fU1q");

var $bSJIT = parcelRequire("bSJIT");

var $14TCm = parcelRequire("14TCm");

var $jNJGJ = parcelRequire("jNJGJ");

var $4TRbS = parcelRequire("4TRbS");

var $9EHSp = parcelRequire("9EHSp");

var $hPVlR = parcelRequire("hPVlR");

var $lebr5 = parcelRequire("lebr5");

var $9PwDt = parcelRequire("9PwDt");

var $lavtv = parcelRequire("lavtv");

var $5kJPq = parcelRequire("5kJPq");

var $7Z1Fb = parcelRequire("7Z1Fb");

var $3P7qX = parcelRequire("3P7qX");

var $cUXyD = parcelRequire("cUXyD");

var $1K1oW = parcelRequire("1K1oW");

var $2KUQd = parcelRequire("2KUQd");
const $12c49a7b9bdaa83c$var$IconOnlyLarge = null;
const $12c49a7b9bdaa83c$var$SizeSmall = null;
const $12c49a7b9bdaa83c$var$styles = {
    textSmall: "_13bowadc _1q9t1wq8 _1rlg1g80 _bdn61h6o"
};
const $12c49a7b9bdaa83c$var$SizeSmallIconOnly = null;
const $12c49a7b9bdaa83c$var$SizeSmallNotIconOnly = null;
const $12c49a7b9bdaa83c$var$IconButtonAppearanceMap = {
    default: 'default',
    danger: undefined,
    link: 'default',
    primary: 'primary',
    subtle: 'subtle',
    'subtle-link': 'subtle',
    warning: undefined
};
const $12c49a7b9bdaa83c$var$ButtonAppearanceMap = {
    default: 'default',
    danger: 'danger',
    link: 'default',
    primary: 'primary',
    subtle: 'subtle',
    'subtle-link': 'subtle',
    warning: 'warning'
};
const $12c49a7b9bdaa83c$var$tooltipOptions = {
    hideTooltipOnClick: true
};
const $12c49a7b9bdaa83c$var$ActionButtonRefresh = /*#__PURE__*/ (0, $bSJIT.forwardRef)(({ appearance: appearance = 'default', content: content, iconAfter: iconAfter, iconBefore: iconBefore, isLoading: isLoading, onClick: onClick, size: size, testId: testId, tooltipMessage: tooltipMessage, isDisabled: isDisabled, href: href, ariaLabel: ariaLabel }, ref)=>{
    var _context$actions;
    const iconOnly = !content;
    const context = (0, $7Z1Fb.useFlexibleUiContext)();
    const { product: product } = (0, $cUXyD.default)();
    const isRovoSupported = !!(context !== null && context !== void 0 && (_context$actions = context.actions) !== null && _context$actions !== void 0 && _context$actions[(0, $5kJPq.ActionName).RovoChatAction]) && !!product && product === 'CONFLUENCE';
    const onButtonClick = (0, $bSJIT.useCallback)((handler)=>(e)=>{
            e.preventDefault();
            handler();
        }, []);
    const button = (0, $bSJIT.useMemo)(()=>{
        const isLinkButton = !!href;
        const spacing = size === (0, $5kJPq.SmartLinkSize).Large || size === (0, $5kJPq.SmartLinkSize).XLarge ? 'default' : 'compact';
        const icon = iconBefore || iconAfter;
        const iconFn = icon ? ()=>icon : undefined;
        if (iconOnly && iconFn) {
            if (isLinkButton && iconFn) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $9EHSp.default), {
                appearance: $12c49a7b9bdaa83c$var$IconButtonAppearanceMap[appearance],
                icon: iconFn,
                href: href,
                isDisabled: isDisabled,
                isTooltipDisabled: false,
                label: tooltipMessage,
                onClick: onButtonClick(onClick),
                spacing: spacing,
                testId: testId,
                tooltip: $12c49a7b9bdaa83c$var$tooltipOptions
            });
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $4TRbS.default), {
                appearance: $12c49a7b9bdaa83c$var$IconButtonAppearanceMap[appearance],
                icon: iconFn,
                isDisabled: isDisabled,
                isLoading: isLoading,
                isTooltipDisabled: false,
                label: tooltipMessage,
                onClick: onButtonClick(onClick),
                spacing: spacing,
                testId: testId,
                tooltip: $12c49a7b9bdaa83c$var$tooltipOptions
            });
        }
        const iconBeforeFn = iconBefore ? ()=>iconBefore : undefined;
        const iconAfterFn = iconAfter ? ()=>iconAfter : undefined;
        if (isLinkButton) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $lavtv.default), {
            content: tooltipMessage,
            hideTooltipOnClick: true,
            testId: `${testId}-tooltip`
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $hPVlR.default), {
            appearance: $12c49a7b9bdaa83c$var$ButtonAppearanceMap[appearance],
            "aria-label": ariaLabel,
            iconAfter: iconAfterFn,
            iconBefore: iconBeforeFn,
            isDisabled: isDisabled,
            href: href,
            onClick: onButtonClick(onClick),
            spacing: spacing,
            testId: testId
        }, content));
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $lavtv.default), {
            content: tooltipMessage,
            hideTooltipOnClick: true,
            testId: `${testId}-tooltip`
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $jNJGJ.default), {
            appearance: $12c49a7b9bdaa83c$var$ButtonAppearanceMap[appearance],
            "aria-label": ariaLabel,
            iconAfter: iconAfterFn,
            iconBefore: iconBeforeFn,
            isDisabled: isDisabled,
            isLoading: isLoading,
            onClick: onButtonClick(onClick),
            spacing: spacing,
            testId: testId
        }, content));
    }, [
        appearance,
        ariaLabel,
        content,
        href,
        iconAfter,
        iconBefore,
        iconOnly,
        isDisabled,
        isLoading,
        onButtonClick,
        onClick,
        size,
        testId,
        tooltipMessage
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $9PwDt.Box), {
        testId: `${testId}-button-wrapper`,
        ref: ref,
        xcss: (0, $14TCm.cx)(isRovoSupported && size === (0, $5kJPq.SmartLinkSize).Small && $12c49a7b9bdaa83c$var$styles.textSmall)
    }, button);
});
const $12c49a7b9bdaa83c$var$ActionButtonRefreshWithOverrideCss = (0, $1K1oW.withOverrideCss)($12c49a7b9bdaa83c$var$ActionButtonRefresh);
const $12c49a7b9bdaa83c$var$ActionButtonNew = ({ appearance: appearance = 'default', content: content, iconAfter: iconAfter, iconBefore: iconBefore, isLoading: isLoading, onClick: onClick, size: size, testId: testId, tooltipMessage: tooltipMessage, isDisabled: isDisabled, href: href, ariaLabel: ariaLabel, className: className })=>{
    const iconOnly = !content;
    const onButtonClick = (0, $bSJIT.useCallback)((handler)=>(e)=>{
            e.preventDefault();
            handler();
        }, []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
        className: (0, $9fU1q.default)([
            size === (0, $5kJPq.SmartLinkSize).Large && iconOnly && "_1gflidpf _or3fidpf _1ddvidpf _1hhaidpf _yhjmidpf _1trnidpf _1fstidpf _1xceidpf _1gqnidpf _1qdmidpf _df2ridpf _j1twidpf _11lvidpf _192bidpf _vbn7idpf _wfu3idpf _1i3bidpf _13gwidpf _4wlcidpf _rehaidpf _mp2fidpf _ro8midpf _1l0qidpf _1bnaidpf _3kh9idpf _i2vxidpf _8pvjidpf _1e1oidpf _1vtwidpf _ijvwidpf _tpwpidpf _1ad8idpf",
            size === (0, $5kJPq.SmartLinkSize).Small && "_11c8wadc _k48p1wq8",
            size === (0, $5kJPq.SmartLinkSize).Small && iconOnly && "_1gflv77o _or3fv77o _1ddvv77o _1hhav77o _yhjmv77o _1trnv77o _1fstv77o _1xcev77o _1gqnv77o _1qdmv77o _df2rv77o _j1twv77o _11lvv77o _192bv77o _vbn7v77o _wfu3v77o",
            size === (0, $5kJPq.SmartLinkSize).Small && !iconOnly && "_11lv1b66 _192b1b66 _vbn71b66 _wfu31b66 _yhjm1b66 _1trn1b66 _1fst1b66 _1xce1b66",
            className
        ]),
        "data-testid": `${testId}-button-wrapper`
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $lavtv.default), {
        content: tooltipMessage,
        hideTooltipOnClick: true,
        testId: `${testId}-tooltip`
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $lebr5.default), {
        appearance: appearance,
        iconAfter: iconAfter,
        iconBefore: iconBefore,
        isDisabled: isDisabled,
        isLoading: isLoading,
        onClick: onButtonClick(onClick),
        spacing: (0, $2KUQd.sizeToButtonSpacing)[size],
        testId: testId,
        href: href,
        "aria-label": ariaLabel
    }, content)));
};
const $12c49a7b9bdaa83c$var$ActionButton = (props)=>{
    const ui = (0, $3P7qX.useFlexibleUiOptionContext)();
    if (ui !== null && ui !== void 0 && ui.hideLegacyButton || ui !== null && ui !== void 0 && ui.removeBlockRestriction) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement($12c49a7b9bdaa83c$var$ActionButtonRefreshWithOverrideCss, props);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement($12c49a7b9bdaa83c$var$ActionButtonNew, props);
};
var $12c49a7b9bdaa83c$export$2e2bcd8739ae039 = $12c49a7b9bdaa83c$var$ActionButton;

});
parcelRegister("1K1oW", function(module, exports) {
$parcel$export(module.exports, "withOverrideCss", () => $0627aeb5a998f454$export$e0bdcacb944f1da6);

var $bSJIT = parcelRequire("bSJIT");
function $0627aeb5a998f454$export$e0bdcacb944f1da6(Component) {
    return (props)=>{
        const ref = (0, $bSJIT.useRef)(null);
        (0, $bSJIT.useEffect)(()=>{
            if (props !== null && props !== void 0 && props.className && ref.current) ref.current.className = `${ref.current.className} ${props.className}`;
        }, [
            props === null || props === void 0 ? void 0 : props.className
        ]);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement(Component, {
            ...props,
            ref: ref
        });
    };
}

});

parcelRegister("2KUQd", function(module, exports) {
$parcel$export(module.exports, "sizeToButtonSpacing", () => $df41337772ab9e31$export$9d642f65a919fb93);

var $5kJPq = parcelRequire("5kJPq");
const $df41337772ab9e31$export$9d642f65a919fb93 = {
    [(0, $5kJPq.SmartLinkSize).Small]: 'none',
    [(0, $5kJPq.SmartLinkSize).Medium]: 'compact',
    [(0, $5kJPq.SmartLinkSize).Large]: 'compact',
    [(0, $5kJPq.SmartLinkSize).XLarge]: 'default'
};

});


parcelRegister("aEzVt", function(module, exports) {
$parcel$export(module.exports, "default", () => $fa6b92c30df31203$export$2e2bcd8739ae039);

var $bSJIT = parcelRequire("bSJIT");

var $ag7mU = parcelRequire("ag7mU");

var $65AjV = parcelRequire("65AjV");
const $fa6b92c30df31203$var$ActionDropdownItem = ({ content: content, iconAfter: iconAfter, iconBefore: iconBefore, isLoading: isLoading, onClick: onClick, testId: testId })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $ag7mU.default), {
        elemAfter: iconAfter,
        elemBefore: iconBefore,
        isDisabled: isLoading,
        onClick: (0, $65AjV.handleOnClick)(onClick),
        testId: testId
    }, content);
var $fa6b92c30df31203$export$2e2bcd8739ae039 = $fa6b92c30df31203$var$ActionDropdownItem;

});
parcelRegister("65AjV", function(module, exports) {
$parcel$export(module.exports, "handleOnClick", () => $92be518cdf972e6e$export$ffccab2ae3d093ef);
parcelRequire("bSJIT");
const $92be518cdf972e6e$export$ffccab2ae3d093ef = (handler)=>(e)=>{
        e.preventDefault();
        e.stopPropagation();
        handler();
    };

});


parcelRegister("kmw7d", function(module, exports) {
$parcel$export(module.exports, "default", () => $7009882a88319abe$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $bSJIT = parcelRequire("bSJIT");

var $9fU1q = parcelRequire("9fU1q");
const $7009882a88319abe$var$stackItemIconStylesCompiled = null;
const $7009882a88319abe$var$ActionIcon = ({ testId: testId, icon: icon })=>{
    return /*#__PURE__*/ $bSJIT.createElement("span", {
        "data-testid": `${testId}-icon`,
        className: (0, $9fU1q.default)([
            "_1e0c116y"
        ])
    }, icon);
};
var $7009882a88319abe$export$2e2bcd8739ae039 = $7009882a88319abe$var$ActionIcon;

});

parcelRegister("aIJT4", function(module, exports) {
$parcel$export(module.exports, "default", () => $330a4a9702493abe$export$2e2bcd8739ae039);

var $bSJIT = parcelRequire("bSJIT");

var $lavtv = parcelRequire("lavtv");

var $dkxkD = parcelRequire("dkxkD");
const $330a4a9702493abe$var$ActionStackItem = ({ content: content, tooltipMessage: tooltipMessage, tooltipOnHide: tooltipOnHide, hideTooltipOnMouseDown: hideTooltipOnMouseDown, hasNewContentOnTriggerClick: hasNewContentOnTriggerClick, hideTooltip: hideTooltip, ...props })=>{
    return hideTooltip ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $dkxkD.default), {
        ...props,
        content: content
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $lavtv.default), {
        content: tooltipMessage || content,
        onHide: tooltipOnHide,
        hideTooltipOnMouseDown: hideTooltipOnMouseDown,
        hasNewContentOnTriggerClick: hasNewContentOnTriggerClick
    }, (tooltipProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $dkxkD.default), {
            ...props,
            content: content,
            tooltipProps: tooltipProps
        }));
};
var $330a4a9702493abe$export$2e2bcd8739ae039 = $330a4a9702493abe$var$ActionStackItem;

});
parcelRegister("dkxkD", function(module, exports) {
$parcel$export(module.exports, "default", () => $d782468bbd612824$export$2e2bcd8739ae039);
/* action-button.tsx generated by @compiled/babel-plugin v3.0.2 */ /* action-button.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $bSJIT = parcelRequire("bSJIT");

var $jDsoo = parcelRequire("jDsoo");

var $9PwDt = parcelRequire("9PwDt");

var $fZ0ZI = parcelRequire("fZ0ZI");

var $gXqq0 = parcelRequire("gXqq0");

var $hDkm2 = parcelRequire("hDkm2");

var $fEx1p = parcelRequire("fEx1p");

var $kmw7d = parcelRequire("kmw7d");
const $d782468bbd612824$var$styles = {
    button: "_bfhksm61 _ca0q1b66 _u5f31b66 _n3td1b66 _19bv1b66 _1bsb1osq _1ah31i6y _irr31dpa _1di6fcek",
    content: "_11c8wadc _syazi7uo",
    spinner: "_1bsb1tcg _4t3i1tcg _1e0c116y _4cvr1h6o _1bah1h6o"
};
const $d782468bbd612824$var$ActionButton = ({ content: content, icon: iconOption, isDisabled: isDisabled, isLoading: isLoading, onClick: onClickCallback, size: size, space: spaceOption, testId: testId, tooltipProps: tooltipProps, style: style, ariaLabel: ariaLabel })=>{
    const space = spaceOption ?? (0, $fEx1p.getPrimitivesInlineSpaceBySize)(size);
    const onClick = (0, $bSJIT.useCallback)(()=>{
        if (!isDisabled && !isLoading && onClickCallback) onClickCallback();
    }, [
        isDisabled,
        isLoading,
        onClickCallback
    ]);
    // FIX-ME: This is required for ResolvedHoverCardFooterBlock action to show proper size
    // ResolvedHoverCardFooterBlock is currently not used but keeping inside the code base for
    // upcoming experiment to refresh HoverCard design
    // If ResolvedHoverCardFooterBlock is cleaned up, this code can be removed.
    const showSpinnerSize24 = false;
    const icon = iconOption && isLoading ? /*#__PURE__*/ $bSJIT.createElement((0, $kmw7d.default), {
        icon: showSpinnerSize24 ? /*#__PURE__*/ $bSJIT.createElement((0, $9PwDt.Box), {
            xcss: $d782468bbd612824$var$styles.spinner
        }, /*#__PURE__*/ $bSJIT.createElement((0, $hDkm2.default), {
            size: 16,
            testId: `${testId}-loading`
        })) : /*#__PURE__*/ $bSJIT.createElement((0, $hDkm2.default), {
            testId: `${testId}-loading`
        })
    }) : iconOption;
    return /*#__PURE__*/ $bSJIT.createElement((0, $gXqq0.Pressable), {
        xcss: (0, $jDsoo.cx)($d782468bbd612824$var$styles.button),
        ...tooltipProps,
        onClick: onClick,
        testId: testId,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
        style: style,
        "aria-label": ariaLabel
    }, /*#__PURE__*/ $bSJIT.createElement((0, $fZ0ZI.Inline), {
        alignBlock: "center",
        grow: "fill",
        space: space
    }, icon, /*#__PURE__*/ $bSJIT.createElement((0, $9PwDt.Box), {
        xcss: (0, $jDsoo.cx)($d782468bbd612824$var$styles.content)
    }, content)));
};
var $d782468bbd612824$export$2e2bcd8739ae039 = $d782468bbd612824$var$ActionButton;

});
parcelRegister("fEx1p", function(module, exports) {
$parcel$export(module.exports, "getPrimitivesInlineSpaceBySize", () => $1acfcba35f8a4989$export$475c391af8171fec);

var $5kJPq = parcelRequire("5kJPq");
const $1acfcba35f8a4989$export$475c391af8171fec = (size)=>{
    switch(size){
        case (0, $5kJPq.SmartLinkSize).XLarge:
            return 'space.250';
        case (0, $5kJPq.SmartLinkSize).Large:
            return 'space.200';
        case (0, $5kJPq.SmartLinkSize).Medium:
            return 'space.100';
        case (0, $5kJPq.SmartLinkSize).Small:
        default:
            return 'space.050';
    }
};

});




parcelRegister("6mQ6U", function(module, exports) {
$parcel$export(module.exports, "default", () => $a843749f2bb04b36$export$2e2bcd8739ae039);

var $bSJIT = parcelRequire("bSJIT");

var $5kJPq = parcelRequire("5kJPq");

var $7Z1Fb = parcelRequire("7Z1Fb");

var $5WkZM = parcelRequire("5WkZM");
const $a843749f2bb04b36$var$AISummaryAction = (props)=>{
    var _context$actions;
    const context = (0, $7Z1Fb.useFlexibleUiContext)();
    const actionData = context === null || context === void 0 || (_context$actions = context.actions) === null || _context$actions === void 0 ? void 0 : _context$actions[(0, $5kJPq.InternalActionName).AISummaryAction];
    return actionData ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $5WkZM.AISummaryActionComponent), {
        ...actionData,
        ...props
    }) : null;
};
var $a843749f2bb04b36$export$2e2bcd8739ae039 = $a843749f2bb04b36$var$AISummaryAction;

});
parcelRegister("5WkZM", function(module, exports) {
$parcel$export(module.exports, "AISummaryActionComponent", () => $9371618a66b25059$export$8eed96bc6d982595);

var $bSJIT = parcelRequire("bSJIT");

var $jsMV5 = parcelRequire("jsMV5");

var $4IrAn = parcelRequire("4IrAn");

var $03KQa = parcelRequire("03KQa");
const $9371618a66b25059$export$8eed96bc6d982595 = (props)=>{
    const { url: url, onLoadingChange: onLoadingChange, testId: testId = 'smart-action-ai-summary-action' } = props;
    const { state: { status: status, content: content }, summariseUrl: summariseUrl } = (0, $jsMV5.default)(url);
    (0, $bSJIT.useEffect)(()=>{
        onLoadingChange === null || onLoadingChange === void 0 || onLoadingChange(status === 'loading');
    }, [
        onLoadingChange,
        status
    ]);
    return status === 'done' ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $03KQa.CopySummaryAction), {
        ...props,
        summary: content,
        testId: testId
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $4IrAn.AISummariseAction), {
        ...props,
        testId: testId,
        summariseUrl: summariseUrl,
        status: status
    });
};

});
parcelRegister("jsMV5", function(module, exports) {
$parcel$export(module.exports, "default", () => $911bf523eb73544b$export$2e2bcd8739ae039);

var $bSJIT = parcelRequire("bSJIT");

var $4FI6h = parcelRequire("4FI6h");

var $fLcUZ = parcelRequire("fLcUZ");

var $2fwRK = parcelRequire("2fwRK");

var $iq8lm = parcelRequire("iq8lm");

var $jERMp = parcelRequire("jERMp");

var $dXrim = parcelRequire("dXrim");

var $2TtjQ = parcelRequire("2TtjQ");

var $c06ml = parcelRequire("c06ml");

var $cnUW1 = parcelRequire("cnUW1");
const $911bf523eb73544b$var$EXPERIENCE_NAME = 'smart-link-ai-summary';
const $911bf523eb73544b$var$useAISummaryAction = (url)=>{
    var _cardState$details;
    const { baseUrl: baseUrl, envKey: envKey, product: product } = (0, $cnUW1.useAISummaryConfig)();
    const cardState = (0, $2TtjQ.useSmartCardState)(url);
    const { fireEvent: fireEvent } = (0, $2fwRK.useAnalyticsEvents)();
    const data = (_cardState$details = cardState.details) === null || _cardState$details === void 0 ? void 0 : _cardState$details.data;
    const ari = data && (0, $4FI6h.extractAri)(data);
    const dataUrl = data && (0, $fLcUZ.extractLink)(data) || '';
    const onStart = (0, $bSJIT.useCallback)((id)=>{
        (0, $jERMp.startUfoExperience)($911bf523eb73544b$var$EXPERIENCE_NAME, id);
    }, []);
    const onSuccess = (0, $bSJIT.useCallback)((id)=>{
        fireEvent('operational.summary.success', {});
        (0, $dXrim.succeedUfoExperience)($911bf523eb73544b$var$EXPERIENCE_NAME, id);
    }, [
        fireEvent
    ]);
    const onError = (0, $bSJIT.useCallback)((id, reason)=>{
        /**
     * Errors should only be counted to the SLO if they are not due to acceptable use violations
     * HIPAA content detected or exceeding context length.
     */ const isSloError = reason === undefined ? true : ![
            'ACCEPTABLE_USE_VIOLATIONS',
            'HIPAA_CONTENT_DETECTED',
            'EXCEEDING_CONTEXT_LENGTH_ERROR'
        ].includes(reason);
        fireEvent('operational.summary.failed', {
            reason: reason || null,
            isSloError: isSloError
        });
        (0, $iq8lm.failUfoExperience)($911bf523eb73544b$var$EXPERIENCE_NAME, id);
    }, [
        fireEvent
    ]);
    return (0, $c06ml.useAISummary)({
        url: dataUrl,
        ari: ari,
        product: product,
        envKey: envKey,
        baseUrl: baseUrl,
        onStart: onStart,
        onSuccess: onSuccess,
        onError: onError
    });
};
var $911bf523eb73544b$export$2e2bcd8739ae039 = $911bf523eb73544b$var$useAISummaryAction;

});
parcelRegister("4FI6h", function(module, exports) {
$parcel$export(module.exports, "extractAri", () => $ac58631f84819fd5$export$be18a6294fd426ec);
const $ac58631f84819fd5$export$be18a6294fd426ec = (jsonLd)=>{
    if (jsonLd !== null && jsonLd !== void 0 && jsonLd['atlassian:ari']) return jsonLd['atlassian:ari'];
    return undefined;
};

});

parcelRegister("fLcUZ", function(module, exports) {
$parcel$export(module.exports, "extractLink", () => $dd611d154e4c991f$export$63f54cf4c5883620);

var $dtKl2 = parcelRequire("dtKl2");
const $dd611d154e4c991f$export$63f54cf4c5883620 = (jsonLd)=>{
    const url = jsonLd === null || jsonLd === void 0 ? void 0 : jsonLd.url;
    if (url) {
        if (typeof url === 'string') return url;
        else return (0, $dtKl2.extractUrlFromLinkJsonLd)(url);
    }
    return undefined;
};

});

parcelRegister("c06ml", function(module, exports) {
$parcel$export(module.exports, "useAISummary", () => $913224181c58ce71$export$becd8f2eba1bbd96);

var $bSJIT = parcelRequire("bSJIT");

var $4vLTk = parcelRequire("4vLTk");

var $imnV0 = parcelRequire("imnV0");

var $er1Di = parcelRequire("er1Di");
const $913224181c58ce71$export$becd8f2eba1bbd96 = (props)=>{
    var _AISummariesStore$get;
    const { url: url, baseUrl: baseUrl, product: product, ari: ari, envKey: envKey, onError: onError, onStart: onStart, onSuccess: onSuccess } = props;
    const [state, setState] = (0, $bSJIT.useState)(((_AISummariesStore$get = (0, $er1Di.AISummariesStore).get(url)) === null || _AISummariesStore$get === void 0 ? void 0 : _AISummariesStore$get.state) || {
        status: 'ready',
        content: ''
    });
    const { locale: locale } = (0, $4vLTk.default)();
    (0, $bSJIT.useEffect)(()=>{
        var _AISummariesStore$get2;
        //do not create a service for the empty URL string when the link data is not yet available,
        //or the service has already been created and cached.
        if (url && !(0, $er1Di.AISummariesStore).get(url)) (0, $er1Di.AISummariesStore).set(url, new (0, $imnV0.AISummaryService)({
            url: url,
            ari: ari,
            baseUrl: baseUrl,
            product: product,
            envKey: envKey,
            locale: locale,
            onError: onError,
            onStart: onStart,
            onSuccess: onSuccess
        }));
        //returns function that calls unsubscribe method
        return (_AISummariesStore$get2 = (0, $er1Di.AISummariesStore).get(url)) === null || _AISummariesStore$get2 === void 0 ? void 0 : _AISummariesStore$get2.subscribe(setState);
    }, [
        url,
        baseUrl,
        onError,
        onStart,
        onSuccess,
        product,
        ari,
        envKey,
        locale
    ]);
    const summariseUrl = ()=>{
        var _AISummariesStore$get3;
        return (_AISummariesStore$get3 = (0, $er1Di.AISummariesStore).get(url)) === null || _AISummariesStore$get3 === void 0 ? void 0 : _AISummariesStore$get3.summariseUrl();
    };
    return {
        summariseUrl: summariseUrl,
        state: state
    };
};

});
parcelRegister("imnV0", function(module, exports) {
$parcel$export(module.exports, "AISummaryService", () => $8adc6e03119ce9ac$export$73e4b807d5bd74b6);
// eslint-disable-next-line @atlaskit/platform/prefer-crypto-random-uuid -- Use crypto.randomUUID instead

var $7RHfd = parcelRequire("7RHfd");

var $4AI8m = parcelRequire("4AI8m");

var $3Uqp7 = parcelRequire("3Uqp7");

var $ljUpd = parcelRequire("ljUpd");

var $6DmG2 = parcelRequire("6DmG2");

var $3Gxt5 = parcelRequire("3Gxt5");
const $8adc6e03119ce9ac$var$CONVO_AI_ENDPOINT = 'assist/api/ai/v2/ai-feature/smartlinksummary/stream';
class $8adc6e03119ce9ac$export$73e4b807d5bd74b6 {
    constructor(props){
        this.state = {
            content: '',
            status: 'ready'
        };
        this.subscribedStateSetters = new Set();
        this.getRequestUrl = (envKey, baseUrlOverride)=>{
            if (baseUrlOverride || envKey) {
                const baseUrl = baseUrlOverride || (0, $4AI8m.getBaseUrl)(envKey);
                return (0, $3Uqp7.addPath)(baseUrl, $8adc6e03119ce9ac$var$CONVO_AI_ENDPOINT);
            }
            return (0, $3Uqp7.addPath)('/gateway/api/', $8adc6e03119ce9ac$var$CONVO_AI_ENDPOINT);
        };
        this.fetchStream = async ()=>{
            const payload = {
                recipient_agent_named_id: 'smartlink_summary_agent',
                agent_input_context: {
                    content_url: this.url,
                    content_ari: this.ari,
                    prompt_id: 'smart_links',
                    summary_output_mimetype: 'text/markdown',
                    locale: this.locale
                },
                ai_feature_input: {
                    content_url: this.url,
                    content_ari: this.ari,
                    locale: this.locale
                }
            };
            const options = {
                method: 'POST',
                headers: this.config.headers,
                body: JSON.stringify(payload),
                credentials: 'include'
            };
            const response = await fetch(this.config.requestUrl, options);
            if (!response.ok || response.status >= 400) throw new Error(`Status: ${response.status}\n URL: ${this.url}\n StatusText ${response.statusText}`);
            else return (0, $6DmG2.readStream)(response);
        };
        var _getXProductHeaderVal;
        this.config = {
            requestUrl: this.getRequestUrl(props.envKey, props.baseUrl),
            headers: {
                'Content-Type': 'application/json;charset=UTF-8',
                'x-experience-id': 'smart-link',
                'x-product': ((_getXProductHeaderVal = (0, $ljUpd.getXProductHeaderValue)(props.product)) === null || _getXProductHeaderVal === void 0 ? void 0 : _getXProductHeaderVal.toLowerCase()) || 'confluence'
            }
        };
        this.url = props.url;
        this.ari = props.ari;
        this.locale = props.locale;
        this.onStart = props.onStart;
        this.onSuccess = props.onSuccess;
        this.onError = props.onError;
    }
    async summariseUrl() {
        this.state = {
            status: 'loading',
            content: ''
        };
        for (const subscriber of this.subscribedStateSetters)subscriber(this.state);
        // eslint-disable-next-line @atlaskit/platform/prefer-crypto-random-uuid -- Use crypto.randomUUID instead
        const id = (0, $7RHfd.default)();
        try {
            var _this$onStart, _this$onSuccess;
            (_this$onStart = this.onStart) === null || _this$onStart === void 0 || _this$onStart.call(this, id);
            const stream = await this.fetchStream();
            let bufferContent = '';
            for await (const chunk of stream){
                if (chunk.type === 'ANSWER_PART') {
                    bufferContent += chunk.message.content;
                    for (const subscriber of this.subscribedStateSetters)subscriber({
                        ...this.state,
                        content: bufferContent
                    });
                }
                //if AI Mate service returns cached summary we get the summary text in one piece as the last message
                if (chunk.type === 'FINAL_RESPONSE') bufferContent = chunk.message.content;
                if (chunk.type === 'ERROR') {
                    var _chunk$message;
                    throw new (0, $3Gxt5.ChunkProcessingError)(chunk === null || chunk === void 0 || (_chunk$message = chunk.message) === null || _chunk$message === void 0 ? void 0 : _chunk$message.message_template);
                }
            }
            (_this$onSuccess = this.onSuccess) === null || _this$onSuccess === void 0 || _this$onSuccess.call(this, id);
            this.state = {
                status: 'done',
                content: bufferContent
            };
        } catch (err) {
            var _this$onError;
            let message = err instanceof (0, $3Gxt5.ChunkProcessingError) ? err.message : 'UNEXPECTED';
            (_this$onError = this.onError) === null || _this$onError === void 0 || _this$onError.call(this, id, message);
            this.state = {
                status: 'error',
                content: '',
                error: message
            };
        }
        for (const subscriber of this.subscribedStateSetters)subscriber(this.state);
        return this.state;
    }
    subscribe(stateSetter) {
        this.subscribedStateSetters.add(stateSetter);
        return ()=>{
            this.subscribedStateSetters.delete(stateSetter);
        };
    }
}

});
parcelRegister("3Uqp7", function(module, exports) {
$parcel$export(module.exports, "addPath", () => $6e89074b4e071ca7$export$4c25481b843feb0b);
const $6e89074b4e071ca7$export$4c25481b843feb0b = (baseUrl, path)=>{
    const urlWithTrailingSlash = baseUrl.endsWith('/') ? baseUrl : `${baseUrl}/`;
    const pathWithoutLeadingSlash = !path.startsWith('/') ? path : path.substring(1, path.length);
    const url = [
        urlWithTrailingSlash,
        pathWithoutLeadingSlash
    ].join('');
    return url;
};

});

parcelRegister("ljUpd", function(module, exports) {
$parcel$export(module.exports, "getXProductHeaderValue", () => $cbb8b6a0ce717d47$export$ff2962de2b2c930f);
/**
 * Subset of a map of Jira `ProductTypes` to AI Mate expected values
 * See for more info: https://atlassian.slack.com/archives/C066UP0G0G3/p1716341647677829?thread_ts=1716338063.255939&cid=C066UP0G0G3
 */ const $cbb8b6a0ce717d47$var$AiMateJiraXProduct = {
    JSM: 'JSM',
    JSW: 'JIRA-SOFTWARE',
    JWM: 'JIRA-CORE',
    JPD: 'JPD'
};
/**
 * Checks if `product` is a Jira related product.
 */ const $cbb8b6a0ce717d47$var$isJiraProduct = (product)=>{
    const JIRA_PRODUCTS = [
        'JPD',
        'JSM',
        'JSW',
        'JWM'
    ];
    return product !== undefined && JIRA_PRODUCTS.includes(product);
};
const $cbb8b6a0ce717d47$export$ff2962de2b2c930f = (product)=>{
    if ($cbb8b6a0ce717d47$var$isJiraProduct(product)) return $cbb8b6a0ce717d47$var$AiMateJiraXProduct[product];
    return product;
};

});

parcelRegister("6DmG2", function(module, exports) {
$parcel$export(module.exports, "readStream", () => $2e30ecde595127d0$export$e45226161c660403);

var $3MMOT = parcelRequire("3MMOT");
async function* $2e30ecde595127d0$export$e45226161c660403(response) {
    const reader = (0, $3MMOT.getBufferReader)(response);
    let doneStreaming = false;
    let chunkBuffer = '';
    do try {
        const { value: value, done: done } = await reader.read();
        doneStreaming = done;
        if (value) {
            const processedChunks = `${chunkBuffer}${value}`.split('\n'); // assumes that all JSON chunks are separated by a new-line;
            chunkBuffer = '';
            for (let chunk of processedChunks)try {
                const jsonChunk = JSON.parse(chunk);
                if (jsonChunk.type === 'ERROR') reader.cancel();
                yield jsonChunk;
            } catch (e) {
                // the chunk may be incomplete, so we'll save it for the next iteration.
                chunkBuffer = chunk;
            }
        }
    } catch (e) {
        // If we abort the call, this exception bubbles up, so we want to catch it and exit gracefully
        if (e instanceof DOMException && e.name === 'AbortError') doneStreaming = true;
        else {
            reader.cancel();
            throw e;
        }
    }
    while (!doneStreaming);
    if (chunkBuffer) {
        const error = new Error(`Not all the data was processed: ${chunkBuffer}`);
        throw error;
    }
}

});
parcelRegister("3MMOT", function(module, exports) {
$parcel$export(module.exports, "getBufferReader", () => $1fd9e7fa9bb215a4$export$f6383c3ea1307da9);
const $1fd9e7fa9bb215a4$export$f6383c3ea1307da9 = (response)=>{
    if (!response.body) throw new Error('Response body is empty');
    return response.body.pipeThrough(new TextDecoderStream()).getReader();
};

});


parcelRegister("3Gxt5", function(module, exports) {
$parcel$export(module.exports, "ChunkProcessingError", () => $9c58bd635a4ae9fa$export$fcec967a4b7ebd84);
class $9c58bd635a4ae9fa$export$fcec967a4b7ebd84 extends Error {
    constructor(error){
        super(error);
    }
}
const $9c58bd635a4ae9fa$export$d8bd0967cb58683 = [
    'NETWORK_ERROR',
    'NO_ANSWER',
    'RATE_LIMIT',
    'NO_AGENT',
    'PLUGIN_ERRORED',
    'OPENAI_RATE_LIMIT_USER_ABUSE',
    'ACCEPTABLE_USE_VIOLATIONS',
    'AI_DISABLED',
    'UNEXPECTED',
    'HIPAA_CONTENT_DETECTED',
    'EXCEEDING_CONTEXT_LENGTH_ERROR'
];

});


parcelRegister("er1Di", function(module, exports) {
$parcel$export(module.exports, "AISummariesStore", () => $135f26ca769b9211$export$6979339b6d41707e);

var $5j6lg = parcelRequire("5j6lg");
const $135f26ca769b9211$var$AI_SUMMARY_CACHE_SIZE = 100;
const $135f26ca769b9211$export$6979339b6d41707e = new (0, $5j6lg.LRUMap)($135f26ca769b9211$var$AI_SUMMARY_CACHE_SIZE);

});


parcelRegister("cnUW1", function(module, exports) {
$parcel$export(module.exports, "useAISummaryConfig", () => $848319d89b9aed49$export$4480af2c00aa7ebe);

var $bSJIT = parcelRequire("bSJIT");

var $6bOBo = parcelRequire("6bOBo");
const $848319d89b9aed49$export$4480af2c00aa7ebe = ()=>{
    const { connections: connections, product: product, isAdminHubAIEnabled: isAdminHubAIEnabled } = (0, $6bOBo.useSmartLinkContext)();
    return (0, $bSJIT.useMemo)(()=>({
            baseUrl: connections.client.baseUrlOverride,
            envKey: connections.client.envKey,
            product: product,
            isAdminHubAIEnabled: isAdminHubAIEnabled
        }), [
        connections.client.baseUrlOverride,
        connections.client.envKey,
        product,
        isAdminHubAIEnabled
    ]);
};

});


parcelRegister("4IrAn", function(module, exports) {
$parcel$export(module.exports, "AISummariseAction", () => $cab027376d96cb5f$export$75a19de44af58722);

var $bSJIT = parcelRequire("bSJIT");

var $5cKiX = parcelRequire("5cKiX");

var $74KHX = parcelRequire("74KHX");

var $2fwRK = parcelRequire("2fwRK");

var $7wYyA = parcelRequire("7wYyA");

var $8bEg5 = parcelRequire("8bEg5");

var $e7Ac5 = parcelRequire("e7Ac5");
function $cab027376d96cb5f$export$75a19de44af58722({ onClick: onClickCallback, onError: onErrorCallback, testId: testId, status: status, summariseUrl: summariseUrl, ...props }) {
    const { fireEvent: fireEvent } = (0, $2fwRK.useAnalyticsEvents)();
    const onCompleted = (0, $bSJIT.useCallback)((state)=>{
        if ((state === null || state === void 0 ? void 0 : state.status) === 'error') onErrorCallback === null || onErrorCallback === void 0 || onErrorCallback((0, $e7Ac5.getErrorMessage)(state.error));
    }, [
        onErrorCallback
    ]);
    const handleActionClick = (0, $bSJIT.useCallback)(()=>{
        var _summariseUrl;
        fireEvent('ui.button.clicked.aiSummary', {});
        fireEvent('track.aiInteraction.initiated', {
            aiFeatureName: 'Smart Links Summary',
            proactiveAIGenerated: 0,
            userGeneratedAI: 1
        });
        (_summariseUrl = summariseUrl()) === null || _summariseUrl === void 0 || _summariseUrl.then(onCompleted, onCompleted);
        onClickCallback === null || onClickCallback === void 0 || onClickCallback();
    }, [
        fireEvent,
        onClickCallback,
        onCompleted,
        summariseUrl
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $8bEg5.default), {
        content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $5cKiX.default), (0, $7wYyA.messages).ai_summary_action_rebrand),
        icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($74KHX))), {
            spacing: "spacious",
            color: "currentColor",
            label: "Summarise with AI",
            size: props.iconSize
        }),
        onClick: handleActionClick,
        testId: `${testId}-summarise-action`,
        isLoading: status === 'loading',
        tooltipMessage: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $5cKiX.default), (0, $7wYyA.messages).ai_summary_action_description_rebrand),
        ...props
    });
}

});
parcelRegister("e7Ac5", function(module, exports) {
$parcel$export(module.exports, "getErrorMessage", () => $a05083a1b23687fa$export$82f46aa4e6535a45);

var $bSJIT = parcelRequire("bSJIT");

var $5cKiX = parcelRequire("5cKiX");

var $dyRKZ = parcelRequire("dyRKZ");

var $h8u2d = parcelRequire("h8u2d");

var $bTsZv = parcelRequire("bTsZv");
const $a05083a1b23687fa$export$82f46aa4e6535a45 = (error)=>{
    const { message: message, url: url } = (0, $dyRKZ.getAISummaryErrorMessage)(error);
    return {
        appearance: 'error',
        title: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $h8u2d.default), {
            reason: error
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $5cKiX.default), {
            ...message,
            values: {
                a: (chunks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $bTsZv.default), {
                        href: url
                    }, chunks)
            }
        }))
    };
};

});
parcelRegister("dyRKZ", function(module, exports) {
$parcel$export(module.exports, "getAISummaryErrorMessage", () => $2f6cd1608e7dd831$export$cd2e891d7f87074d);

var $5kJPq = parcelRequire("5kJPq");

var $7wYyA = parcelRequire("7wYyA");
const $2f6cd1608e7dd831$export$cd2e891d7f87074d = (error)=>{
    switch(error){
        case 'ACCEPTABLE_USE_VIOLATIONS':
            return {
                message: (0, $7wYyA.messages).ai_summary_error_acceptable_use_violation,
                url: (0, $5kJPq.CONTENT_URL_ACCEPTABLE_USE_POLICY)
            };
        case 'HIPAA_CONTENT_DETECTED':
            return {
                message: (0, $7wYyA.messages).ai_summary_error_hipaa_content_detected
            };
        case 'EXCEEDING_CONTEXT_LENGTH_ERROR':
            return {
                message: (0, $7wYyA.messages).ai_summary_error_exceeding_context_length_error
            };
        default:
            return {
                message: (0, $7wYyA.messages).ai_summary_error_generic_rebrand,
                url: (0, $5kJPq.CONTENT_URL_AI_TROUBLESHOOTING)
            };
    }
};

});

parcelRegister("h8u2d", function(module, exports) {
$parcel$export(module.exports, "default", () => $ec32bafb6bd5277c$export$2e2bcd8739ae039);

var $bSJIT = parcelRequire("bSJIT");

var $2fwRK = parcelRequire("2fwRK");
const $ec32bafb6bd5277c$var$AIEventErrorViewed = ({ reason: reason })=>{
    const { fireEvent: fireEvent } = (0, $2fwRK.useAnalyticsEvents)();
    (0, $bSJIT.useEffect)(()=>{
        fireEvent('ui.error.viewed.aiSummary', {
            reason: reason
        });
    }, [
        fireEvent,
        reason
    ]);
    return null;
};
var $ec32bafb6bd5277c$export$2e2bcd8739ae039 = $ec32bafb6bd5277c$var$AIEventErrorViewed;

});

parcelRegister("bTsZv", function(module, exports) {
$parcel$export(module.exports, "default", () => $bc724ddbd09cfdb7$export$2e2bcd8739ae039);

var $bSJIT = parcelRequire("bSJIT");

var $9Rfip = parcelRequire("9Rfip");

var $5kJPq = parcelRequire("5kJPq");
const $bc724ddbd09cfdb7$var$AILearnMoreAnchor = ({ children: children, ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $9Rfip.default), {
        href: (0, $5kJPq.CONTENT_URL_ROVO),
        target: "_blank",
        rel: "noopener noreferrer",
        ...props
    }, children);
var $bc724ddbd09cfdb7$export$2e2bcd8739ae039 = $bc724ddbd09cfdb7$var$AILearnMoreAnchor;

});



parcelRegister("03KQa", function(module, exports) {
$parcel$export(module.exports, "CopySummaryAction", () => $a0d8e1669c2ad6ca$export$cfa1d3eed9a61059);

var $bSJIT = parcelRequire("bSJIT");

var $5cKiX = parcelRequire("5cKiX");

var $c81bI = parcelRequire("c81bI");

var $2fwRK = parcelRequire("2fwRK");

var $7wYyA = parcelRequire("7wYyA");

var $8bEg5 = parcelRequire("8bEg5");
function $a0d8e1669c2ad6ca$export$cfa1d3eed9a61059({ url: url, onClick: onClickCallback, summary: summary = '', testId: testId, ...props }) {
    const { fireEvent: fireEvent } = (0, $2fwRK.useAnalyticsEvents)();
    const [tooltipMessage, setTooltipMessage] = (0, $bSJIT.useState)((0, $7wYyA.messages).copy_summary_action_description);
    const handleCopySummaryClick = (0, $bSJIT.useCallback)(async ()=>{
        fireEvent('ui.button.clicked.copySummary', {});
        await navigator.clipboard.writeText(summary);
        setTooltipMessage((0, $7wYyA.messages).copied_summary_action_description);
        onClickCallback === null || onClickCallback === void 0 || onClickCallback();
    }, [
        fireEvent,
        onClickCallback,
        summary
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $8bEg5.default), {
        content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $5cKiX.default), (0, $7wYyA.messages).copy_summary_action),
        icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($c81bI))), {
            color: "currentColor",
            spacing: "spacious",
            label: "Copy Summary",
            size: props.iconSize
        }),
        onClick: handleCopySummaryClick,
        testId: `${testId}-copy-summary-action`,
        tooltipMessage: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $5cKiX.default), tooltipMessage),
        tooltipOnHide: ()=>setTooltipMessage((0, $7wYyA.messages).copy_summary_action_description),
        hasNewContentOnTriggerClick: true,
        ...props
    });
}

});



parcelRegister("kop7u", function(module, exports) {
$parcel$export(module.exports, "default", () => $39a16f168319a266$export$2e2bcd8739ae039);

var $bSJIT = parcelRequire("bSJIT");

var $5cKiX = parcelRequire("5cKiX");
var $4vLTk = parcelRequire("4vLTk");

var $9ucZp = parcelRequire("9ucZp");

var $8aT4G = parcelRequire("8aT4G");

var $2fwRK = parcelRequire("2fwRK");

var $5kJPq = parcelRequire("5kJPq");

var $7wYyA = parcelRequire("7wYyA");

var $7Z1Fb = parcelRequire("7Z1Fb");

var $8MP27 = parcelRequire("8MP27");

var $8bEg5 = parcelRequire("8bEg5");

var $7U2ep = parcelRequire("7U2ep");

const $39a16f168319a266$var$AutomationModal = /*#__PURE__*/ (0, $bSJIT.lazy)(()=>(parcelRequire("7Ixte")));
const $39a16f168319a266$var$AutomationAction = (props)=>{
    var _context$actions;
    const { formatMessage: formatMessage } = (0, $4vLTk.default)();
    const modal = (0, $8MP27.useSmartLinkModal)();
    const { onClick: onClickCallback } = props;
    const context = (0, $7Z1Fb.useFlexibleUiContext)();
    const { fireEvent: fireEvent } = (0, $2fwRK.useAnalyticsEvents)();
    const automationActionData = context === null || context === void 0 || (_context$actions = context.actions) === null || _context$actions === void 0 ? void 0 : _context$actions[(0, $5kJPq.ActionName).AutomationAction];
    const automationActionOnClick = (0, $bSJIT.useCallback)((automationActionData)=>{
        const { product: product, resourceType: resourceType, baseAutomationUrl: baseAutomationUrl, objectAri: objectAri, siteAri: siteAri, canManageAutomation: canManageAutomation, analyticsSource: analyticsSource, objectName: objectName } = automationActionData;
        fireEvent('ui.button.clicked.automationAction', {});
        const { modalTitle: modalTitle, modalDescription: modalDescription } = (0, $7U2ep.getModalContent)(product, resourceType) || {};
        const automationModalTitle = modalTitle ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $5cKiX.default), modalTitle) : undefined;
        const automationModalDescription = modalDescription ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $5cKiX.default), {
            ...modalDescription,
            values: {
                name: objectName,
                b: (chunks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $8aT4G.Text), {
                        as: "strong"
                    }, chunks),
                br: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement("br", null)
            }
        }) : undefined;
        modal.open(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement($39a16f168319a266$var$AutomationModal, {
            baseAutomationUrl: baseAutomationUrl,
            objectAri: objectAri,
            siteAri: siteAri,
            canManageAutomation: canManageAutomation,
            analyticsSource: analyticsSource,
            modalTitle: automationModalTitle,
            modalDescription: automationModalDescription,
            onClose: ()=>modal.close()
        }));
        onClickCallback === null || onClickCallback === void 0 || onClickCallback();
    }, [
        modal,
        onClickCallback,
        fireEvent
    ]);
    if (!automationActionData) return null;
    const automationActionTitle = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $5cKiX.default), (0, $7wYyA.messages).automation_action_title);
    const automationActionTooltip = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $5cKiX.default), (0, $7wYyA.messages).automation_action_tooltip);
    const automationActionIconLabel = formatMessage((0, $7wYyA.messages).automation_action_icon_label);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $8bEg5.default), {
        content: automationActionTitle,
        icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($9ucZp))), {
            spacing: "spacious",
            color: "currentColor",
            label: automationActionIconLabel,
            size: props.iconSize
        }),
        testId: "smart-action-automation-action",
        tooltipMessage: automationActionTooltip,
        ...props,
        onClick: ()=>automationActionOnClick(automationActionData)
    }));
};
var $39a16f168319a266$export$2e2bcd8739ae039 = $39a16f168319a266$var$AutomationAction;

});
parcelRegister("8MP27", function(module, exports) {
$parcel$export(module.exports, "useSmartLinkModal", () => $f14a7a98b3d9c21b$export$1fd7f5f21a6d6cb8);

var $bSJIT = parcelRequire("bSJIT");

var $d078P = parcelRequire("d078P");
const $f14a7a98b3d9c21b$export$1fd7f5f21a6d6cb8 = ()=>(0, $bSJIT.useContext)((0, $d078P.SmartLinkModalContext));

});
parcelRegister("d078P", function(module, exports) {
$parcel$export(module.exports, "SmartLinkModalContext", () => $5b2873d8c1b4f217$export$f4c0a0f23ba57f8c);

var $bSJIT = parcelRequire("bSJIT");
const $5b2873d8c1b4f217$var$FALLBACK_API = {
    open: ()=>{},
    close: ()=>{}
};
const $5b2873d8c1b4f217$export$f4c0a0f23ba57f8c = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createContext($5b2873d8c1b4f217$var$FALLBACK_API);

});


parcelRegister("7U2ep", function(module, exports) {
$parcel$export(module.exports, "getModalContent", () => $c3b3c7b02fe76cf4$export$93e707b363eaf5c8);

var $7wYyA = parcelRequire("7wYyA");
const $c3b3c7b02fe76cf4$export$93e707b363eaf5c8 = (product, resourceType)=>{
    var _modalContentMap$prod;
    const modalContentMap = {
        confluence: {
            page: {
                modalTitle: (0, $7wYyA.messages).automation_action_confluence_page_modal_title,
                modalDescription: (0, $7wYyA.messages).automation_action_confluence_page_modal_description
            }
        }
    };
    return modalContentMap === null || modalContentMap === void 0 || (_modalContentMap$prod = modalContentMap[product]) === null || _modalContentMap$prod === void 0 ? void 0 : _modalContentMap$prod[resourceType];
};

});

parcelRegister("7Ixte", function(module, exports) {

var $kOunM = parcelRequire("kOunM");
module.exports = $kOunM("gX1Y6").then(()=>parcelRequire('acEeq'));

});
parcelRegister("kOunM", function(module, exports) {
"use strict";

function $f2700b8349aa6afb$var$load(id) {
    // eslint-disable-next-line no-undef
    return import((parcelRequire("gBxz7")).resolve(id));
}
module.exports = $f2700b8349aa6afb$var$load;

});
parcelRegister("gBxz7", function(module, exports) {
$parcel$export(module.exports, "register", () => $c16a23763a54f59d$export$6503ec6e8aabbaf, (v) => $c16a23763a54f59d$export$6503ec6e8aabbaf = v);
$parcel$export(module.exports, "resolve", () => $c16a23763a54f59d$export$f7ad0328861e2f03, (v) => $c16a23763a54f59d$export$f7ad0328861e2f03 = v);
var $c16a23763a54f59d$export$6503ec6e8aabbaf;
var $c16a23763a54f59d$export$f7ad0328861e2f03;
"use strict";
var $c16a23763a54f59d$var$mapping = new Map();
function $c16a23763a54f59d$var$register(/** @type {string} */ baseUrl, /** @type {Array<string>} */ manifest // ['id', 'path', 'id2', 'path2']
) {
    for(var i = 0; i < manifest.length - 1; i += 2)$c16a23763a54f59d$var$mapping.set(manifest[i], {
        baseUrl: baseUrl,
        path: manifest[i + 1]
    });
}
function $c16a23763a54f59d$var$resolve(id) {
    var resolved = $c16a23763a54f59d$var$mapping.get(id);
    if (resolved == null) throw new Error('Could not resolve bundle with id ' + id);
    return new URL(resolved.path, resolved.baseUrl).toString();
}
$c16a23763a54f59d$export$6503ec6e8aabbaf = $c16a23763a54f59d$var$register;
$c16a23763a54f59d$export$f7ad0328861e2f03 = $c16a23763a54f59d$var$resolve;

});




parcelRegister("asa4T", function(module, exports) {
$parcel$export(module.exports, "default", () => $74315f2203954d6a$export$2e2bcd8739ae039);

var $bSJIT = parcelRequire("bSJIT");

var $5cKiX = parcelRequire("5cKiX");
var $4vLTk = parcelRequire("4vLTk");

var $gRfjb = parcelRequire("gRfjb");

var $5kJPq = parcelRequire("5kJPq");

var $7wYyA = parcelRequire("7wYyA");

var $7Z1Fb = parcelRequire("7Z1Fb");

var $2AqEC = parcelRequire("2AqEC");

var $8bEg5 = parcelRequire("8bEg5");
const $74315f2203954d6a$var$CopyLinkAction = ({ onClick: onClickCallback, ...props })=>{
    var _context$actions;
    const intl = (0, $4vLTk.default)();
    const context = (0, $7Z1Fb.useFlexibleUiContext)();
    const invoke = (0, $2AqEC.default)({});
    const data = context === null || context === void 0 || (_context$actions = context.actions) === null || _context$actions === void 0 ? void 0 : _context$actions[(0, $5kJPq.ActionName).CopyLinkAction];
    const [tooltipMessage, setTooltipMessage] = (0, $bSJIT.useState)((0, $7wYyA.messages).copy_url_to_clipboard);
    const onClick = (0, $bSJIT.useCallback)(()=>{
        if (data !== null && data !== void 0 && data.invokeAction) {
            invoke({
                ...data.invokeAction,
                actionFn: async ()=>{
                    var _data$invokeAction;
                    await ((_data$invokeAction = data.invokeAction) === null || _data$invokeAction === void 0 ? void 0 : _data$invokeAction.actionFn());
                    setTooltipMessage((0, $7wYyA.messages).copied_url_to_clipboard);
                }
            });
            onClickCallback === null || onClickCallback === void 0 || onClickCallback();
        }
    }, [
        data,
        invoke,
        onClickCallback
    ]);
    return data ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $8bEg5.default), {
        ariaLabel: intl.formatMessage((0, $7wYyA.messages).copy_url_to_clipboard),
        content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $5cKiX.default), (0, $7wYyA.messages).copy_url_to_clipboard),
        icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($gRfjb))), {
            color: "currentColor",
            label: "",
            spacing: "spacious",
            size: props.iconSize
        }),
        onClick: onClick,
        testId: "smart-action-copy-link-action",
        tooltipMessage: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $5cKiX.default), tooltipMessage),
        tooltipOnHide: ()=>setTooltipMessage((0, $7wYyA.messages).copy_url_to_clipboard),
        hasNewContentOnTriggerClick: true,
        ...data,
        ...props
    }) : null;
};
var $74315f2203954d6a$export$2e2bcd8739ae039 = $74315f2203954d6a$var$CopyLinkAction;

});

parcelRegister("14on2", function(module, exports) {
$parcel$export(module.exports, "default", () => $5d1cd288e48b3267$export$2e2bcd8739ae039);
/* eslint-disable @repo/internal/deprecations/deprecation-ticket-required -- VOLTC-139 tracks removal of these deprecated re-export shims. */ 
var $eV1Lu = parcelRequire("eV1Lu");
var $5d1cd288e48b3267$export$2e2bcd8739ae039 = (0, $eV1Lu.CustomUnresolvedAction);

});
parcelRegister("eV1Lu", function(module, exports) {
$parcel$export(module.exports, "CustomUnresolvedAction", () => $854f44afb794f410$export$275b43513330d43b);
/* CustomUnresolvedAction.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $bSJIT = parcelRequire("bSJIT");

var $5cKiX = parcelRequire("5cKiX");

var $9PwDt = parcelRequire("9PwDt");

var $gXqq0 = parcelRequire("gXqq0");

var $5kJPq = parcelRequire("5kJPq");

var $eAoOt = parcelRequire("eAoOt");
const $854f44afb794f410$var$styles = {
    button: "_1e0c1bgi",
    message: "_1rjcze3t _18zrze3t"
};
const $854f44afb794f410$var$validErrorStatuses = [
    (0, $5kJPq.SmartLinkStatus).Forbidden,
    (0, $5kJPq.SmartLinkStatus).Unauthorized
];
const $854f44afb794f410$var$validateErrorStatus = (status)=>{
    return status !== undefined && $854f44afb794f410$var$validErrorStatuses.includes(status);
};
const $854f44afb794f410$var$getMessageDescriptor = (status, accessType, props)=>{
    var _props$status;
    if (!$854f44afb794f410$var$validateErrorStatus(status)) return undefined;
    const message = props === null || props === void 0 || (_props$status = props[status]) === null || _props$status === void 0 ? void 0 : _props$status[accessType ?? 'FALLBACK'];
    return message;
};
const $854f44afb794f410$export$275b43513330d43b = ({ testId: testId = 'custom-unresolved-action', onlyShowIfAction: onlyShowIfAction = false, Container: Container, ...props })=>{
    var _context$data, _context$data2;
    const context = (0, $eAoOt.useFlexibleCardContext)();
    const data = context === null || context === void 0 || (_context$data = context.data) === null || _context$data === void 0 || (_context$data = _context$data.actions) === null || _context$data === void 0 ? void 0 : _context$data[(0, $5kJPq.InternalActionName).UnresolvedAction];
    if (!data) return null;
    const { descriptor: descriptor, onClick: onClick, values: values } = data;
    const { status: status } = context;
    const accessType = context === null || context === void 0 || (_context$data2 = context.data) === null || _context$data2 === void 0 || (_context$data2 = _context$data2.meta) === null || _context$data2 === void 0 ? void 0 : _context$data2.accessType;
    const hasAction = onClick !== undefined;
    if (onlyShowIfAction && !hasAction) return null;
    const messageDescriptor = $854f44afb794f410$var$getMessageDescriptor(status, accessType, props) ?? descriptor;
    if (!messageDescriptor) return null;
    const message = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $9PwDt.Box), {
        testId: `${testId}-errored-view-message`,
        tabIndex: hasAction ? 0 : undefined,
        xcss: $854f44afb794f410$var$styles.message
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $5cKiX.default), {
        ...messageDescriptor,
        values: values
    }));
    const component = hasAction ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $gXqq0.Pressable), {
        onClick: data.onClick,
        style: {
            color: `inherit`,
            font: `inherit`,
            textAlign: `inherit`
        },
        xcss: $854f44afb794f410$var$styles.button
    }, message) : message;
    return Container ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement(Container, null, component) : component;
};

});


parcelRegister("8bLs2", function(module, exports) {
$parcel$export(module.exports, "default", () => $3271c2a59ae4dab5$export$2e2bcd8739ae039);

var $bSJIT = parcelRequire("bSJIT");

var $5cKiX = parcelRequire("5cKiX");

var $9dYEz = parcelRequire("9dYEz");

var $7wYyA = parcelRequire("7wYyA");

var $8bEg5 = parcelRequire("8bEg5");
const $3271c2a59ae4dab5$var$DeleteAction = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $8bEg5.default), {
        content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $5cKiX.default), (0, $7wYyA.messages).delete),
        icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($9dYEz))), {
            color: "currentColor",
            spacing: "spacious",
            label: "Delete"
        }),
        testId: "smart-action-delete-action",
        tooltipMessage: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $5cKiX.default), (0, $7wYyA.messages).delete),
        ...props
    });
var $3271c2a59ae4dab5$export$2e2bcd8739ae039 = $3271c2a59ae4dab5$var$DeleteAction;

});

parcelRegister("6StZP", function(module, exports) {
$parcel$export(module.exports, "default", () => $d1f98519d9789301$export$2e2bcd8739ae039);

var $bSJIT = parcelRequire("bSJIT");

var $5cKiX = parcelRequire("5cKiX");

var $3iMZX = parcelRequire("3iMZX");

var $5kJPq = parcelRequire("5kJPq");

var $7wYyA = parcelRequire("7wYyA");

var $7Z1Fb = parcelRequire("7Z1Fb");

var $2AqEC = parcelRequire("2AqEC");

var $8bEg5 = parcelRequire("8bEg5");
const $d1f98519d9789301$var$DownloadAction = ({ onClick: onClickCallback, ...props })=>{
    var _context$actions;
    const context = (0, $7Z1Fb.useFlexibleUiContext)();
    const invoke = (0, $2AqEC.default)({});
    const data = context === null || context === void 0 || (_context$actions = context.actions) === null || _context$actions === void 0 ? void 0 : _context$actions[(0, $5kJPq.ActionName).DownloadAction];
    const onClick = (0, $bSJIT.useCallback)(()=>{
        if (data !== null && data !== void 0 && data.invokeAction) {
            invoke(data.invokeAction);
            onClickCallback === null || onClickCallback === void 0 || onClickCallback();
        }
    }, [
        data,
        invoke,
        onClickCallback
    ]);
    const isStackItem = props.as === 'stack-item';
    const label = isStackItem ? (0, $7wYyA.messages).download_file : (0, $7wYyA.messages).download;
    const tooltipMessage = isStackItem ? (0, $7wYyA.messages).download_description : (0, $7wYyA.messages).download;
    return data ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $8bEg5.default), {
        content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $5cKiX.default), label),
        icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($3iMZX))), {
            spacing: "spacious",
            color: "currentColor",
            label: "Download"
        }),
        onClick: onClick,
        testId: "smart-action-download-action",
        tooltipMessage: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $5cKiX.default), tooltipMessage),
        ...data,
        ...props
    }) : null;
};
var $d1f98519d9789301$export$2e2bcd8739ae039 = $d1f98519d9789301$var$DownloadAction;

});

parcelRegister("8zn38", function(module, exports) {
$parcel$export(module.exports, "default", () => $8b1b1e98a502a735$export$2e2bcd8739ae039);

var $bSJIT = parcelRequire("bSJIT");

var $5cKiX = parcelRequire("5cKiX");

var $5Uddy = parcelRequire("5Uddy");

var $7wYyA = parcelRequire("7wYyA");

var $8bEg5 = parcelRequire("8bEg5");
const $8b1b1e98a502a735$var$EditAction = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $8bEg5.default), {
        content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $5cKiX.default), (0, $7wYyA.messages).edit),
        icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5Uddy))), {
            color: "currentColor",
            spacing: "spacious",
            label: "Edit"
        }),
        testId: "smart-action-edit-action",
        tooltipMessage: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $5cKiX.default), (0, $7wYyA.messages).edit),
        ...props
    });
var $8b1b1e98a502a735$export$2e2bcd8739ae039 = $8b1b1e98a502a735$var$EditAction;

});

parcelRegister("4iLYG", function(module, exports) {
$parcel$export(module.exports, "default", () => $6f8401ffddbe2e69$export$2e2bcd8739ae039);

var $bSJIT = parcelRequire("bSJIT");

var $5cKiX = parcelRequire("5cKiX");
var $4vLTk = parcelRequire("4vLTk");

var $87QgR = parcelRequire("87QgR");

var $5kJPq = parcelRequire("5kJPq");

var $7wYyA = parcelRequire("7wYyA");

var $7Z1Fb = parcelRequire("7Z1Fb");

var $jRrgb = parcelRequire("jRrgb");

var $hFiir = parcelRequire("hFiir");

var $jqWb3 = parcelRequire("jqWb3");


const $6f8401ffddbe2e69$var$importIconMapper = {
    goal: ()=>(parcelRequire("5rgtV")).then(({ GoalIcon: GoalIcon })=>({
                default: GoalIcon
            })),
    projects: ()=>(parcelRequire("b838Y")).then(({ ProjectsIcon: ProjectsIcon })=>({
                default: ProjectsIcon
            }))
};
const $6f8401ffddbe2e69$var$getIcon = (stackIconType)=>{
    const importFn = $6f8401ffddbe2e69$var$importIconMapper[stackIconType];
    if (!importFn) return null;
    return (0, $jRrgb.importIcon)(importFn);
};
const $6f8401ffddbe2e69$var$FollowAction = (props)=>{
    var _context$actions;
    const context = (0, $7Z1Fb.useFlexibleUiContext)();
    const intl = (0, $4vLTk.default)();
    const actionData = context === null || context === void 0 || (_context$actions = context.actions) === null || _context$actions === void 0 ? void 0 : _context$actions[(0, $5kJPq.ActionName).FollowAction];
    if (!context || !actionData) return null;
    const { value: value, isProject: isProject, ...data } = actionData;
    const isStackItem = props.as === 'stack-item';
    const message = value ? (0, $7wYyA.messages).follow : (0, $7wYyA.messages).unfollow;
    const projectMessage = value ? (0, $7wYyA.messages).follow_project : (0, $7wYyA.messages).unfollow_project;
    const goalMessage = value ? (0, $7wYyA.messages).follow_goal : (0, $7wYyA.messages).unfollow_goal;
    const stackMessage = isProject ? projectMessage : goalMessage;
    const label = isStackItem ? stackMessage : message;
    const projectTooltipMessage = value ? (0, $87QgR.default).getExperimentValue('project-terminology-refresh', 'isEnabled', false) ? (0, $7wYyA.messages).follow_project_descriptionGalaxia : (0, $7wYyA.messages).follow_project_description : (0, $87QgR.default).getExperimentValue('project-terminology-refresh', 'isEnabled', false) ? (0, $7wYyA.messages).unfollow_project_descriptionGalaxia : (0, $7wYyA.messages).unfollow_project_description;
    const goalTooltipMessage = value ? (0, $7wYyA.messages).follow_goal_description : (0, $7wYyA.messages).unfollow_goal_description;
    const stackTooltipMessage = isProject ? projectTooltipMessage : goalTooltipMessage;
    const tooltipMessage = isStackItem ? stackTooltipMessage : message;
    const stackIconType = isProject ? 'projects' : 'goal';
    const ImportedIcon = $6f8401ffddbe2e69$var$getIcon(stackIconType);
    const followIcon = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement(ImportedIcon, {
        label: "Follow",
        testId: `smart-action-follow-action-${stackIconType}-icon`
    });
    const handleError = ()=>{
        const { onError: onErrorCallback } = props;
        const errorMessage = (0, $jqWb3.getFollowActionErrorMessage)(isProject, value);
        onErrorCallback === null || onErrorCallback === void 0 || onErrorCallback({
            title: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $5cKiX.default), errorMessage),
            appearance: 'error'
        });
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $hFiir.default), {
        content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $5cKiX.default), label),
        ariaLabel: intl.formatMessage(label),
        icon: followIcon,
        testId: "smart-action-follow-action",
        tooltipMessage: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $5cKiX.default), tooltipMessage),
        ...data,
        ...props,
        onError: handleError
    });
};
var $6f8401ffddbe2e69$export$2e2bcd8739ae039 = $6f8401ffddbe2e69$var$FollowAction;

});
parcelRegister("jRrgb", function(module, exports) {
$parcel$export(module.exports, "importIcon", () => $e053119ba94f9ba7$export$6dc831e1a0a7a851);

var $deAR2 = parcelRequire("deAR2");
const $e053119ba94f9ba7$export$6dc831e1a0a7a851 = (importFn)=>{
    return (0, (/*@__PURE__*/$parcel$interopDefault($deAR2)))({
        loader: ()=>importFn().then((module)=>module.default),
        loading: ()=>null
    }); // Because we're using dynamic loading here, TS will not be able to infer the type.
};

});

parcelRegister("hFiir", function(module, exports) {
$parcel$export(module.exports, "default", () => $fa27b32b343ebfff$export$2e2bcd8739ae039);

var $bSJIT = parcelRequire("bSJIT");

var $2fwRK = parcelRequire("2fwRK");

var $bKqb0 = parcelRequire("bKqb0");

var $9VImP = parcelRequire("9VImP");

var $1Nceg = parcelRequire("1Nceg");

var $kK7cH = parcelRequire("kK7cH");

var $8bEg5 = parcelRequire("8bEg5");
const $fa27b32b343ebfff$var$ServerAction = ({ action: action, onClick: onClick, onError: onErrorCallback, ...props })=>{
    const [isLoading, setIsLoading] = (0, $bSJIT.useState)(false);
    const invoke = (0, $bKqb0.default)();
    const reload = (0, $1Nceg.default)();
    const { fireEvent: fireEvent } = (0, $2fwRK.useAnalyticsEvents)();
    const handleClick = (0, $bSJIT.useCallback)(async ()=>{
        if (action) {
            var _action$action;
            const smartLinkActionType = (_action$action = action.action) === null || _action$action === void 0 ? void 0 : _action$action.actionType;
            try {
                setIsLoading(true);
                if (smartLinkActionType === 'FollowEntityAction' || smartLinkActionType === 'UnfollowEntityAction') fireEvent('ui.button.clicked.smartLinkFollowButton', {});
                else fireEvent(`ui.button.clicked.${smartLinkActionType}`, {});
                fireEvent('track.smartLinkQuickAction.started', {
                    smartLinkActionType: smartLinkActionType
                });
                const request = (0, $kK7cH.default)(action);
                await invoke(request);
                fireEvent('track.smartLinkQuickAction.success', {
                    smartLinkActionType: smartLinkActionType
                });
                if (action.reload && action.reload.url) await reload({
                    url: action.reload.url,
                    isReloading: true,
                    id: action.reload.id
                });
                setIsLoading(false);
                if (onClick) onClick();
            } catch (err) {
                setIsLoading(false);
                fireEvent('track.smartLinkQuickAction.failed', {
                    smartLinkActionType: smartLinkActionType,
                    reason: (0, $9VImP.getInvokeFailureReason)(err)
                });
                onErrorCallback === null || onErrorCallback === void 0 || onErrorCallback();
            }
        }
    }, [
        action,
        invoke,
        onClick,
        onErrorCallback,
        reload,
        fireEvent
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $8bEg5.default), {
        ...props,
        isLoading: isLoading,
        onClick: handleClick
    });
};
var $fa27b32b343ebfff$export$2e2bcd8739ae039 = $fa27b32b343ebfff$var$ServerAction;

});
parcelRegister("bKqb0", function(module, exports) {
$parcel$export(module.exports, "default", () => $7d227ff9d9e7264a$export$2e2bcd8739ae039);

var $bSJIT = parcelRequire("bSJIT");

var $kZ6mk = parcelRequire("kZ6mk");

var $6bOBo = parcelRequire("6bOBo");
const $7d227ff9d9e7264a$var$useInvoke = ()=>{
    const { connections: connections } = (0, $6bOBo.useSmartLinkContext)();
    const clientExt = (0, $kZ6mk.useSmartLinkClientExtension)(connections.client);
    return (0, $bSJIT.useCallback)(async (req, cb)=>{
        const response = await clientExt.invoke(req);
        return cb ? cb(response) : response;
    }, [
        clientExt
    ]);
};
var $7d227ff9d9e7264a$export$2e2bcd8739ae039 = $7d227ff9d9e7264a$var$useInvoke;

});
parcelRegister("kZ6mk", function(module, exports) {
$parcel$export(module.exports, "useSmartLinkClientExtension", () => $37a5651d978e1b6d$export$303ede4eed148855);

var $bSJIT = parcelRequire("bSJIT");

var $hyP0z = parcelRequire("hyP0z");

var $6vGM1 = parcelRequire("6vGM1");

var $59hb7 = parcelRequire("59hb7");
const $37a5651d978e1b6d$export$303ede4eed148855 = (cardClient)=>{
    const resolverUrl = (0, $59hb7.useResolverUrl)(cardClient);
    const invoke = (0, $bSJIT.useCallback)(async (data)=>{
        try {
            return await (0, $hyP0z.request)('post', `${resolverUrl}/invoke`, data, undefined, [
                200,
                201,
                202,
                203,
                204
            ]);
        } catch (err) {
            // checking if the error is a Response type
            // since we already had a few HOTs caused by comparing with instanceOf',
            // we're verifying the type by the contents
            if (err && err.json && typeof err.json === 'function') {
                const errorBody = await err.json();
                if (errorBody) throw new (0, $6vGM1.InvokeError)(errorBody === null || errorBody === void 0 ? void 0 : errorBody.error.message, errorBody === null || errorBody === void 0 ? void 0 : errorBody.error.status);
            }
            throw err;
        }
    }, [
        resolverUrl
    ]);
    return (0, $bSJIT.useMemo)(()=>({
            invoke: invoke
        }), [
        invoke
    ]);
};

});
parcelRegister("6vGM1", function(module, exports) {
$parcel$export(module.exports, "SmartLinkActionType", () => $8ae278f8c54c8e1a$export$6324b7946ad663e9);
$parcel$export(module.exports, "InvokeError", () => $8ae278f8c54c8e1a$export$d4d72202bff63658);
/**
 * The enum that describes Smart Link action types
 */ var $8ae278f8c54c8e1a$export$6324b7946ad663e9 = /*#__PURE__*/ function(SmartLinkActionType) {
    SmartLinkActionType["FollowEntityAction"] = "FollowEntityAction";
    SmartLinkActionType["GetStatusTransitionsAction"] = "GetStatusTransitionsAction";
    SmartLinkActionType["StatusUpdateAction"] = "StatusUpdateAction";
    SmartLinkActionType["UnfollowEntityAction"] = "UnfollowEntityAction";
    return SmartLinkActionType;
}({});
class $8ae278f8c54c8e1a$export$d4d72202bff63658 extends Error {
    constructor(message, errorCode){
        super(message);
        this.errorCode = errorCode;
    }
}

});

parcelRegister("59hb7", function(module, exports) {
$parcel$export(module.exports, "useResolverUrl", () => $986b4cd7faf4768e$export$d08617a365fbe694);

var $bSJIT = parcelRequire("bSJIT");

var $9cVVq = parcelRequire("9cVVq");
const $986b4cd7faf4768e$export$d08617a365fbe694 = (cardClient)=>(0, $bSJIT.useMemo)(()=>(0, $9cVVq.getResolverUrl)(cardClient === null || cardClient === void 0 ? void 0 : cardClient.envKey, cardClient === null || cardClient === void 0 ? void 0 : cardClient.baseUrlOverride), [
        cardClient === null || cardClient === void 0 ? void 0 : cardClient.baseUrlOverride,
        cardClient === null || cardClient === void 0 ? void 0 : cardClient.envKey
    ]);

});



parcelRegister("9VImP", function(module, exports) {
$parcel$export(module.exports, "getInvokeFailureReason", () => $228f199cda1293ca$export$65b3f792dff0bd60);

var $2hVNZ = parcelRequire("2hVNZ");

var $4mdwW = parcelRequire("4mdwW");
const $228f199cda1293ca$export$65b3f792dff0bd60 = (err)=>{
    if (!(0, $4mdwW.isInvokeCustomError)(err)) return (0, $2hVNZ.TrackQuickActionFailureReason).UnknownError;
    switch(err === null || err === void 0 ? void 0 : err.errorCode){
        case 403:
            return (0, $2hVNZ.TrackQuickActionFailureReason).PermissionError;
        default:
            return (0, $2hVNZ.TrackQuickActionFailureReason).UnknownError;
    }
};

});
parcelRegister("4mdwW", function(module, exports) {
$parcel$export(module.exports, "isInvokeCustomError", () => $1eef854b22095b4e$export$1694272377fa07d8);
const $1eef854b22095b4e$export$1694272377fa07d8 = (err)=>(err === null || err === void 0 ? void 0 : err.message) !== undefined && (err === null || err === void 0 ? void 0 : err.errorCode) !== undefined;

});


parcelRegister("kK7cH", function(module, exports) {
$parcel$export(module.exports, "default", () => $0703963b336619c5$export$2e2bcd8739ae039);
const $0703963b336619c5$var$createInvokeRequest = (request, payload)=>({
        action: {
            ...request.action,
            payload: payload
        },
        providerKey: request.providerKey
    });
var $0703963b336619c5$export$2e2bcd8739ae039 = $0703963b336619c5$var$createInvokeRequest;

});


parcelRegister("jqWb3", function(module, exports) {
$parcel$export(module.exports, "getFollowActionErrorMessage", () => $0315a905acba9d57$export$49248678d3914625);

var $87QgR = parcelRequire("87QgR");

var $7wYyA = parcelRequire("7wYyA");
const $0315a905acba9d57$export$49248678d3914625 = (isProject = false, isFollow = false)=>{
    if (isProject && isFollow) return (0, $87QgR.default).getExperimentValue('project-terminology-refresh', 'isEnabled', false) ? (0, $7wYyA.messages).follow_project_errorGalaxia : (0, $7wYyA.messages).follow_project_error;
    if (isProject && !isFollow) return (0, $87QgR.default).getExperimentValue('project-terminology-refresh', 'isEnabled', false) ? (0, $7wYyA.messages).unfollow_project_errorGalaxia : (0, $7wYyA.messages).unfollow_project_error;
    if (!isProject && isFollow) return (0, $7wYyA.messages).follow_goal_error;
    if (!isProject && !isFollow) return (0, $7wYyA.messages).unfollow_goal_error;
    return (0, $7wYyA.messages).generic_error_message;
};

});

parcelRegister("5rgtV", function(module, exports) {

var $kOunM = parcelRequire("kOunM");
module.exports = Promise.all([
    $kOunM("fT3ez"),
    $kOunM("djfnW")
]).then(()=>parcelRequire('l5aaP'));

});

parcelRegister("b838Y", function(module, exports) {

var $kOunM = parcelRequire("kOunM");
module.exports = Promise.all([
    $kOunM("6QYMh"),
    $kOunM("7CAS7")
]).then(()=>parcelRequire('3bBWi'));

});


parcelRegister("4uDT5", function(module, exports) {
$parcel$export(module.exports, "default", () => $598173c557f0ae0b$export$2e2bcd8739ae039);

var $bSJIT = parcelRequire("bSJIT");

var $5cKiX = parcelRequire("5cKiX");
var $4vLTk = parcelRequire("4vLTk");

var $j7FKK = parcelRequire("j7FKK");

var $hpM3n = parcelRequire("hpM3n");

var $5N1Y4 = parcelRequire("5N1Y4");

var $5kJPq = parcelRequire("5kJPq");

var $7wYyA = parcelRequire("7wYyA");

var $7Z1Fb = parcelRequire("7Z1Fb");

var $2AqEC = parcelRequire("2AqEC");

var $8bEg5 = parcelRequire("8bEg5");
const $598173c557f0ae0b$var$PreviewAction = ({ onClick: onClickCallback, ...props })=>{
    var _context$actions;
    const intl = (0, $4vLTk.default)();
    const context = (0, $7Z1Fb.useFlexibleUiContext)();
    const invoke = (0, $2AqEC.default)({});
    const data = context === null || context === void 0 || (_context$actions = context.actions) === null || _context$actions === void 0 ? void 0 : _context$actions[(0, $5kJPq.ActionName).PreviewAction];
    const hasPreviewPanel = data === null || data === void 0 ? void 0 : data.hasPreviewPanel;
    const onClick = (0, $bSJIT.useCallback)(()=>{
        if (data !== null && data !== void 0 && data.invokeAction) {
            invoke(data.invokeAction);
            onClickCallback === null || onClickCallback === void 0 || onClickCallback();
        }
    }, [
        data,
        invoke,
        onClickCallback
    ]);
    const isStackItem = props.as === 'stack-item';
    const tooltipMessage = isStackItem ? (0, $7wYyA.messages).preview_description : (0, $7wYyA.messages).preview_improved;
    const actionIcon = (0, $bSJIT.useCallback)(()=>{
        // Only use panel icon if experiment is enabled and hasPreviewPanel is true
        if ((0, $5N1Y4.expValEquals)('platform_hover_card_preview_panel', 'cohort', 'test') && hasPreviewPanel) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($hpM3n))), {
            color: "currentColor",
            spacing: "spacious",
            label: "",
            size: props.iconSize
        });
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($j7FKK))), {
            color: "currentColor",
            spacing: "spacious",
            label: "",
            size: props.iconSize
        });
    }, [
        hasPreviewPanel,
        props.iconSize
    ]);
    const actionLabel = (0, $bSJIT.useMemo)(()=>{
        // Only use panel message if experiment is enabled and hasPreviewPanel is true
        if ((0, $5N1Y4.expValEquals)('platform_hover_card_preview_panel', 'cohort', 'test') && hasPreviewPanel) return (0, $7wYyA.messages).preview_panel;
        // Fall back to modal message if experiment is enabled, otherwise use original preview message
        if ((0, $5N1Y4.expValEquals)('platform_hover_card_preview_panel', 'cohort', 'test')) return (0, $7wYyA.messages).preview_modal;
        return (0, $7wYyA.messages).preview_improved;
    }, [
        hasPreviewPanel
    ]);
    const actionMessage = intl.formatMessage(actionLabel);
    return data ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $8bEg5.default), {
        ariaLabel: actionMessage,
        content: actionMessage,
        icon: actionIcon(),
        onClick: onClick,
        testId: "smart-action-preview-action",
        tooltipMessage: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $5cKiX.default), tooltipMessage),
        hideTooltipOnMouseDown: true,
        ...data,
        ...props
    }) : null;
};
var $598173c557f0ae0b$export$2e2bcd8739ae039 = $598173c557f0ae0b$var$PreviewAction;

});

parcelRegister("kXAHP", function(module, exports) {
$parcel$export(module.exports, "default", () => $daaa646836989a97$export$2e2bcd8739ae039);

var $bSJIT = parcelRequire("bSJIT");

var $4vLTk = parcelRequire("4vLTk");

var $5kJPq = parcelRequire("5kJPq");

var $7Z1Fb = parcelRequire("7Z1Fb");

var $2AqEC = parcelRequire("2AqEC");

var $1A0Oh = parcelRequire("1A0Oh");

var $4xVXc = parcelRequire("4xVXc");

var $8bEg5 = parcelRequire("8bEg5");
const $daaa646836989a97$var$DEFAULT_PROMPTS = [];
const $daaa646836989a97$var$RovoChatAction = ({ onClick: onClickCallback, prompts: prompts, testId: testId = 'smart-action-rovo-chat-action', ...props })=>{
    var _context$actions;
    const intl = (0, $4vLTk.default)();
    const { isRovoChatEnabled: isRovoChatEnabled, sendPromptMessage: sendPromptMessage } = (0, $1A0Oh.default)();
    const context = (0, $7Z1Fb.useFlexibleUiContext)();
    const data = context === null || context === void 0 || (_context$actions = context.actions) === null || _context$actions === void 0 ? void 0 : _context$actions[(0, $5kJPq.ActionName).RovoChatAction];
    const resolvedPrompts = (0, $bSJIT.useMemo)(()=>{
        if (prompts) return prompts;
        return $daaa646836989a97$var$DEFAULT_PROMPTS;
    }, [
        prompts
    ]);
    const invoke = (0, $2AqEC.default)({});
    const onClick = (0, $bSJIT.useCallback)((promptData, promptKey)=>{
        if (promptData && data !== null && data !== void 0 && data.invokeAction) {
            invoke({
                ...data === null || data === void 0 ? void 0 : data.invokeAction,
                actionFn: async ()=>sendPromptMessage(promptData),
                prompt: promptKey
            });
            onClickCallback === null || onClickCallback === void 0 || onClickCallback();
        }
    }, [
        data === null || data === void 0 ? void 0 : data.invokeAction,
        invoke,
        onClickCallback,
        sendPromptMessage
    ]);
    const promptActions = (0, $bSJIT.useMemo)(()=>{
        return resolvedPrompts.map((promptKey, idx)=>{
            const { icon: icon, content: content, tooltipMessage: tooltipMessage, data: promptData } = (0, $4xVXc.getPromptAction)({
                promptKey: promptKey,
                intl: intl,
                url: data === null || data === void 0 ? void 0 : data.url,
                product: data === null || data === void 0 ? void 0 : data.product,
                iconSize: props.iconSize,
                cardAppearance: props.cardAppearance
            }) || {};
            return promptData ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $8bEg5.default), {
                content: content,
                icon: icon,
                key: promptKey,
                onClick: ()=>onClick(promptData, promptKey),
                testId: `${testId}-${idx + 1}`,
                tooltipMessage: tooltipMessage,
                ...props
            }) : null;
        });
    }, [
        data,
        intl,
        onClick,
        resolvedPrompts,
        props,
        testId
    ]);
    return isRovoChatEnabled && data && (promptActions === null || promptActions === void 0 ? void 0 : promptActions.length) > 0 ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).Fragment, null, promptActions) : null;
};
var $daaa646836989a97$export$2e2bcd8739ae039 = $daaa646836989a97$var$RovoChatAction;

});
parcelRegister("1A0Oh", function(module, exports) {
$parcel$export(module.exports, "default", () => $d64d16f736c74bec$export$2e2bcd8739ae039);

var $bSJIT = parcelRequire("bSJIT");

var $8gobf = parcelRequire("8gobf");

var $1R1LG = parcelRequire("1R1LG");

var $cUXyD = parcelRequire("cUXyD");
const $d64d16f736c74bec$var$SMART_LINK_TO_ROVO_SOURCE = 'smart-link';
const $d64d16f736c74bec$var$useRovoChat = ()=>{
    const { rovoOptions: config } = (0, $cUXyD.default)();
    const { publishWithPostMessage: publishWithPostMessage } = (0, $8gobf.useRovoPostMessageToPubsub)();
    const isRovoChatEnabled = (0, $1R1LG.getIsRovoChatEnabled)(config);
    const sendPromptMessage = (0, $bSJIT.useCallback)((data)=>{
        publishWithPostMessage({
            targetWindow: window.parent ?? window,
            payload: {
                type: 'chat-new',
                source: $d64d16f736c74bec$var$SMART_LINK_TO_ROVO_SOURCE,
                data: {
                    dialogues: [],
                    ...data,
                    agentId: undefined
                },
                openChat: true,
                openChatMode: 'sidebar'
            },
            onAcknowledgeTimeout: ()=>{
            // NAVX-3599: Add analytics event
            }
        });
    }, [
        publishWithPostMessage
    ]);
    return (0, $bSJIT.useMemo)(()=>({
            isRovoChatEnabled: isRovoChatEnabled,
            sendPromptMessage: sendPromptMessage
        }), [
        isRovoChatEnabled,
        sendPromptMessage
    ]);
};
var $d64d16f736c74bec$export$2e2bcd8739ae039 = $d64d16f736c74bec$var$useRovoChat;

});


parcelRegister("j04u5", function(module, exports) {
$parcel$export(module.exports, "default", () => $b345e84fe3d2ac97$export$2e2bcd8739ae039);

var $bSJIT = parcelRequire("bSJIT");

var $5cKiX = parcelRequire("5cKiX");

var $2fwRK = parcelRequire("2fwRK");

var $7wYyA = parcelRequire("7wYyA");

var $7Z1Fb = parcelRequire("7Z1Fb");

var $8MP27 = parcelRequire("8MP27");

var $8bEg5 = parcelRequire("8bEg5");

var $UmTP6 = parcelRequire("UmTP6");

const $b345e84fe3d2ac97$var$RelatedLinksModal = /*#__PURE__*/ (0, $bSJIT.lazy)(()=>(parcelRequire("8xFD2")));
const $b345e84fe3d2ac97$var$ViewRelatedLinksAction = ({ onClick: onClickCallback, ...props })=>{
    var _context$actions;
    const modal = (0, $8MP27.useSmartLinkModal)();
    const context = (0, $7Z1Fb.useFlexibleUiContext)();
    const actionData = context === null || context === void 0 || (_context$actions = context.actions) === null || _context$actions === void 0 ? void 0 : _context$actions.ViewRelatedLinksAction;
    const { fireEvent: fireEvent } = (0, $2fwRK.useAnalyticsEvents)();
    const onClick = (0, $bSJIT.useCallback)(()=>{
        const ari = actionData === null || actionData === void 0 ? void 0 : actionData.ari;
        if (ari) modal.open(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement($b345e84fe3d2ac97$var$RelatedLinksModal, {
            ari: ari,
            showModal: true,
            onClose: ()=>modal.close()
        }));
        fireEvent('ui.button.clicked.relatedLinks', {});
        onClickCallback === null || onClickCallback === void 0 || onClickCallback();
    }, [
        actionData === null || actionData === void 0 ? void 0 : actionData.ari,
        fireEvent,
        modal,
        onClickCallback
    ]);
    return actionData ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $8bEg5.default), {
        content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $5cKiX.default), (0, $7wYyA.messages).related_links_view_related_links),
        tooltipMessage: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $5cKiX.default), (0, $7wYyA.messages).related_links_view_related_links),
        icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $UmTP6.default), {
            iconSize: props.iconSize
        }),
        onClick: onClick,
        testId: "smart-action-view-related-links-action",
        ariaLabel: "View most recent pages or content types coming from or found on this link",
        ...props
    }) : null;
};
var $b345e84fe3d2ac97$export$2e2bcd8739ae039 = $b345e84fe3d2ac97$var$ViewRelatedLinksAction;

});
parcelRegister("UmTP6", function(module, exports) {
$parcel$export(module.exports, "default", () => $4cf433c5c89e797f$export$2e2bcd8739ae039);

var $bSJIT = parcelRequire("bSJIT");

var $87EHs = parcelRequire("87EHs");
const $4cf433c5c89e797f$var$RelatedLinksActionIcon = ({ iconSize: iconSize })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($87EHs))), {
        color: "currentColor",
        spacing: "spacious",
        label: '',
        size: iconSize
    });
var $4cf433c5c89e797f$export$2e2bcd8739ae039 = $4cf433c5c89e797f$var$RelatedLinksActionIcon;

});

parcelRegister("8xFD2", function(module, exports) {

var $kOunM = parcelRequire("kOunM");
module.exports = $kOunM("MFc9R").then(()=>parcelRequire('8QRHN'));

});




parcelRegister("bUztx", function(module, exports) {
$parcel$export(module.exports, "default", () => $c3d394d084e17660$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $bSJIT = parcelRequire("bSJIT");

var $9PwDt = parcelRequire("9PwDt");

var $5kJPq = parcelRequire("5kJPq");

var $7Z1Fb = parcelRequire("7Z1Fb");

var $hkXpb = parcelRequire("hkXpb");

var $lgzQp = parcelRequire("lgzQp");

var $8dLhi = parcelRequire("8dLhi");

var $94O41 = parcelRequire("94O41");
const $c3d394d084e17660$var$styles = {
    titleBoxCard: "_1e0c1txw _2lx2vrvc _4cvr1h6o _1bsb1osq"
};
/**
 * Represents an Errored TitleBlock view.
 * This will render when a Smart Link did not successfully resolve.
 * This may be a result of a Smart Link not having the correct credentials,
 * or the backend response was errored or malformed.
 * @see TitleBlock
 */ const $c3d394d084e17660$var$TitleBlockErroredView = ({ actionGroup: actionGroup, hideRetry: hideRetry, retry: _retry, position: position, testId: testId, title: title, icon: icon, hideIcon: hideIcon, CompetitorPrompt: CompetitorPrompt, ...blockProps })=>{
    var _context$actions;
    const context = (0, $7Z1Fb.useFlexibleUiContext)();
    const showRetry = !hideRetry && Boolean(context === null || context === void 0 || (_context$actions = context.actions) === null || _context$actions === void 0 ? void 0 : _context$actions[(0, $5kJPq.InternalActionName).UnresolvedAction]);
    const competitorPrompt = CompetitorPrompt && context !== null && context !== void 0 && context.url ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement(CompetitorPrompt, {
        sourceUrl: context === null || context === void 0 ? void 0 : context.url,
        linkType: 'card'
    }) : null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $8dLhi.default), {
        ...blockProps,
        testId: `${testId}-errored-view`
    }, !hideIcon && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $lgzQp.default), {
        overrideIcon: icon,
        position: position
    }), competitorPrompt ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $9PwDt.Box), {
        xcss: $c3d394d084e17660$var$styles.titleBoxCard
    }, title, competitorPrompt) : title, showRetry && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $94O41.default), {
        align: (0, $5kJPq.SmartLinkAlignment).Right
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $hkXpb.default), {
        testId: testId
    })), actionGroup);
};
var $c3d394d084e17660$export$2e2bcd8739ae039 = $c3d394d084e17660$var$TitleBlockErroredView;

});
parcelRegister("hkXpb", function(module, exports) {
$parcel$export(module.exports, "default", () => $53edc01748cffaae$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v3.0.2 */ /* index.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $bSJIT = parcelRequire("bSJIT");

var $5cKiX = parcelRequire("5cKiX");

var $jDsoo = parcelRequire("jDsoo");

var $9PwDt = parcelRequire("9PwDt");

var $gXqq0 = parcelRequire("gXqq0");

var $5kJPq = parcelRequire("5kJPq");

var $7Z1Fb = parcelRequire("7Z1Fb");
const $53edc01748cffaae$var$styles = {
    button: "_1e0c1bgi",
    padding: "_18zrutpp",
    message: "_1rjcze3t _18zrze3t"
};
const $53edc01748cffaae$var$UnresolvedAction = ({ testId: testId = 'unresolved-action', hasPadding: hasPadding = false })=>{
    var _context$actions;
    const context = (0, $7Z1Fb.useFlexibleUiContext)();
    const data = context === null || context === void 0 || (_context$actions = context.actions) === null || _context$actions === void 0 ? void 0 : _context$actions[(0, $5kJPq.InternalActionName).UnresolvedAction];
    if (!data) return null;
    const { descriptor: descriptor, onClick: onClick, values: values } = data;
    const hasAction = onClick !== undefined;
    const message = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $9PwDt.Box), {
        testId: `${testId}-errored-view-message`,
        tabIndex: hasAction ? 0 : undefined,
        xcss: (0, $jDsoo.cx)($53edc01748cffaae$var$styles.message, hasPadding && $53edc01748cffaae$var$styles.padding)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $5cKiX.default), {
        ...descriptor,
        values: values
    }));
    return hasAction ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $gXqq0.Pressable), {
        onClick: data.onClick,
        style: {
            color: `inherit`,
            font: `inherit`,
            textAlign: `inherit`
        },
        xcss: $53edc01748cffaae$var$styles.button
    }, message) : message;
};
var $53edc01748cffaae$export$2e2bcd8739ae039 = $53edc01748cffaae$var$UnresolvedAction;

});

parcelRegister("lgzQp", function(module, exports) {
$parcel$export(module.exports, "default", () => $454f516cfdb4fb17$export$2e2bcd8739ae039);

var $bSJIT = parcelRequire("bSJIT");

var $5kJPq = parcelRequire("5kJPq");

var $7Z1Fb = parcelRequire("7Z1Fb");

var $836bz = parcelRequire("836bz");
var $8gJWv = parcelRequire("8gJWv");

var $7cMTd = parcelRequire("7cMTd");
const $454f516cfdb4fb17$var$LinkIconElement = (props)=>{
    var _context$meta, _context$type, _linkIconProps$label, _context$meta2, _linkIconProps$label2;
    const context = (0, $7Z1Fb.useFlexibleUiContext)();
    if (!context) return null;
    const linkIconProps = (0, $8gJWv.toLinkIconProps)(context === null || context === void 0 ? void 0 : context.linkIcon, context.type);
    if (!linkIconProps) return null;
    const jiraIssueTypeLabel = ((_context$meta = context.meta) === null || _context$meta === void 0 ? void 0 : _context$meta.resourceType) === 'issue' && (_context$type = context.type) !== null && _context$type !== void 0 && _context$type.includes('atlassian:Task') ? (_linkIconProps$label = linkIconProps.label) === null || _linkIconProps$label === void 0 ? void 0 : _linkIconProps$label.trim() : undefined;
    const label = jiraIssueTypeLabel ?? (0, $7cMTd.resourceTypeToLabel)((_context$meta2 = context.meta) === null || _context$meta2 === void 0 ? void 0 : _context$meta2.resourceType) ?? ((_linkIconProps$label2 = linkIconProps.label) === null || _linkIconProps$label2 === void 0 ? void 0 : _linkIconProps$label2.trim()) ?? props.label;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $836bz.default), {
        ...linkIconProps,
        ...props,
        label: label,
        name: (0, $5kJPq.ElementName).LinkIcon
    });
};
var $454f516cfdb4fb17$export$2e2bcd8739ae039 = $454f516cfdb4fb17$var$LinkIconElement;

});
parcelRegister("836bz", function(module, exports) {
$parcel$export(module.exports, "default", () => $65c0c3975c49ecb5$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v3.0.2 */ /* eslint-disable @compiled/shorthand-property-sorting */ /* eslint-disable @atlaskit/design-system/use-tokens-typography */ /* eslint-disable @atlaskit/ui-styling-standard/no-nested-selectors */ 
var $bSJIT = parcelRequire("bSJIT");

var $9fU1q = parcelRequire("9fU1q");

var $gRfjb = parcelRequire("gRfjb");

var $gdUUy = parcelRequire("gdUUy");

var $9PwDt = parcelRequire("9PwDt");

var $4VsjU = parcelRequire("4VsjU");

var $5kJPq = parcelRequire("5kJPq");

var $1kLa3 = parcelRequire("1kLa3");

var $9YTee = parcelRequire("9YTee");

var $b2mmI = parcelRequire("b2mmI");
const $65c0c3975c49ecb5$var$styles = {
    container: "_1ul91ns9",
    iconWrapperStyle: "_1e0c1txw _4cvr1h6o _1bah1h6o"
};
const $65c0c3975c49ecb5$var$positionStyleMap = {
    center: "_1wpz1h6o",
    top: "_19pkidpf _2hwxidpf _otyridpf _18u0idpf _1wpz1y6m"
};
const $65c0c3975c49ecb5$var$customRenderStyleMap = {
    xlarge: "_1reo15vq _18m915vq _11c810sd _1e0ccj1k _1nmz1hna _1yyjkb7n _y3gn1h6o _1btozryt _sudpn7od _1ipkidpf _1kdcidpf _3glyidpf _1w2uidpf _1oh2idpf _99ztidpf _1m2uidpf _9n9oidpf _e4km1q9y _1xjx1osq _e2oo1osq _102kz42d",
    large: "_1reo15vq _18m915vq _11c810sd _1e0ccj1k _1nmz1hna _1yyjkb7n _y3gn1h6o _1btozryt _sudpn7od _1ipkidpf _1kdcidpf _3glyidpf _1w2uidpf _1oh2idpf _99ztidpf _1m2uidpf _9n9oidpf _e4km1q9y _1xjx1osq _e2oo1osq _102kz42d",
    medium: "_1reo15vq _18m915vq _11c81e3o _1e0ccj1k _1nmz1hna _1yyjkb7n _y3gn1h6o _1btozryt _sudpn7od _1ipkidpf _1kdcidpf _3glyidpf _1w2uidpf _1oh2idpf _99ztidpf _1m2uidpf _9n9oidpf _e4km1q9y _1xjx1osq _e2oo1osq _102kptym",
    small: "_1reo15vq _18m915vq _11c81e3o _1e0ccj1k _1nmz1hna _1yyjkb7n _y3gn1h6o _1btozryt _sudpn7od _1ipkidpf _1kdcidpf _3glyidpf _1w2uidpf _1oh2idpf _99ztidpf _1m2uidpf _9n9oidpf _e4km1q9y _1xjx1osq _e2oo1osq _102kptym"
};
const $65c0c3975c49ecb5$var$renderAtlaskitIcon = (icon, testId, size = (0, $5kJPq.SmartLinkSize).Medium, label, isTiledIcon)=>{
    if (icon) return /*#__PURE__*/ $bSJIT.createElement((0, $9YTee.default), {
        icon: icon,
        testId: `${testId}-icon`,
        label: label,
        size: size,
        isTiledIcon: isTiledIcon
    });
};
const $65c0c3975c49ecb5$var$renderDefaultIcon = (label, testId)=>/*#__PURE__*/ $bSJIT.createElement((0, (/*@__PURE__*/$parcel$interopDefault($gRfjb))), {
        label: label,
        testId: `${testId}-default`,
        color: "currentColor"
    });
const $65c0c3975c49ecb5$var$widthFromSize = (size, isTiledIcon)=>{
    switch(size){
        case (0, $5kJPq.SmartLinkSize).XLarge:
            return "var(--ds-space-300, 24px)";
        case (0, $5kJPq.SmartLinkSize).Large:
            return "var(--ds-space-300, 24px)";
        case (0, $5kJPq.SmartLinkSize).Medium:
            return isTiledIcon ? "var(--ds-space-250, 20px)" : "var(--ds-space-200, 16px)";
        case (0, $5kJPq.SmartLinkSize).Small:
            return "var(--ds-space-200, 16px)";
        default:
            return "var(--ds-space-200, 16px)";
    }
};
const $65c0c3975c49ecb5$var$renderImageIcon = (defaultIcon, url, testId, size = (0, $5kJPq.SmartLinkSize).Medium, appearance, hideLoadingSkeleton, label)=>{
    const width = size === (0, $5kJPq.SmartLinkSize).Large ? "var(--ds-space-300, 24px)" : "var(--ds-space-200, 16px)";
    if (url) return /*#__PURE__*/ $bSJIT.createElement((0, $1kLa3.default), {
        label: label,
        defaultIcon: defaultIcon,
        testId: testId,
        url: url,
        width: width,
        height: width,
        appearance: appearance,
        hideLoadingSkeleton: hideLoadingSkeleton
    });
};
const $65c0c3975c49ecb5$var$renderImageIconNew = (defaultIcon, url, testId, size = (0, $5kJPq.SmartLinkSize).Medium, appearance, hideLoadingSkeleton, label, isTiledIcon = false)=>{
    const width = $65c0c3975c49ecb5$var$widthFromSize(size, isTiledIcon);
    if (url) return /*#__PURE__*/ $bSJIT.createElement((0, $1kLa3.default), {
        label: label,
        defaultIcon: defaultIcon,
        testId: testId,
        url: url,
        width: width,
        height: width,
        appearance: appearance,
        hideLoadingSkeleton: hideLoadingSkeleton
    });
};
/**
 * A base element that displays an Icon or favicon.
 * @internal
 * @param props - The props necessary for the Icon element.
 * @see LinkIcon
 */ const $65c0c3975c49ecb5$var$IconElement = ({ icon: icon, overrideIcon: overrideIcon, label: labelProp, name: name, position: position = (0, $5kJPq.SmartLinkPosition).Top, className: className, render: render, size: size = (0, $5kJPq.SmartLinkSize).Medium, testId: testId = 'smart-element-icon', url: url, appearance: appearance = 'square', hideLoadingSkeleton: hideLoadingSkeleton, isTiledIcon: isTiledIcon })=>{
    const label = labelProp ?? '';
    const element = (0, $bSJIT.useMemo)(()=>{
        const defaultIcon = $65c0c3975c49ecb5$var$renderDefaultIcon(label, testId);
        return overrideIcon || (render === null || render === void 0 ? void 0 : render()) || ((0, $gdUUy.fg)('platform_sl_3p_preauth_better_hovercard_killswitch') ? $65c0c3975c49ecb5$var$renderImageIconNew(defaultIcon, url, testId, size, appearance, hideLoadingSkeleton, label, isTiledIcon) : $65c0c3975c49ecb5$var$renderImageIcon(defaultIcon, url, testId, size, appearance, hideLoadingSkeleton, label)) || $65c0c3975c49ecb5$var$renderAtlaskitIcon(icon, testId, size, label, isTiledIcon) || defaultIcon;
    }, [
        label,
        testId,
        overrideIcon,
        render,
        url,
        size,
        appearance,
        hideLoadingSkeleton,
        icon,
        isTiledIcon
    ]);
    const width = (0, $b2mmI.getIconWidth)(size);
    return /*#__PURE__*/ $bSJIT.createElement("div", {
        "data-smart-element": name,
        "data-smart-element-icon": true,
        "data-testid": testId,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
        className: (0, $9fU1q.default)([
            $65c0c3975c49ecb5$var$styles.container,
            $65c0c3975c49ecb5$var$positionStyleMap[position],
            render && $65c0c3975c49ecb5$var$customRenderStyleMap[size],
            className
        ])
    }, isTiledIcon ? // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage -- the rule does not yet recognise @atlaskit/primitives subpath entry points
    /*#__PURE__*/ $bSJIT.createElement((0, $4VsjU.default), {
        size: size,
        hasBorder: true,
        backgroundColor: "white",
        label: label,
        testId: `${testId}-tile`
    }, element) : /*#__PURE__*/ $bSJIT.createElement((0, $9PwDt.Box), {
        xcss: $65c0c3975c49ecb5$var$styles.iconWrapperStyle,
        testId: `${testId}-box`,
        style: {
            width: width,
            height: width
        }
    }, element));
};
var $65c0c3975c49ecb5$export$2e2bcd8739ae039 = $65c0c3975c49ecb5$var$IconElement;

});
parcelRegister("9YTee", function(module, exports) {
$parcel$export(module.exports, "default", () => $7334a35b4c97535a$export$2e2bcd8739ae039);

var $bSJIT = parcelRequire("bSJIT");

var $deAR2 = parcelRequire("deAR2");

var $67YKA = parcelRequire("67YKA");

var $4eIWR = parcelRequire("4eIWR");

var $jSH6l = parcelRequire("jSH6l");

var $gdUUy = parcelRequire("gdUUy");

var $30UCz = parcelRequire("30UCz");

var $5kJPq = parcelRequire("5kJPq");

var $8qanF = parcelRequire("8qanF");

var $aDlsY = parcelRequire("aDlsY");
const $7334a35b4c97535a$var$getIconImportFn = (icon, size)=>{
    const item = (0, $8qanF.getLazyIcons)()[icon];
    if ((0, $aDlsY.isIconSizeLarge)(size) && item !== null && item !== void 0 && item.large) return item.large;
    return item === null || item === void 0 ? void 0 : item.default;
};
const $7334a35b4c97535a$var$importIcon = (importFn)=>{
    return (0, (/*@__PURE__*/$parcel$interopDefault($deAR2)))({
        loader: ()=>importFn().then((module)=>module.default),
        loading: ()=>null
    }); // Because we're using dynamic loading here, TS will not be able to infer the type.
};

const $7334a35b4c97535a$var$getBlogIcon = ()=>(parcelRequire("8BZ9Q")).default;

const $7334a35b4c97535a$var$getDocumentIcon = ()=>(parcelRequire("iZe2v")).default;

const $7334a35b4c97535a$var$getLiveDocumentIcon = ()=>(parcelRequire("5YS12")).default;
const $7334a35b4c97535a$var$PRIORITY_ICONS = [
    (0, $5kJPq.IconType).PriorityBlocker,
    (0, $5kJPq.IconType).PriorityCritical,
    (0, $5kJPq.IconType).PriorityHigh,
    (0, $5kJPq.IconType).PriorityHighest,
    (0, $5kJPq.IconType).PriorityLow,
    (0, $5kJPq.IconType).PriorityLowest,
    (0, $5kJPq.IconType).PriorityMajor,
    (0, $5kJPq.IconType).PriorityMedium,
    (0, $5kJPq.IconType).PriorityMinor,
    (0, $5kJPq.IconType).PriorityTrivial
];
const $7334a35b4c97535a$var$isCoreIcon = (icon)=>{
    return [
        (0, $5kJPq.IconType).Project,
        (0, $5kJPq.IconType).Template,
        (0, $5kJPq.IconType).Forbidden,
        (0, $5kJPq.IconType).Default,
        (0, $5kJPq.IconType).Error,
        (0, $5kJPq.IconType).Attachment,
        (0, $5kJPq.IconType).CheckItem,
        (0, $5kJPq.IconType).Component,
        (0, $5kJPq.IconType).Comment,
        (0, $5kJPq.IconType).View,
        (0, $5kJPq.IconType).React,
        (0, $5kJPq.IconType).Vote,
        (0, $5kJPq.IconType).PriorityUndefined,
        (0, $5kJPq.IconType).ProgrammingLanguage,
        (0, $5kJPq.IconType).Subscriber,
        (0, $5kJPq.IconType).SubTasksProgress,
        ...$7334a35b4c97535a$var$PRIORITY_ICONS
    ].includes(icon);
};
const $7334a35b4c97535a$var$AtlaskitIcon = ({ icon: icon, label: label, testId: testId, size: size = (0, $5kJPq.SmartLinkSize).Medium, isTiledIcon: isTiledIcon })=>{
    // Intentionally keep these three icon types synchronous and outside lazy imports.
    // These icons should be present in SSR markup so hydration does not cause a
    // visible empty-state-then-pop-in transition in Smart Link consumers.
    switch(icon){
        case (0, $5kJPq.IconType).Document:
            {
                const DocumentIcon = $7334a35b4c97535a$var$getDocumentIcon();
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement(DocumentIcon, {
                    label: label ?? 'document',
                    testId: testId,
                    size: size,
                    isTiledIcon: isTiledIcon
                });
            }
        case (0, $5kJPq.IconType).Blog:
            {
                const BlogIcon = $7334a35b4c97535a$var$getBlogIcon();
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement(BlogIcon, {
                    label: label ?? 'blog',
                    testId: testId,
                    size: size,
                    isTiledIcon: isTiledIcon
                });
            }
        case (0, $5kJPq.IconType).LiveDocument:
            {
                const LiveDocumentIcon = $7334a35b4c97535a$var$getLiveDocumentIcon();
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement(LiveDocumentIcon, {
                    label: label ?? 'live-doc',
                    testId: testId,
                    size: size,
                    isTiledIcon: isTiledIcon
                });
            }
    }
    const importFn = $7334a35b4c97535a$var$getIconImportFn(icon, size);
    if (!importFn) return null;
    const ImportedIcon = $7334a35b4c97535a$var$importIcon(importFn);
    if ($7334a35b4c97535a$var$isCoreIcon(icon)) {
        let color;
        if (icon === (0, $5kJPq.IconType).Error || icon === (0, $5kJPq.IconType).Forbidden) color = "var(--ds-icon-danger, #C9372C)";
        switch(size){
            case (0, $5kJPq.SmartLinkSize).Small:
            case (0, $5kJPq.SmartLinkSize).Medium:
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement(ImportedIcon, {
                    label: label,
                    testId: testId,
                    color: color
                });
            case (0, $5kJPq.SmartLinkSize).Large:
            case (0, $5kJPq.SmartLinkSize).XLarge:
                if ($7334a35b4c97535a$var$PRIORITY_ICONS.includes(icon)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement(ImportedIcon, {
                    label: label,
                    testId: testId,
                    color: color
                });
                let appearance;
                if (icon === (0, $5kJPq.IconType).Error || icon === (0, $5kJPq.IconType).Forbidden) appearance = 'redBold';
                else if ((0, $gdUUy.fg)('platform_lp_non_bold_large_sl_icon')) appearance = 'gray';
                else appearance = 'grayBold';
                const iconTileSize = (0, $30UCz.transformSmartLinkSizeToIconTileSize)(size);
                if (iconTileSize) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $67YKA.default), {
                    appearance: appearance,
                    icon: isTiledIcon ? (iconProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement(ImportedIcon, {
                            ...iconProps,
                            spacing: "spacious"
                        }) : ImportedIcon,
                    size: iconTileSize,
                    label: label ?? ''
                });
                else return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement(ImportedIcon, {
                    label: label,
                    testId: testId,
                    color: color
                });
        }
    }
    switch(icon){
        case (0, $5kJPq.IconType).Confluence:
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $4eIWR.ConfluenceIcon), {
                appearance: "brand",
                testId: testId,
                ...(0, $gdUUy.fg)('billplat_a11y_icon_label_fix') ? {
                    label: ''
                } : undefined,
                size: size === (0, $5kJPq.SmartLinkSize).Large || size === (0, $5kJPq.SmartLinkSize).XLarge ? 'small' : 'xxsmall'
            });
        case (0, $5kJPq.IconType).Jira:
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $jSH6l.JiraIcon), {
                appearance: "brand",
                testId: testId,
                ...(0, $gdUUy.fg)('billplat_a11y_icon_label_fix') ? {
                    label: ''
                } : undefined,
                size: size === (0, $5kJPq.SmartLinkSize).Large || size === (0, $5kJPq.SmartLinkSize).XLarge ? 'small' : 'xxsmall'
            });
        case (0, $5kJPq.IconType).Error:
        case (0, $5kJPq.IconType).Forbidden:
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement(ImportedIcon, {
                label: label,
                testId: testId,
                size: size,
                isTiledIcon: isTiledIcon
            });
        default:
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement(ImportedIcon, {
                label: label,
                testId: testId,
                size: size,
                isTiledIcon: isTiledIcon
            });
    }
};
var $7334a35b4c97535a$export$2e2bcd8739ae039 = $7334a35b4c97535a$var$AtlaskitIcon;

});
parcelRegister("30UCz", function(module, exports) {
$parcel$export(module.exports, "transformSmartLinkSizeToIconTileSize", () => $83edd842ddb8b2f9$export$3acc3fb10995f020);

var $5kJPq = parcelRequire("5kJPq");
const $83edd842ddb8b2f9$export$3acc3fb10995f020 = (size)=>{
    switch(size){
        case (0, $5kJPq.SmartLinkSize).Small:
        case (0, $5kJPq.SmartLinkSize).Medium:
            return undefined;
        case (0, $5kJPq.SmartLinkSize).XLarge:
        case (0, $5kJPq.SmartLinkSize).Large:
            return 'small';
        default:
            return undefined;
    }
};

});

parcelRegister("8qanF", function(module, exports) {
$parcel$export(module.exports, "getLazyIcons", () => $bd2065a8d67b7d44$export$92d31eb5326761b6);

var $bSJIT = parcelRequire("bSJIT");

var $5kJPq = parcelRequire("5kJPq");

const $bd2065a8d67b7d44$var$loadPriorityIcons = ()=>(parcelRequire("bIHsg"));














































































const $bd2065a8d67b7d44$export$92d31eb5326761b6 = ()=>{
    return {
        // IconTile wrappers (@atlaskit/icon/core/* wrapped in <IconTile> with color)
        [(0, $5kJPq.IconType).Document]: {
            default: ()=>Promise.resolve((parcelRequire("iZe2v")))
        },
        [(0, $5kJPq.IconType).Audio]: {
            default: ()=>(parcelRequire("4CIuJ"))
        },
        [(0, $5kJPq.IconType).Code]: {
            default: ()=>(parcelRequire("eutre"))
        },
        [(0, $5kJPq.IconType).File]: {
            default: ()=>(parcelRequire("77aPy"))
        },
        [(0, $5kJPq.IconType).Folder]: {
            default: ()=>(parcelRequire("bKZpU"))
        },
        [(0, $5kJPq.IconType).Generic]: {
            default: ()=>(parcelRequire("77aPy"))
        },
        [(0, $5kJPq.IconType).Image]: {
            default: ()=>(parcelRequire("he5iL"))
        },
        [(0, $5kJPq.IconType).Presentation]: {
            default: ()=>(parcelRequire("jy9v3"))
        },
        [(0, $5kJPq.IconType).Spreadsheet]: {
            default: ()=>(parcelRequire("dh2xo"))
        },
        [(0, $5kJPq.IconType).Video]: {
            default: ()=>(parcelRequire("fSOJN"))
        },
        // @atlaskit/icon/core/* (plain monochrome icons)
        [(0, $5kJPq.IconType).Project]: {
            default: ()=>(parcelRequire("78jxM"))
        },
        [(0, $5kJPq.IconType).Template]: {
            default: ()=>(parcelRequire("d2Jst"))
        },
        [(0, $5kJPq.IconType).Forbidden]: {
            default: ()=>(parcelRequire("ftYi1"))
        },
        [(0, $5kJPq.IconType).Default]: {
            default: ()=>Promise.resolve((parcelRequire("gRfjb")))
        },
        [(0, $5kJPq.IconType).Error]: {
            default: ()=>Promise.resolve((parcelRequire("hkLEY")))
        },
        // @atlaskit/icon/core/* (badge icons)
        [(0, $5kJPq.IconType).Attachment]: {
            default: ()=>(parcelRequire("j1zBd"))
        },
        [(0, $5kJPq.IconType).CheckItem]: {
            default: ()=>(parcelRequire("6bw59"))
        },
        [(0, $5kJPq.IconType).Component]: {
            default: ()=>(parcelRequire("VhAHa"))
        },
        [(0, $5kJPq.IconType).Comment]: {
            default: ()=>Promise.resolve((parcelRequire("eYvps")))
        },
        [(0, $5kJPq.IconType).View]: {
            default: ()=>Promise.resolve((parcelRequire("8iYAq")))
        },
        [(0, $5kJPq.IconType).React]: {
            default: ()=>(parcelRequire("6vSEe"))
        },
        [(0, $5kJPq.IconType).Vote]: {
            default: ()=>Promise.resolve((parcelRequire("6uKO5")))
        },
        [(0, $5kJPq.IconType).PriorityUndefined]: {
            default: ()=>Promise.resolve((parcelRequire("1hEmZ")))
        },
        [(0, $5kJPq.IconType).ProgrammingLanguage]: {
            default: ()=>(parcelRequire("iEaxt"))
        },
        [(0, $5kJPq.IconType).Subscriber]: {
            default: ()=>(parcelRequire("78jxM"))
        },
        [(0, $5kJPq.IconType).SubTasksProgress]: {
            default: ()=>(parcelRequire("3SqCL"))
        },
        // @atlaskit/icon-file-type/glyph/* (file type icons with 16/24 size variants)
        [(0, $5kJPq.IconType).Archive]: {
            default: ()=>(parcelRequire("lr34Q")),
            large: ()=>(parcelRequire("3zrpY"))
        },
        [(0, $5kJPq.IconType).Executable]: {
            default: ()=>(parcelRequire("8Q3Zb")),
            large: ()=>(parcelRequire("xbAOD"))
        },
        [(0, $5kJPq.IconType).GIF]: {
            default: ()=>(parcelRequire("1sXoB")),
            large: ()=>(parcelRequire("47fYZ"))
        },
        [(0, $5kJPq.IconType).GoogleDocs]: {
            default: ()=>(parcelRequire("gWAQI")),
            large: ()=>(parcelRequire("1Mguq"))
        },
        [(0, $5kJPq.IconType).GoogleForms]: {
            default: ()=>(parcelRequire("fKE91")),
            large: ()=>(parcelRequire("iLUWP"))
        },
        [(0, $5kJPq.IconType).GoogleSheets]: {
            default: ()=>(parcelRequire("eV8W8")),
            large: ()=>(parcelRequire("49d9q"))
        },
        [(0, $5kJPq.IconType).GoogleSlides]: {
            default: ()=>(parcelRequire("bPHYn")),
            large: ()=>(parcelRequire("bsrad"))
        },
        [(0, $5kJPq.IconType).MSExcel]: {
            default: ()=>(parcelRequire("5U2K5")),
            large: ()=>(parcelRequire("48kC0"))
        },
        [(0, $5kJPq.IconType).MSPowerpoint]: {
            default: ()=>(parcelRequire("lTyH8")),
            large: ()=>(parcelRequire("grf4J"))
        },
        [(0, $5kJPq.IconType).MSWord]: {
            default: ()=>(parcelRequire("4Ny40")),
            large: ()=>(parcelRequire("c5LAs"))
        },
        [(0, $5kJPq.IconType).PDF]: {
            default: ()=>(parcelRequire("6xIrD")),
            large: ()=>(parcelRequire("5PQqQ"))
        },
        [(0, $5kJPq.IconType).Sketch]: {
            default: ()=>(parcelRequire("63DD2")),
            large: ()=>(parcelRequire("6FP8G"))
        },
        // Keep blog/live-document out of the lazy map on purpose.
        // These icons should be present in SSR markup so hydration does not cause
        // a visible empty-state-then-pop-in transition in Smart Link consumers.
        [(0, $5kJPq.IconType).Branch]: {
            default: ()=>(parcelRequire("7seFi")),
            large: ()=>(parcelRequire("hY67C")).then((module)=>({
                        default: (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement(module.default, {
                                ...props,
                                size: "small"
                            })
                    }))
        },
        [(0, $5kJPq.IconType).Commit]: {
            default: ()=>(parcelRequire("jdkLR")),
            large: ()=>(parcelRequire("50wDn")).then((module)=>({
                        default: (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement(module.default, {
                                ...props,
                                size: "small"
                            })
                    }))
        },
        [(0, $5kJPq.IconType).PullRequest]: {
            default: ()=>(parcelRequire("iWWNl")),
            large: ()=>(parcelRequire("iuii8")).then((module)=>({
                        default: (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement(module.default, {
                                ...props,
                                size: "small"
                            })
                    }))
        },
        [(0, $5kJPq.IconType).Repo]: {
            default: ()=>(parcelRequire("gZSb6")),
            large: ()=>(parcelRequire("auj2k")).then((module)=>({
                        default: (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement(module.default, {
                                ...props,
                                size: "small"
                            })
                    }))
        },
        [(0, $5kJPq.IconType).Bug]: {
            default: ()=>(parcelRequire("alanM")),
            large: ()=>(parcelRequire("68Vmd")).then((module)=>({
                        default: (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement(module.default, {
                                ...props,
                                size: "small"
                            })
                    }))
        },
        [(0, $5kJPq.IconType).Change]: {
            default: ()=>(parcelRequire("fFO6L")),
            large: ()=>(parcelRequire("3IEJI")).then((module)=>({
                        default: (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement(module.default, {
                                ...props,
                                size: "small"
                            })
                    }))
        },
        [(0, $5kJPq.IconType).Epic]: {
            default: ()=>(parcelRequire("388ez")),
            large: ()=>(parcelRequire("3DBNg")).then((module)=>({
                        default: (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement(module.default, {
                                ...props,
                                size: "small"
                            })
                    }))
        },
        [(0, $5kJPq.IconType).Incident]: {
            default: ()=>(parcelRequire("80iog")),
            large: ()=>(parcelRequire("6YcdX")).then((module)=>({
                        default: (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement(module.default, {
                                ...props,
                                size: "small"
                            })
                    }))
        },
        [(0, $5kJPq.IconType).Problem]: {
            default: ()=>(parcelRequire("c4Nnu")),
            large: ()=>(parcelRequire("a0QRF")).then((module)=>({
                        default: (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement(module.default, {
                                ...props,
                                size: "small"
                            })
                    }))
        },
        [(0, $5kJPq.IconType).ServiceRequest]: {
            default: ()=>(parcelRequire("41mbl")),
            large: ()=>(parcelRequire("dCJ4J")).then((module)=>({
                        default: (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement(module.default, {
                                ...props,
                                size: "small"
                            })
                    }))
        },
        [(0, $5kJPq.IconType).Story]: {
            default: ()=>(parcelRequire("1WGe9")),
            large: ()=>(parcelRequire("eFE3r")).then((module)=>({
                        default: (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement(module.default, {
                                ...props,
                                size: "small"
                            })
                    }))
        },
        [(0, $5kJPq.IconType).SubTask]: {
            default: ()=>(parcelRequire("jVBkl")),
            large: ()=>(parcelRequire("2MmY7")).then((module)=>({
                        default: (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement(module.default, {
                                ...props,
                                size: "small"
                            })
                    }))
        },
        [(0, $5kJPq.IconType).Task]: {
            default: ()=>(parcelRequire("1GMFk")),
            large: ()=>(parcelRequire("6KqoN")).then((module)=>({
                        default: (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement(module.default, {
                                ...props,
                                size: "small"
                            })
                    }))
        },
        // @atlaskit/logo/* (product logos)
        [(0, $5kJPq.IconType).Confluence]: {
            default: ()=>Promise.resolve((parcelRequire("4eIWR"))).then(({ ConfluenceIcon: ConfluenceIcon })=>({
                        default: ConfluenceIcon
                    }))
        },
        [(0, $5kJPq.IconType).Jira]: {
            default: ()=>Promise.resolve((parcelRequire("jSH6l"))).then(({ JiraIcon: JiraIcon })=>({
                        default: JiraIcon
                    }))
        },
        // Priority icons stay lazy, but share one chunk to avoid a cold-cache request per icon type.
        [(0, $5kJPq.IconType).PriorityBlocker]: {
            default: ()=>$bd2065a8d67b7d44$var$loadPriorityIcons().then(({ PriorityBlockerIcon: defaultIcon })=>({
                        default: defaultIcon
                    }))
        },
        [(0, $5kJPq.IconType).PriorityCritical]: {
            default: ()=>$bd2065a8d67b7d44$var$loadPriorityIcons().then(({ PriorityCriticalIcon: defaultIcon })=>({
                        default: defaultIcon
                    }))
        },
        [(0, $5kJPq.IconType).PriorityHigh]: {
            default: ()=>$bd2065a8d67b7d44$var$loadPriorityIcons().then(({ PriorityHighIcon: defaultIcon })=>({
                        default: defaultIcon
                    }))
        },
        [(0, $5kJPq.IconType).PriorityHighest]: {
            default: ()=>$bd2065a8d67b7d44$var$loadPriorityIcons().then(({ PriorityHighestIcon: defaultIcon })=>({
                        default: defaultIcon
                    }))
        },
        [(0, $5kJPq.IconType).PriorityLow]: {
            default: ()=>$bd2065a8d67b7d44$var$loadPriorityIcons().then(({ PriorityLowIcon: defaultIcon })=>({
                        default: defaultIcon
                    }))
        },
        [(0, $5kJPq.IconType).PriorityLowest]: {
            default: ()=>$bd2065a8d67b7d44$var$loadPriorityIcons().then(({ PriorityLowestIcon: defaultIcon })=>({
                        default: defaultIcon
                    }))
        },
        [(0, $5kJPq.IconType).PriorityMajor]: {
            default: ()=>$bd2065a8d67b7d44$var$loadPriorityIcons().then(({ PriorityMajorIcon: defaultIcon })=>({
                        default: defaultIcon
                    }))
        },
        [(0, $5kJPq.IconType).PriorityMedium]: {
            default: ()=>$bd2065a8d67b7d44$var$loadPriorityIcons().then(({ PriorityMediumIcon: defaultIcon })=>({
                        default: defaultIcon
                    }))
        },
        [(0, $5kJPq.IconType).PriorityMinor]: {
            default: ()=>$bd2065a8d67b7d44$var$loadPriorityIcons().then(({ PriorityMinorIcon: defaultIcon })=>({
                        default: defaultIcon
                    }))
        },
        [(0, $5kJPq.IconType).PriorityTrivial]: {
            default: ()=>$bd2065a8d67b7d44$var$loadPriorityIcons().then(({ PriorityTrivialIcon: defaultIcon })=>({
                        default: defaultIcon
                    }))
        }
    };
};

});
parcelRegister("bIHsg", function(module, exports) {

var $kOunM = parcelRequire("kOunM");
module.exports = Promise.all([
    $kOunM("3EY01"),
    $kOunM("7KAdk"),
    $kOunM("h55Vm"),
    $kOunM("kB8Es"),
    $kOunM("as0uO"),
    $kOunM("l5BVw"),
    $kOunM("ii2TN"),
    $kOunM("419vt"),
    $kOunM("dL7s1"),
    $kOunM("1N15d"),
    $kOunM("agD7Y")
]).then(()=>parcelRequire('iVqCU'));

});

parcelRegister("iZe2v", function(module, exports) {

$parcel$defineInteropFlag(module.exports);
$parcel$export(module.exports, "default", () => $9fd66eea3cd8fd91$export$2e2bcd8739ae039);

var $emsU2 = parcelRequire("emsU2");

var $bMeS5 = parcelRequire("bMeS5");
// `blueBold` is used while `platform_lp_non_bold_large_sl_icon` is off.
// Clean up in NAVX-5752: https://hello.jira.atlassian.cloud/browse/NAVX-5752
// When that gate is cleaned up, replace `blueBold` directly with `blue`.
const $9fd66eea3cd8fd91$var$PageIconWithColor = (0, $bMeS5.renderIconTile)((0, (/*@__PURE__*/$parcel$interopDefault($emsU2))), 'blueBold');
$9fd66eea3cd8fd91$var$PageIconWithColor.displayName = 'PageIconWithColor';
var $9fd66eea3cd8fd91$export$2e2bcd8739ae039 = $9fd66eea3cd8fd91$var$PageIconWithColor;

});
parcelRegister("bMeS5", function(module, exports) {
$parcel$export(module.exports, "renderIconTile", () => $eff6338c076479be$export$87c3646d0e299cfe);

var $bSJIT = parcelRequire("bSJIT");

var $67YKA = parcelRequire("67YKA");

var $gdUUy = parcelRequire("gdUUy");

var $30UCz = parcelRequire("30UCz");
/**
 * Maps IconTile appearance to the icon glyph color token to use when rendering
 * a standalone icon (without a tile background).
 * When cleaning up `platform_lp_non_bold_large_sl_icon` in NAVX-5752, remove the `*Bold`
 * entries. Nothing will pass a bold appearance into this map after that.
 */ const $eff6338c076479be$var$appearanceToStandaloneIconColor = {
    blue: "var(--ds-icon-accent-blue, #357DE8)",
    blueBold: "var(--ds-icon-accent-blue, #357DE8)",
    gray: "var(--ds-icon-accent-gray, #7D818A)",
    grayBold: "var(--ds-icon-accent-gray, #7D818A)",
    green: "var(--ds-icon-accent-green, #22A06B)",
    greenBold: "var(--ds-icon-accent-green, #22A06B)",
    lime: "var(--ds-icon-accent-lime, #6A9A23)",
    limeBold: "var(--ds-icon-accent-lime, #6A9A23)",
    magenta: "var(--ds-icon-accent-magenta, #CD519D)",
    magentaBold: "var(--ds-icon-accent-magenta, #CD519D)",
    orange: "var(--ds-icon-accent-orange, #E06C00)",
    orangeBold: "var(--ds-icon-accent-orange, #E06C00)",
    purple: "var(--ds-icon-accent-purple, #AF59E1)",
    purpleBold: "var(--ds-icon-accent-purple, #AF59E1)",
    red: "var(--ds-icon-accent-red, #C9372C)",
    redBold: "var(--ds-icon-accent-red, #C9372C)",
    teal: "var(--ds-icon-accent-teal, #2898BD)",
    tealBold: "var(--ds-icon-accent-teal, #2898BD)",
    yellow: "var(--ds-icon-accent-yellow, #B38600)",
    yellowBold: "var(--ds-icon-accent-yellow, #B38600)"
};
/**
 * Bold appearances are the gate-off values. Remove this map when cleaning up
 * `platform_lp_non_bold_large_sl_icon` in NAVX-5752:
 * https://hello.jira.atlassian.cloud/browse/NAVX-5752
 */ const $eff6338c076479be$var$boldToNonBoldAppearance = {
    blueBold: 'blue',
    grayBold: 'gray',
    greenBold: 'green',
    limeBold: 'lime',
    magentaBold: 'magenta',
    orangeBold: 'orange',
    purpleBold: 'purple',
    redBold: 'red',
    tealBold: 'teal',
    yellowBold: 'yellow'
};
const $eff6338c076479be$export$87c3646d0e299cfe = (Icon, appearance)=>{
    return ({ size: size, isTiledIcon: isTiledIcon, ...props })=>{
        const tileSize = (0, $30UCz.transformSmartLinkSizeToIconTileSize)(size);
        if (tileSize === undefined) {
            // size="16" has been removed — render the icon directly without a tile,
            // using the appearance-derived color so it still matches the intended style.
            const label = props.label ?? '';
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement("span", {
                role: label ? 'img' : undefined,
                "aria-label": label || undefined,
                "data-testid": props.testId
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement(Icon, {
                color: $eff6338c076479be$var$appearanceToStandaloneIconColor[appearance],
                label: ""
            }));
        }
        const { ...tileProps } = props;
        const nonBoldAppearance = $eff6338c076479be$var$boldToNonBoldAppearance[appearance];
        const tileAppearance = nonBoldAppearance !== undefined && (0, $gdUUy.fg)('platform_lp_non_bold_large_sl_icon') ? nonBoldAppearance : appearance;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $67YKA.default), {
            appearance: tileAppearance,
            icon: isTiledIcon ? (iconProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement(Icon, {
                    ...iconProps,
                    spacing: "spacious"
                }) : Icon,
            size: tileSize,
            ...tileProps
        });
    };
};

});


parcelRegister("4CIuJ", function(module, exports) {

var $kOunM = parcelRequire("kOunM");
module.exports = $kOunM("7VyQO").then(()=>parcelRequire('6cGVo'));

});

parcelRegister("eutre", function(module, exports) {

var $kOunM = parcelRequire("kOunM");
module.exports = Promise.all([
    $kOunM("2wCFs"),
    $kOunM("2DUSV")
]).then(()=>parcelRequire('l9Mdl'));

});

parcelRegister("77aPy", function(module, exports) {

var $kOunM = parcelRequire("kOunM");
module.exports = $kOunM("kDDxa").then(()=>parcelRequire('fEGwx'));

});

parcelRegister("bKZpU", function(module, exports) {

var $kOunM = parcelRequire("kOunM");
module.exports = $kOunM("e8AXr").then(()=>parcelRequire('9mSH9'));

});

parcelRegister("he5iL", function(module, exports) {

var $kOunM = parcelRequire("kOunM");
module.exports = $kOunM("gMRTa").then(()=>parcelRequire('7QaKm'));

});

parcelRegister("jy9v3", function(module, exports) {

var $kOunM = parcelRequire("kOunM");
module.exports = $kOunM("jYDd5").then(()=>parcelRequire('fnYUT'));

});

parcelRegister("dh2xo", function(module, exports) {

var $kOunM = parcelRequire("kOunM");
module.exports = $kOunM("ktLtf").then(()=>parcelRequire('70tZA'));

});

parcelRegister("fSOJN", function(module, exports) {

var $kOunM = parcelRequire("kOunM");
module.exports = $kOunM("1dfnY").then(()=>parcelRequire('7JVZh'));

});

parcelRegister("78jxM", function(module, exports) {

var $kOunM = parcelRequire("kOunM");
module.exports = $kOunM("gsQwM").then(()=>parcelRequire('3lVND'));

});

parcelRegister("d2Jst", function(module, exports) {

var $kOunM = parcelRequire("kOunM");
module.exports = $kOunM("272yQ").then(()=>parcelRequire('lwuFt'));

});

parcelRegister("ftYi1", function(module, exports) {

var $kOunM = parcelRequire("kOunM");
module.exports = $kOunM("esjBs").then(()=>parcelRequire('5FomD'));

});

parcelRegister("j1zBd", function(module, exports) {

var $kOunM = parcelRequire("kOunM");
module.exports = $kOunM("bfIA5").then(()=>parcelRequire('5PeKn'));

});

parcelRegister("6bw59", function(module, exports) {

var $kOunM = parcelRequire("kOunM");
module.exports = $kOunM("iTkmH").then(()=>parcelRequire('4ujxi'));

});

parcelRegister("VhAHa", function(module, exports) {

var $kOunM = parcelRequire("kOunM");
module.exports = $kOunM("bb6dY").then(()=>parcelRequire('4eOl6'));

});

parcelRegister("6vSEe", function(module, exports) {

var $kOunM = parcelRequire("kOunM");
module.exports = $kOunM("aLfJb").then(()=>parcelRequire('lfmXv'));

});

parcelRegister("iEaxt", function(module, exports) {

var $kOunM = parcelRequire("kOunM");
module.exports = $kOunM("2wCFs").then(()=>parcelRequire('imwtU'));

});

parcelRegister("3SqCL", function(module, exports) {

var $kOunM = parcelRequire("kOunM");
module.exports = $kOunM("buGvX").then(()=>parcelRequire('7j6fq'));

});

parcelRegister("lr34Q", function(module, exports) {

var $kOunM = parcelRequire("kOunM");
module.exports = $kOunM("5Q6Lv").then(()=>parcelRequire('2Cf0j'));

});

parcelRegister("3zrpY", function(module, exports) {

var $kOunM = parcelRequire("kOunM");
module.exports = $kOunM("8scR7").then(()=>parcelRequire('ing6l'));

});

parcelRegister("8Q3Zb", function(module, exports) {

var $kOunM = parcelRequire("kOunM");
module.exports = $kOunM("im3Gq").then(()=>parcelRequire('cc6dr'));

});

parcelRegister("xbAOD", function(module, exports) {

var $kOunM = parcelRequire("kOunM");
module.exports = $kOunM("5IUGi").then(()=>parcelRequire('f7nOv'));

});

parcelRegister("1sXoB", function(module, exports) {

var $kOunM = parcelRequire("kOunM");
module.exports = $kOunM("hb6aq").then(()=>parcelRequire('5zGdM'));

});

parcelRegister("47fYZ", function(module, exports) {

var $kOunM = parcelRequire("kOunM");
module.exports = $kOunM("49weT").then(()=>parcelRequire('9rKoZ'));

});

parcelRegister("gWAQI", function(module, exports) {

var $kOunM = parcelRequire("kOunM");
module.exports = $kOunM("hsqqr").then(()=>parcelRequire('9Qi0v'));

});

parcelRegister("1Mguq", function(module, exports) {

var $kOunM = parcelRequire("kOunM");
module.exports = $kOunM("k2gok").then(()=>parcelRequire('QvRKw'));

});

parcelRegister("fKE91", function(module, exports) {

var $kOunM = parcelRequire("kOunM");
module.exports = $kOunM("2gnAV").then(()=>parcelRequire('kU9Gp'));

});

parcelRegister("iLUWP", function(module, exports) {

var $kOunM = parcelRequire("kOunM");
module.exports = $kOunM("5JcpR").then(()=>parcelRequire('jFDuu'));

});

parcelRegister("eV8W8", function(module, exports) {

var $kOunM = parcelRequire("kOunM");
module.exports = $kOunM("cguoO").then(()=>parcelRequire('6YBWf'));

});

parcelRegister("49d9q", function(module, exports) {

var $kOunM = parcelRequire("kOunM");
module.exports = $kOunM("i4HzU").then(()=>parcelRequire('ldDms'));

});

parcelRegister("bPHYn", function(module, exports) {

var $kOunM = parcelRequire("kOunM");
module.exports = $kOunM("4mnZC").then(()=>parcelRequire('lXZwO'));

});

parcelRegister("bsrad", function(module, exports) {

var $kOunM = parcelRequire("kOunM");
module.exports = $kOunM("7EtTP").then(()=>parcelRequire('cYmjV'));

});

parcelRegister("5U2K5", function(module, exports) {

var $kOunM = parcelRequire("kOunM");
module.exports = $kOunM("ePlp8").then(()=>parcelRequire('lQDdk'));

});

parcelRegister("48kC0", function(module, exports) {

var $kOunM = parcelRequire("kOunM");
module.exports = $kOunM("7VIjZ").then(()=>parcelRequire('l75WN'));

});

parcelRegister("lTyH8", function(module, exports) {

var $kOunM = parcelRequire("kOunM");
module.exports = $kOunM("cLKjG").then(()=>parcelRequire('cRwRL'));

});

parcelRegister("grf4J", function(module, exports) {

var $kOunM = parcelRequire("kOunM");
module.exports = $kOunM("ipAwN").then(()=>parcelRequire('jcS4t'));

});

parcelRegister("4Ny40", function(module, exports) {

var $kOunM = parcelRequire("kOunM");
module.exports = $kOunM("gyNWY").then(()=>parcelRequire('jx64G'));

});

parcelRegister("c5LAs", function(module, exports) {

var $kOunM = parcelRequire("kOunM");
module.exports = $kOunM("42Pvp").then(()=>parcelRequire('jUxZl'));

});

parcelRegister("6xIrD", function(module, exports) {

var $kOunM = parcelRequire("kOunM");
module.exports = $kOunM("8g32G").then(()=>parcelRequire('jTZ17'));

});

parcelRegister("5PQqQ", function(module, exports) {

var $kOunM = parcelRequire("kOunM");
module.exports = $kOunM("lcafb").then(()=>parcelRequire('bVev6'));

});

parcelRegister("63DD2", function(module, exports) {

var $kOunM = parcelRequire("kOunM");
module.exports = $kOunM("7whKl").then(()=>parcelRequire('6hOsT'));

});

parcelRegister("6FP8G", function(module, exports) {

var $kOunM = parcelRequire("kOunM");
module.exports = $kOunM("6FbLK").then(()=>parcelRequire('jHFvN'));

});

parcelRegister("7seFi", function(module, exports) {

var $kOunM = parcelRequire("kOunM");
module.exports = $kOunM("k8thC").then(()=>parcelRequire('96QwL'));

});

parcelRegister("hY67C", function(module, exports) {

var $kOunM = parcelRequire("kOunM");
module.exports = Promise.all([
    $kOunM("hwIr9"),
    $kOunM("2aRbO")
]).then(()=>parcelRequire('14xaE'));

});

parcelRegister("jdkLR", function(module, exports) {

var $kOunM = parcelRequire("kOunM");
module.exports = $kOunM("dVPBt").then(()=>parcelRequire('8Qale'));

});

parcelRegister("50wDn", function(module, exports) {

var $kOunM = parcelRequire("kOunM");
module.exports = Promise.all([
    $kOunM("geajC"),
    $kOunM("fuIxn")
]).then(()=>parcelRequire('ewR9z'));

});

parcelRegister("iWWNl", function(module, exports) {

var $kOunM = parcelRequire("kOunM");
module.exports = $kOunM("JcBsL").then(()=>parcelRequire('2Lzug'));

});

parcelRegister("iuii8", function(module, exports) {

var $kOunM = parcelRequire("kOunM");
module.exports = Promise.all([
    $kOunM("4d2X7"),
    $kOunM("cezei")
]).then(()=>parcelRequire('9I7Y8'));

});

parcelRegister("gZSb6", function(module, exports) {

var $kOunM = parcelRequire("kOunM");
module.exports = $kOunM("l1iNV").then(()=>parcelRequire('5XnaM'));

});

parcelRegister("auj2k", function(module, exports) {

var $kOunM = parcelRequire("kOunM");
module.exports = Promise.all([
    $kOunM("2wCFs"),
    $kOunM("6Q20U")
]).then(()=>parcelRequire('4X1hM'));

});

parcelRegister("alanM", function(module, exports) {

var $kOunM = parcelRequire("kOunM");
module.exports = $kOunM("cZUzS").then(()=>parcelRequire('5GXrT'));

});

parcelRegister("68Vmd", function(module, exports) {

var $kOunM = parcelRequire("kOunM");
module.exports = Promise.all([
    $kOunM("70W5u"),
    $kOunM("bfhLz")
]).then(()=>parcelRequire('k8wi9'));

});

parcelRegister("fFO6L", function(module, exports) {

var $kOunM = parcelRequire("kOunM");
module.exports = $kOunM("de818").then(()=>parcelRequire('fmxSi'));

});

parcelRegister("3IEJI", function(module, exports) {

var $kOunM = parcelRequire("kOunM");
module.exports = Promise.all([
    $kOunM("3Z4Dd"),
    $kOunM("ejI14")
]).then(()=>parcelRequire('4Vcl4'));

});

parcelRegister("388ez", function(module, exports) {

var $kOunM = parcelRequire("kOunM");
module.exports = $kOunM("9oDwW").then(()=>parcelRequire('k0n7D'));

});

parcelRegister("3DBNg", function(module, exports) {

var $kOunM = parcelRequire("kOunM");
module.exports = Promise.all([
    $kOunM("kTcCo"),
    $kOunM("5k6UP")
]).then(()=>parcelRequire('8LOIN'));

});

parcelRegister("80iog", function(module, exports) {

var $kOunM = parcelRequire("kOunM");
module.exports = $kOunM("2OWEg").then(()=>parcelRequire('lQdGj'));

});

parcelRegister("6YcdX", function(module, exports) {

var $kOunM = parcelRequire("kOunM");
module.exports = Promise.all([
    $kOunM("2NZMo"),
    $kOunM("5Ih8L")
]).then(()=>parcelRequire('lIRMb'));

});

parcelRegister("c4Nnu", function(module, exports) {

var $kOunM = parcelRequire("kOunM");
module.exports = $kOunM("ef2p4").then(()=>parcelRequire('bF3dv'));

});

parcelRegister("a0QRF", function(module, exports) {

var $kOunM = parcelRequire("kOunM");
module.exports = Promise.all([
    $kOunM("876f5"),
    $kOunM("c0AkT")
]).then(()=>parcelRequire('e5woj'));

});

parcelRegister("41mbl", function(module, exports) {

var $kOunM = parcelRequire("kOunM");
module.exports = $kOunM("1jZR6").then(()=>parcelRequire('24J67'));

});

parcelRegister("dCJ4J", function(module, exports) {

var $kOunM = parcelRequire("kOunM");
module.exports = $kOunM("86iRt").then(()=>parcelRequire('i6GqK'));

});

parcelRegister("1WGe9", function(module, exports) {

var $kOunM = parcelRequire("kOunM");
module.exports = $kOunM("d3ovF").then(()=>parcelRequire('f4EgE'));

});

parcelRegister("eFE3r", function(module, exports) {

var $kOunM = parcelRequire("kOunM");
module.exports = Promise.all([
    $kOunM("dx4Ty"),
    $kOunM("49y5U")
]).then(()=>parcelRequire('45hfz'));

});

parcelRegister("jVBkl", function(module, exports) {

var $kOunM = parcelRequire("kOunM");
module.exports = $kOunM("eo13b").then(()=>parcelRequire('fbMo8'));

});

parcelRegister("2MmY7", function(module, exports) {

var $kOunM = parcelRequire("kOunM");
module.exports = Promise.all([
    $kOunM("buGvX"),
    $kOunM("brKnd")
]).then(()=>parcelRequire('lmvoo'));

});

parcelRegister("1GMFk", function(module, exports) {

var $kOunM = parcelRequire("kOunM");
module.exports = $kOunM("2iKrl").then(()=>parcelRequire('iLUhj'));

});

parcelRegister("6KqoN", function(module, exports) {

var $kOunM = parcelRequire("kOunM");
module.exports = Promise.all([
    $kOunM("iTkmH"),
    $kOunM("io1WS")
]).then(()=>parcelRequire('2CHon'));

});


parcelRegister("aDlsY", function(module, exports) {
$parcel$export(module.exports, "isIconSizeLarge", () => $e23157ff28ca3800$export$d2b8fb9e780e17e7);

var $5kJPq = parcelRequire("5kJPq");
const $e23157ff28ca3800$export$d2b8fb9e780e17e7 = (size)=>size && [
        (0, $5kJPq.SmartLinkSize).Large,
        (0, $5kJPq.SmartLinkSize).XLarge
    ].includes(size);

});

parcelRegister("8BZ9Q", function(module, exports) {
$parcel$export(module.exports, "default", () => $51db5a1da9c31406$export$2e2bcd8739ae039);

var $5L1nf = parcelRequire("5L1nf");

var $7nxoy = parcelRequire("7nxoy");

var $jqApj = parcelRequire("jqApj");
const $51db5a1da9c31406$var$BlogIconWithColor = (0, $jqApj.renderIconPerSize)((0, $5L1nf.default), (0, $7nxoy.default));
$51db5a1da9c31406$var$BlogIconWithColor.displayName = 'BlogIconWithColor';
var $51db5a1da9c31406$export$2e2bcd8739ae039 = $51db5a1da9c31406$var$BlogIconWithColor;

});
parcelRegister("jqApj", function(module, exports) {
$parcel$export(module.exports, "renderIconPerSize", () => $d5aebff702093e71$export$28dd5ad82647c000);

var $bSJIT = parcelRequire("bSJIT");

var $aDlsY = parcelRequire("aDlsY");
const $d5aebff702093e71$export$28dd5ad82647c000 = (ObjectIcon, ObjectTileIcon)=>{
    return ({ size: size, ...props })=>{
        if ((0, $aDlsY.isIconSizeLarge)(size)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement(ObjectTileIcon, {
            ...props,
            size: "small"
        });
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement(ObjectIcon, props);
    };
};

});


parcelRegister("5YS12", function(module, exports) {
$parcel$export(module.exports, "default", () => $43b0f0002209cd92$export$2e2bcd8739ae039);

var $58h91 = parcelRequire("58h91");

var $dPoiI = parcelRequire("dPoiI");

var $jqApj = parcelRequire("jqApj");
const $43b0f0002209cd92$var$LiveDocumentIconWithColor = (0, $jqApj.renderIconPerSize)((0, $58h91.default), (0, $dPoiI.default));
$43b0f0002209cd92$var$LiveDocumentIconWithColor.displayName = 'LiveDocumentIconWithColor';
var $43b0f0002209cd92$export$2e2bcd8739ae039 = $43b0f0002209cd92$var$LiveDocumentIconWithColor;

});


parcelRegister("b2mmI", function(module, exports) {
$parcel$export(module.exports, "getIconWidth", () => $aaa4a632559dbabc$export$fb10bc5609c6347e);

var $5kJPq = parcelRequire("5kJPq");
const $aaa4a632559dbabc$export$fb10bc5609c6347e = (size)=>{
    switch(size){
        case (0, $5kJPq.SmartLinkSize).XLarge:
        case (0, $5kJPq.SmartLinkSize).Large:
            return "var(--ds-space-300, 24px)";
        case (0, $5kJPq.SmartLinkSize).Medium:
        case (0, $5kJPq.SmartLinkSize).Small:
        default:
            return "var(--ds-space-200, 16px)";
    }
};

});


parcelRegister("8gJWv", function(module, exports) {
$parcel$export(module.exports, "toLinkIconProps", () => $3ddd3599023af1ed$export$6d33abd591a3f700);
/* eslint-disable @compiled/shorthand-property-sorting */ /* eslint-disable @atlaskit/design-system/use-tokens-typography */ /* eslint-disable @atlaskit/ui-styling-standard/no-nested-selectors */ /**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $k5Giz = parcelRequire("k5Giz");
const $3ddd3599023af1ed$export$6d33abd591a3f700 = (data, type)=>{
    const isDataLinkIcon = (_data)=>{
        return typeof _data === 'object' && _data !== null && ('icon' in _data || 'url' in _data);
    };
    if (!isDataLinkIcon(data)) return typeof data === 'object' ? data : undefined;
    const isImageRound = (0, $k5Giz.isProfileType)(type);
    return {
        ...data,
        appearance: isImageRound ? 'round' : 'square'
    };
};

});
parcelRegister("k5Giz", function(module, exports) {
$parcel$export(module.exports, "isProfileType", () => $66b98e355d22891e$export$6a4545d6b336c401);
const $66b98e355d22891e$export$6a4545d6b336c401 = (type)=>!!(type && type.includes('Profile'));

});


parcelRegister("7cMTd", function(module, exports) {
$parcel$export(module.exports, "resourceTypeToLabel", () => $ca74c32a04b2bd0b$export$3422b5d26145468d);
const $ca74c32a04b2bd0b$var$excludedResourceTypes = [
    '0',
    'unknown',
    'unsupported',
    'REDACTED'
];
const $ca74c32a04b2bd0b$var$manualMapping = {
    jswBoard: 'Jira Software Board',
    calendarJsw: 'Jira Software Calendar',
    kbArticle: 'Knowledge Base Article',
    pull: 'Pull Request',
    repo: 'Repository'
};
/**
 * Splits a resolver `resourceType` token into human-oriented words.
 * Prefers kebab-case (`-`) when present; otherwise splits camelCase / PascalCase.
 */ function $ca74c32a04b2bd0b$var$splitIntoWords(resourceType) {
    if (resourceType.includes('-')) return resourceType.split('-').map((w)=>w.trim()).filter(Boolean);
    const spaced = resourceType.replace(/([a-z\d])([A-Z])/g, '$1 $2').replace(/([A-Z]+)([A-Z][a-z])/g, '$1 $2');
    return spaced.split(/\s+/).filter(Boolean);
}
function $ca74c32a04b2bd0b$var$titleCaseWord(word) {
    if (!word) return word;
    return word.charAt(0).toUpperCase() + word.slice(1).toLowerCase();
}
function $ca74c32a04b2bd0b$export$3422b5d26145468d(resourceType) {
    const trimmed = resourceType === null || resourceType === void 0 ? void 0 : resourceType.trim();
    if (!trimmed) return undefined;
    if ($ca74c32a04b2bd0b$var$excludedResourceTypes.includes(trimmed)) return undefined;
    const manual = $ca74c32a04b2bd0b$var$manualMapping[trimmed];
    if (manual !== undefined) return manual;
    const words = $ca74c32a04b2bd0b$var$splitIntoWords(trimmed);
    if (words.length === 0) return undefined;
    return words.map($ca74c32a04b2bd0b$var$titleCaseWord).join(' ');
} // Following are unique resourceType values for the past week (at the the time of writing) for reference:
 // page
 // issue
 // 0
 // (none)
 // unknown
 // file
 // space
 // message
 // jswBoard
 // video
 // card
 // project
 // board
 // repository
 // whiteboard
 // channel
 // pull-request
 // mergeRequest
 // database
 // pullRequest
 // singlePortalPage
 // folder
 // dashboard
 // requestCreateForm
 // commit
 // jql
 // blog
 // version
 // backlog
 // undefinedLink
 // branch
 // report
 // planTimeline
 // sharepointFile
 // comment
 // roadmap
 // idea
 // case
 // opportunity
 // account
 // list
 // issues
 // view
 // workItem
 // link
 // block
 // kbArticle
 // form
 // summary
 // task
 // search
 // visitor
 // public-link
 // user
 // playlist
 // prototype
 // deal
 // screen
 // pipeline
 // contact
 // incident
 // sheet
 // featureFlag
 // release
 // switcheroo-flag
 // single-calendar
 // repo
 // formBuilder
 // proformaForm
 // object
 // tiny
 // document
 // sharedFile
 // campaign
 // table
 // compassComponent
 // timeline
 // boardInvite
 // action
 // embed
 // objectType
 // calendar
 // calendarJsw
 // publishedView
 // template
 // gist
 // recording
 // plan
 // planDependencies
 // epic
 // oneDriveFile
 // chart
 // capability
 // artboard
 // planCalendar
 // planSummary
 // projectTeamTag
 // planProgram
 // compassComponentSearchQuery
 // feature
 // workspace
 // company
 // insight
 // customer
 // Page
 // schema
 // dependency
 // note
 // article
 // snippet
 // tag
 // goal
 // security
 // collaborationGroup
 // envelope
 // code
 // boardView
 // compassScorecard
 // invoice
 // theme
 // customWorkspaceView
 // risk
 // reel
 // deployments
 // objective
 // ask
 // compassMetricDefinition
 // compassComponentAnnouncement
 // portals
 // asks
 // breadcrumbChart
 // Chart
 // slide
 // unsupported
 // remote-link
 // pull
 // REDACTED
 // compassComponentScorecard
 // forms
 // sante
 // zoom

});


parcelRegister("8dLhi", function(module, exports) {
$parcel$export(module.exports, "default", () => $e4973956f64af8f9$export$2e2bcd8739ae039);
/* eslint-disable @repo/internal/deprecations/deprecation-ticket-required -- VOLTC-139 tracks removal of these deprecated re-export shims. */ /* eslint-disable @atlaskit/ui-styling-standard/no-nested-selectors */ /**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $8r89X = parcelRequire("8r89X");
var $e4973956f64af8f9$export$2e2bcd8739ae039 = (0, $8r89X.Block);

});
parcelRegister("8r89X", function(module, exports) {
$parcel$export(module.exports, "Block", () => $f34b47a704382aae$export$d96a8827a60d6b69);
/* Block.tsx generated by @compiled/babel-plugin v3.0.2 */ /* eslint-disable @atlaskit/ui-styling-standard/no-nested-selectors */ 
var $bSJIT = parcelRequire("bSJIT");

var $9fU1q = parcelRequire("9fU1q");

var $5kJPq = parcelRequire("5kJPq");

var $b4upk = parcelRequire("b4upk");
const $f34b47a704382aae$var$baseBlockStyles = null;
const $f34b47a704382aae$var$highlightRemoveStyles = null;
const $f34b47a704382aae$var$gapStyles = {
    xlarge: "_zulpv47k _1ljqv47k",
    large: "_zulppxbi _1ljqpxbi",
    medium: "_zulpu2gc _1ljqu2gc",
    small: "_zulp1b66 _1ljq1b66"
};
const $f34b47a704382aae$var$directionStyles = {
    vertical: "_2lx21bp4 _4cvr1y6m",
    horizontal: "_2lx2vrvc _4cvr1h6o"
};
const $f34b47a704382aae$export$d96a8827a60d6b69 = ({ children: children, direction: direction = (0, $5kJPq.SmartLinkDirection).Horizontal, size: size = (0, $5kJPq.SmartLinkSize).Medium, testId: testId = 'smart-block', className: className, blockRef: blockRef, onRender: onRender, onTransitionEnd: onTransitionEnd, style: style, placeholderId: placeholderId })=>{
    (0, $bSJIT.useEffect)(()=>{
        onRender && onRender();
    }, [
        onRender
    ]);
    return /*#__PURE__*/ $bSJIT.createElement("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
        className: (0, $9fU1q.default)([
            "_1reo15vq _18m915vq _4cvr1h6o _1e0c1txw _1ul9idpf _1bah1y6m _fiawglyw _1uzp1mp2 _a6bx1l7x _e4i5bjq5 _1gu2dgkc _5b7tuxlv _17aedgkc",
            "_12ji1snc _1qu2agmp _12y310yn _12ji1kw7 _syaz1kw7 _18ql1j28 _1ifmglyw _181uglyw _1rkwglyw _te17glyw _uiztglyw",
            $f34b47a704382aae$var$directionStyles[direction],
            $f34b47a704382aae$var$gapStyles[size],
            className
        ]),
        "data-smart-block": true,
        "data-testid": testId,
        onTransitionEnd: onTransitionEnd,
        ref: blockRef,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
        style: style,
        "data-ssr-placeholder": placeholderId,
        "data-ssr-placeholder-replace": placeholderId
    }, (0, $b4upk.renderChildren)(children, size));
};

});
parcelRegister("b4upk", function(module, exports) {
$parcel$export(module.exports, "renderChildren", () => $225fb6ef5de9cdac$export$cd762ccf1a583d69);

var $bSJIT = parcelRequire("bSJIT");

var $eKAty = parcelRequire("eKAty");

var $goesr = parcelRequire("goesr");

var $94O41 = parcelRequire("94O41");
const $225fb6ef5de9cdac$var$isActionGroup = (node)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).isValidElement(node) && node.type === (0, $goesr.default);
const $225fb6ef5de9cdac$var$isElementOrElementGroup = (node)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).isValidElement(node) && ((0, $eKAty.isFlexibleUiElement)(node) || node.type === (0, $94O41.default));
const $225fb6ef5de9cdac$export$cd762ccf1a583d69 = (children, size)=>(0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).Children.map(children, (child)=>{
        if ($225fb6ef5de9cdac$var$isElementOrElementGroup(child) || $225fb6ef5de9cdac$var$isActionGroup(child)) {
            const node = child;
            const { size: childSize } = node.props;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).cloneElement(node, {
                size: childSize || size
            });
        }
        return child;
    });

});
parcelRegister("eKAty", function(module, exports) {
$parcel$export(module.exports, "isFlexibleUiElement", () => $73a4bca3d1b76fab$export$d7fc505bb0bd5756);

var $bSJIT = parcelRequire("bSJIT");

var $2TxTu = parcelRequire("2TxTu");

var $4pP1K = parcelRequire("4pP1K");

var $8VhG4 = parcelRequire("8VhG4");

var $jaRTQ = parcelRequire("jaRTQ");

var $lR3MV = parcelRequire("lR3MV");

var $jf7a7 = parcelRequire("jf7a7");

var $iU6l7 = parcelRequire("iU6l7");

var $k8wNj = parcelRequire("k8wNj");

var $lLEGZ = parcelRequire("lLEGZ");

var $iTIMD = parcelRequire("iTIMD");

var $jZNZe = parcelRequire("jZNZe");

var $co4V5 = parcelRequire("co4V5");

var $1YXxS = parcelRequire("1YXxS");

var $lgzQp = parcelRequire("lgzQp");

var $98x8l = parcelRequire("98x8l");

var $whVOD = parcelRequire("whVOD");

var $6bVEJ = parcelRequire("6bVEJ");

var $79YtU = parcelRequire("79YtU");

var $40odn = parcelRequire("40odn");

var $f3OWg = parcelRequire("f3OWg");

var $2XIml = parcelRequire("2XIml");

var $69cJJ = parcelRequire("69cJJ");

var $beIZm = parcelRequire("beIZm");

var $gIpkO = parcelRequire("gIpkO");

var $1gqay = parcelRequire("1gqay");

var $8EnvJ = parcelRequire("8EnvJ");

var $3DaZe = parcelRequire("3DaZe");

var $4VZZ9 = parcelRequire("4VZZ9");

var $i6SML = parcelRequire("i6SML");

var $e5w9n = parcelRequire("e5w9n");

var $aPBCU = parcelRequire("aPBCU");

var $6pxsJ = parcelRequire("6pxsJ");

var $4wkZy = parcelRequire("4wkZy");

var $6M7UH = parcelRequire("6M7UH");

var $7XNox = parcelRequire("7XNox");

var $63Pef = parcelRequire("63Pef");

var $fJYci = parcelRequire("fJYci");

var $47V1p = parcelRequire("47V1p");

var $eaAgR = parcelRequire("eaAgR");
const $73a4bca3d1b76fab$var$Elements = {
    AppliedToComponentsCount: $2TxTu.default,
    AssignedTo: $4pP1K.default,
    AssignedToGroup: $8VhG4.default,
    AttachmentCount: $jaRTQ.default,
    AuthorGroup: $lR3MV.default,
    ChecklistProgress: $jf7a7.default,
    CollaboratorGroup: $iU6l7.default,
    CommentCount: $k8wNj.default,
    CreatedBy: $lLEGZ.default,
    CreatedOn: $iTIMD.default,
    DueOn: $jZNZe.default,
    HostName: $co4V5.default,
    LatestCommit: $1YXxS.default,
    LinkIcon: $lgzQp.default,
    Location: $98x8l.default,
    ModifiedBy: $whVOD.default,
    ModifiedOn: $6bVEJ.default,
    OwnedBy: $79YtU.default,
    OwnedByGroup: $40odn.default,
    Preview: $f3OWg.default,
    Priority: $2XIml.default,
    ProgrammingLanguage: $69cJJ.default,
    Provider: $beIZm.default,
    ReactCount: $gIpkO.default,
    ReadTime: $1gqay.default,
    SentOn: $8EnvJ.default,
    Snippet: $3DaZe.default,
    SourceBranch: $4VZZ9.default,
    State: $i6SML.default,
    StoryPoints: $e5w9n.default,
    SubTasksProgress: $aPBCU.default,
    SubscriberCount: $6pxsJ.default,
    TargetBranch: $4wkZy.default,
    TeamMemberCount: $6M7UH.default,
    Title: $7XNox.default,
    UserAttributes: $63Pef.default,
    ViewCount: $fJYci.default,
    VoteCount: $47V1p.default
};
const $73a4bca3d1b76fab$export$d7fc505bb0bd5756 = (node)=>{
    if (!/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).isValidElement(node)) return false;
    if (Object.values($73a4bca3d1b76fab$var$Elements).some((type)=>type === node.type)) return true;
    if ((0, $eaAgR.isStyleCacheProvider)(node)) {
        // Component wrapped with compiled at runtime, check for children
        let isChildrenValid = true;
        (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).Children.map(node.props.children, (child)=>{
            var _child$type;
            if (!/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).isValidElement(child)) {
                isChildrenValid = false;
                return;
            }
            if (typeof child.type !== 'string' && ((_child$type = child.type) === null || _child$type === void 0 ? void 0 : _child$type.name) !== 'Style') isChildrenValid = $73a4bca3d1b76fab$export$d7fc505bb0bd5756(child);
        });
        return isChildrenValid;
    }
    return false;
};

});
parcelRegister("2TxTu", function(module, exports) {
$parcel$export(module.exports, "default", () => $43e09e9b88a45ccd$export$2e2bcd8739ae039);

var $bSJIT = parcelRequire("bSJIT");

var $4vLTk = parcelRequire("4vLTk");

var $5kJPq = parcelRequire("5kJPq");

var $7wYyA = parcelRequire("7wYyA");

var $7Z1Fb = parcelRequire("7Z1Fb");

var $1s24H = parcelRequire("1s24H");
const $43e09e9b88a45ccd$var$AppliedToComponentsCountElement = (props)=>{
    const { formatMessage: formatMessage } = (0, $4vLTk.default)();
    const context = (0, $7Z1Fb.useFlexibleUiContext)();
    if (// Check for null and undefined, render if it's 0.
    (context === null || context === void 0 ? void 0 : context.appliedToComponentsCount) === null || (context === null || context === void 0 ? void 0 : context.appliedToComponentsCount) === undefined) return null;
    const label = formatMessage((0, $7wYyA.messages).compass_applied_components_count, {
        numberOfComponents: context.appliedToComponentsCount
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $1s24H.default), {
        icon: (0, $5kJPq.IconType).Component,
        label: label,
        ...props
    });
};
var $43e09e9b88a45ccd$export$2e2bcd8739ae039 = $43e09e9b88a45ccd$var$AppliedToComponentsCountElement;

});
parcelRegister("1s24H", function(module, exports) {
$parcel$export(module.exports, "default", () => $e716ff3e0a919c1a$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v3.0.2 */ /* eslint-disable @atlaskit/design-system/use-tokens-typography */ 
var $9fU1q = parcelRequire("9fU1q");

var $bSJIT = parcelRequire("bSJIT");

var $9PwDt = parcelRequire("9PwDt");

var $5kJPq = parcelRequire("5kJPq");

var $7wYyA = parcelRequire("7wYyA");

var $3P7qX = parcelRequire("3P7qX");

var $cUXyD = parcelRequire("cUXyD");

var $1kLa3 = parcelRequire("1kLa3");

var $9YTee = parcelRequire("9YTee");

var $1K1oW = parcelRequire("1K1oW");

var $ctUly = parcelRequire("ctUly");
const $e716ff3e0a919c1a$var$styles = {
    container: "_zulp1b66 _1e0c116y _4cvr1h6o _1ul91ns9",
    icon: "_1e0c116y _v4pn116y _1b94116y _1ii7116y _4t3i7vkz _bna77vkz _1xjx7vkz _17527vkz _ca0qze3t _14bqze3t _1oh2ze3t _i2i3ze3t _u5f3ze3t _3tceze3t _99ztze3t _uhasze3t _n3tdze3t _1ym6ze3t _1m2uze3t _5jw9ze3t _19bvze3t _1xr1ze3t _9n9oze3t _7wy9ze3t _1bsb7vkz _mezj7vkz _e2oo7vkz _w8l57vkz _s7n4nkob _rtqbnkob _e4kmnkob _z239nkob",
    text: "_11c8wadc"
};
const $e716ff3e0a919c1a$var$colorMap = {
    subtle: "_syaz1rpy",
    default: "_syazazsu"
};
const $e716ff3e0a919c1a$var$messageMapper = {
    [(0, $5kJPq.IconType).PriorityBlocker]: (0, $7wYyA.messages).priority_blocker,
    [(0, $5kJPq.IconType).PriorityCritical]: (0, $7wYyA.messages).priority_critical,
    [(0, $5kJPq.IconType).PriorityHigh]: (0, $7wYyA.messages).priority_high,
    [(0, $5kJPq.IconType).PriorityHighest]: (0, $7wYyA.messages).priority_highest,
    [(0, $5kJPq.IconType).PriorityLow]: (0, $7wYyA.messages).priority_low,
    [(0, $5kJPq.IconType).PriorityLowest]: (0, $7wYyA.messages).priority_lowest,
    [(0, $5kJPq.IconType).PriorityMajor]: (0, $7wYyA.messages).priority_major,
    [(0, $5kJPq.IconType).PriorityMedium]: (0, $7wYyA.messages).priority_medium,
    [(0, $5kJPq.IconType).PriorityMinor]: (0, $7wYyA.messages).priority_minor,
    [(0, $5kJPq.IconType).PriorityTrivial]: (0, $7wYyA.messages).priority_trivial,
    [(0, $5kJPq.IconType).PriorityUndefined]: (0, $7wYyA.messages).priority_undefined
};
const $e716ff3e0a919c1a$var$getFormattedMessageFromIcon = (icon)=>{
    if (icon) {
        const descriptor = $e716ff3e0a919c1a$var$messageMapper[icon];
        if (descriptor) return (0, $ctUly.getFormattedMessage)({
            descriptor: descriptor
        });
    }
};
const $e716ff3e0a919c1a$var$renderAtlaskitIcon = (icon, testId)=>{
    if (icon) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $9YTee.default), {
        icon: icon,
        label: icon,
        testId: `${testId}-icon`
    });
};
const $e716ff3e0a919c1a$var$renderImageIcon = (url, testId, hideLoadingSkeleton)=>{
    if (url) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $1kLa3.default), {
        testId: testId,
        url: url,
        hideLoadingSkeleton: hideLoadingSkeleton
    });
};
/**
 * A base element that displays some text with an associated icon.
 * @internal
 * @param {BaseBadgeElementProps} BaseBadgeElementProps - The props necessary for the Badge.
 * @see CommentCount
 * @see ViewCount
 * @see ReactCount
 * @see VoteCount
 * @see SubscriberCount
 * @see Priority
 * @see ProgrammingLanguage
 * @see Provider
 */ const $e716ff3e0a919c1a$var$BaseBadgeRefreshNew = /*#__PURE__*/ (0, $bSJIT.forwardRef)(({ appearance: appearance = 'default', hideIcon: hideIcon = false, icon: icon, label: label, name: name, testId: testId = 'smart-element-badge', url: url, color: color, hideLabel: hideLabel = false }, ref)=>{
    const ui = (0, $3P7qX.useFlexibleUiOptionContext)();
    const { product: product } = (0, $cUXyD.default)();
    const formattedMessageOrLabel = $e716ff3e0a919c1a$var$getFormattedMessageFromIcon(icon) || label;
    const badgeIcon = $e716ff3e0a919c1a$var$renderAtlaskitIcon(icon, testId) || $e716ff3e0a919c1a$var$renderImageIcon(url, testId, ui === null || ui === void 0 ? void 0 : ui.hideLoadingSkeleton);
    if (!formattedMessageOrLabel || !badgeIcon) return null;
    const shouldHideLabel = hideLabel && !!product && product === 'CONFLUENCE';
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement("span", {
        "data-smart-element": name,
        "data-smart-element-badge": true,
        "data-testid": testId,
        ref: ref,
        style: {
            color: color
        },
        className: (0, $9fU1q.default)([
            $e716ff3e0a919c1a$var$styles.container,
            $e716ff3e0a919c1a$var$colorMap[appearance]
        ])
    }, !hideIcon && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $9PwDt.Box), {
        as: "span",
        xcss: $e716ff3e0a919c1a$var$styles.icon
    }, badgeIcon), !shouldHideLabel && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $9PwDt.Box), {
        as: "span",
        testId: `${testId}-label`,
        xcss: $e716ff3e0a919c1a$var$styles.text
    }, formattedMessageOrLabel));
});
const $e716ff3e0a919c1a$var$_default_1 = (0, $1K1oW.withOverrideCss)($e716ff3e0a919c1a$var$BaseBadgeRefreshNew);
var $e716ff3e0a919c1a$export$2e2bcd8739ae039 = $e716ff3e0a919c1a$var$_default_1;

});
parcelRegister("ctUly", function(module, exports) {
$parcel$export(module.exports, "getFormattedMessage", () => $51592aade304cfb1$export$f1aa79f2218fb713);

var $bSJIT = parcelRequire("bSJIT");

var $5cKiX = parcelRequire("5cKiX");
const $51592aade304cfb1$export$f1aa79f2218fb713 = (message)=>{
    if (message) {
        const { descriptor: descriptor, values: values } = message;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $5cKiX.default), {
            ...descriptor,
            values: values
        });
    }
};

});



parcelRegister("4pP1K", function(module, exports) {
$parcel$export(module.exports, "default", () => $87848939e0218e2a$export$2e2bcd8739ae039);

var $bSJIT = parcelRequire("bSJIT");

var $5kJPq = parcelRequire("5kJPq");

var $7wYyA = parcelRequire("7wYyA");

var $7Z1Fb = parcelRequire("7Z1Fb");

var $7pUjV = parcelRequire("7pUjV");
var $J1wso = parcelRequire("J1wso");
const $87848939e0218e2a$var$AssignedToElement = (props)=>{
    const context = (0, $7Z1Fb.useFlexibleUiContext)();
    const data = context ? (0, $J1wso.toFormattedTextProps)((0, $7wYyA.messages).assigned_to, context.assignedTo) : null;
    return data ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $7pUjV.default), {
        ...data,
        ...props,
        name: (0, $5kJPq.ElementName).AssignedTo
    }) : null;
};
var $87848939e0218e2a$export$2e2bcd8739ae039 = $87848939e0218e2a$var$AssignedToElement;

});
parcelRegister("7pUjV", function(module, exports) {
$parcel$export(module.exports, "default", () => $e5fbdafda40e2d8d$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $RxuW4 = parcelRequire("RxuW4");
var $e5fbdafda40e2d8d$export$2e2bcd8739ae039 = (0, $RxuW4.BaseTextElement);

});
parcelRegister("RxuW4", function(module, exports) {
$parcel$export(module.exports, "BaseTextElement", () => $219a7deb654a578b$export$79422073c7118b5b);
/* BaseTextElement.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $bSJIT = parcelRequire("bSJIT");

var $9fU1q = parcelRequire("9fU1q");
var $3zY6O = parcelRequire("3zY6O");

var $ctUly = parcelRequire("ctUly");
const $219a7deb654a578b$var$baseStyle = null;
const $219a7deb654a578b$var$fontOverrideStyleMap = {
    'font.body': "_11c8fhey",
    'font.body.large': "_11c81d4k",
    'font.body.small': "_11c8wadc"
};
const $219a7deb654a578b$export$79422073c7118b5b = ({ content: content, maxLines: maxLines = 1, message: message, name: name, className: className, testId: testId = 'smart-element-text', hideFormat: hideFormat = false, color: color, fontSize: fontSize })=>{
    if (!message && !content) return null;
    const dynamicCss = null;
    const formattedContent = hideFormat && content ? content : (0, $ctUly.getFormattedMessage)(message) || content;
    return /*#__PURE__*/ $bSJIT.createElement("span", {
        "data-separator": true,
        "data-smart-element": name,
        "data-smart-element-text": true,
        "data-testid": testId,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
        className: (0, $9fU1q.default)([
            "_11c8wadc _1reo15vq _18m915vq _syazazsu _o5724jg8 _1e0ccj1k _1ul9idpf _1bto1l2s _1nmz1hna _sudp1e54",
            fontSize !== undefined && $219a7deb654a578b$var$fontOverrideStyleMap[fontSize],
            "_1yyjr31u _102k1dud",
            className
        ]),
        style: {
            color: color,
            "--_1erfju8": (0, $3zY6O.default)(maxLines)
        }
    }, formattedContent);
};

});


parcelRegister("J1wso", function(module, exports) {
$parcel$export(module.exports, "toFormattedTextProps", () => $2cf62d7a1a7efe78$export$b9738bf28fb14829);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ const $2cf62d7a1a7efe78$export$b9738bf28fb14829 = (descriptor, context)=>{
    return context ? {
        message: {
            descriptor: descriptor,
            values: {
                context: context
            }
        },
        content: context
    } : undefined;
};

});


parcelRegister("8VhG4", function(module, exports) {
$parcel$export(module.exports, "default", () => $06ea17097173c040$export$2e2bcd8739ae039);

var $bSJIT = parcelRequire("bSJIT");

var $5kJPq = parcelRequire("5kJPq");

var $7Z1Fb = parcelRequire("7Z1Fb");

var $1hLZg = parcelRequire("1hLZg");
var $5IWYF = parcelRequire("5IWYF");
const $06ea17097173c040$var$AssignedToGroupElement = (props)=>{
    const context = (0, $7Z1Fb.useFlexibleUiContext)();
    const data = context ? (0, $5IWYF.toAvatarGroupProps)(context.assignedToGroup, true) : null;
    return data ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $1hLZg.default), {
        ...data,
        ...props,
        name: (0, $5kJPq.ElementName).AssignedToGroup
    }) : null;
};
var $06ea17097173c040$export$2e2bcd8739ae039 = $06ea17097173c040$var$AssignedToGroupElement;

});
parcelRegister("1hLZg", function(module, exports) {
$parcel$export(module.exports, "default", () => $08d1a1ffbc8c4c57$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $bSJIT = parcelRequire("bSJIT");

var $9fU1q = parcelRequire("9fU1q");

var $4vLTk = parcelRequire("4vLTk");

var $2eoYM = parcelRequire("2eoYM");

var $5kJPq = parcelRequire("5kJPq");

var $7wYyA = parcelRequire("7wYyA");

var $6ZBhf = parcelRequire("6ZBhf");
const $08d1a1ffbc8c4c57$var$styles = null;
const $08d1a1ffbc8c4c57$var$getPersonNameWithPrefix = (elementName, personName, intl)=>{
    switch(elementName){
        case (0, $5kJPq.ElementName).AssignedToGroup:
            return (0, $6ZBhf.getFormattedMessageAsString)(intl, (0, $7wYyA.messages).assigned_to, personName);
        case (0, $5kJPq.ElementName).OwnedByGroup:
            return (0, $6ZBhf.getFormattedMessageAsString)(intl, (0, $7wYyA.messages).owned_by, personName);
        case (0, $5kJPq.ElementName).AuthorGroup:
            return (0, $6ZBhf.getFormattedMessageAsString)(intl, (0, $7wYyA.messages).created_by, personName);
        default:
            return personName;
    }
};
/**
 * A base element that displays a group of avatars.
 * @internal
 * @param {BaseAvatarGroupElementProps} BaseAvatarGroupElementProps - The props necessary for the AvatarGroup.
 * @see AuthorGroup
 * @see CollaboratorGroup
 */ const $08d1a1ffbc8c4c57$var$BaseAvatarGroup = ({ items: items = [], maxCount: maxCount = 4, name: name, className: className, testId: testId = 'smart-element-avatar-group', showNamePrefix: showNamePrefix = false, showFallbackAvatar: showFallbackAvatar = true })=>{
    const intl = (0, $4vLTk.default)();
    const data = (0, $bSJIT.useMemo)(()=>{
        if (!items.length && showFallbackAvatar) switch(name){
            case (0, $5kJPq.ElementName).AssignedToGroup:
                return [
                    {
                        name: (0, $6ZBhf.getFormattedMessageAsString)(intl, (0, $7wYyA.messages).unassigned)
                    }
                ];
            default:
                return [];
        }
        //show a name prefix if there is one Avatar in a group only
        if (name && items.length === 1 && showNamePrefix) return items.map((person)=>{
            return {
                ...person,
                name: $08d1a1ffbc8c4c57$var$getPersonNameWithPrefix(name, person.name, intl) || person.name
            };
        });
        return items;
    }, [
        name,
        items,
        showNamePrefix,
        showFallbackAvatar,
        intl
    ]);
    if (!data.length) return null;
    return /*#__PURE__*/ $bSJIT.createElement("span", {
        // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
        "data-separator": true,
        "data-smart-element": name,
        "data-smart-element-avatar-group": true,
        "data-testid": testId,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
        className: (0, $9fU1q.default)([
            "_1ul91ns9 _1e0c116y _1kvxu2gc _102oidpf",
            className
        ])
    }, /*#__PURE__*/ $bSJIT.createElement((0, $2eoYM.default), {
        maxCount: maxCount,
        appearance: "stack",
        size: "small",
        data: data,
        testId: testId
    }));
};
var $08d1a1ffbc8c4c57$export$2e2bcd8739ae039 = $08d1a1ffbc8c4c57$var$BaseAvatarGroup;

});
parcelRegister("6ZBhf", function(module, exports) {
$parcel$export(module.exports, "getFormattedMessageAsString", () => $ca817bebc4aa6d9e$export$66ecb50a9dd1768);
const $ca817bebc4aa6d9e$export$66ecb50a9dd1768 = (intl, message, context)=>{
    const { formatMessage: formatMessage } = intl;
    return message ? formatMessage(message, {
        context: context
    }) : '';
};

});


parcelRegister("5IWYF", function(module, exports) {
$parcel$export(module.exports, "toAvatarGroupProps", () => $5ff4cd8b987e2998$export$91ba8651475968bd);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ const $5ff4cd8b987e2998$export$91ba8651475968bd = (items, showFallbackAvatar)=>{
    return items ? {
        items: items
    } : showFallbackAvatar ? {
        items: []
    } : undefined;
};

});


parcelRegister("jaRTQ", function(module, exports) {
$parcel$export(module.exports, "default", () => $855c6806c2536de3$export$2e2bcd8739ae039);

var $bSJIT = parcelRequire("bSJIT");

var $5kJPq = parcelRequire("5kJPq");

var $7Z1Fb = parcelRequire("7Z1Fb");

var $1s24H = parcelRequire("1s24H");
var $ajXQ9 = parcelRequire("ajXQ9");
const $855c6806c2536de3$var$AttachmentCountElement = (props)=>{
    var _context$attachmentCo;
    const context = (0, $7Z1Fb.useFlexibleUiContext)();
    const data = context ? (0, $ajXQ9.toBadgeProps)((_context$attachmentCo = context.attachmentCount) === null || _context$attachmentCo === void 0 ? void 0 : _context$attachmentCo.toString()) : null;
    return data ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $1s24H.default), {
        icon: (0, $5kJPq.IconType).Attachment,
        ...data,
        ...props,
        name: (0, $5kJPq.ElementName).AttachmentCount
    }) : null;
};
var $855c6806c2536de3$export$2e2bcd8739ae039 = $855c6806c2536de3$var$AttachmentCountElement;

});
parcelRegister("ajXQ9", function(module, exports) {
$parcel$export(module.exports, "toBadgeProps", () => $93cde710f31c8b0a$export$a2fb457791942ba4);
/* eslint-disable @atlaskit/design-system/use-tokens-typography */ /**
 * @jsxRuntime classic
 * @jsx jsx
 */ const $93cde710f31c8b0a$export$a2fb457791942ba4 = (label)=>{
    // Don't render the element if its 0
    return label !== '0' && label ? {
        label: label
    } : undefined;
};

});


parcelRegister("lR3MV", function(module, exports) {
$parcel$export(module.exports, "default", () => $41aa71807544fbbf$export$2e2bcd8739ae039);

var $bSJIT = parcelRequire("bSJIT");

var $5kJPq = parcelRequire("5kJPq");

var $7Z1Fb = parcelRequire("7Z1Fb");

var $1hLZg = parcelRequire("1hLZg");
var $5IWYF = parcelRequire("5IWYF");
const $41aa71807544fbbf$var$AuthorGroupElement = (props)=>{
    const context = (0, $7Z1Fb.useFlexibleUiContext)();
    const data = context ? (0, $5IWYF.toAvatarGroupProps)(context.authorGroup, false) : null;
    return data ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $1hLZg.default), {
        ...data,
        ...props,
        name: (0, $5kJPq.ElementName).AuthorGroup
    }) : null;
};
var $41aa71807544fbbf$export$2e2bcd8739ae039 = $41aa71807544fbbf$var$AuthorGroupElement;

});

parcelRegister("jf7a7", function(module, exports) {
$parcel$export(module.exports, "default", () => $01d7df8ffb05d123$export$2e2bcd8739ae039);

var $bSJIT = parcelRequire("bSJIT");

var $5kJPq = parcelRequire("5kJPq");

var $7Z1Fb = parcelRequire("7Z1Fb");

var $1s24H = parcelRequire("1s24H");
var $ajXQ9 = parcelRequire("ajXQ9");
const $01d7df8ffb05d123$var$ChecklistProgressElement = (props)=>{
    var _context$checklistPro;
    const context = (0, $7Z1Fb.useFlexibleUiContext)();
    const data = context ? (0, $ajXQ9.toBadgeProps)((_context$checklistPro = context.checklistProgress) === null || _context$checklistPro === void 0 ? void 0 : _context$checklistPro.toString()) : null;
    return data ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $1s24H.default), {
        icon: (0, $5kJPq.IconType).CheckItem,
        ...data,
        ...props,
        name: (0, $5kJPq.ElementName).ChecklistProgress
    }) : null;
};
var $01d7df8ffb05d123$export$2e2bcd8739ae039 = $01d7df8ffb05d123$var$ChecklistProgressElement;

});

parcelRegister("iU6l7", function(module, exports) {
$parcel$export(module.exports, "default", () => $f72c5c0d9ab98503$export$2e2bcd8739ae039);

var $bSJIT = parcelRequire("bSJIT");

var $5kJPq = parcelRequire("5kJPq");

var $7Z1Fb = parcelRequire("7Z1Fb");

var $1hLZg = parcelRequire("1hLZg");
var $5IWYF = parcelRequire("5IWYF");
const $f72c5c0d9ab98503$var$CollaboratorGroupElement = (props)=>{
    const context = (0, $7Z1Fb.useFlexibleUiContext)();
    const data = context ? (0, $5IWYF.toAvatarGroupProps)(context.collaboratorGroup, false) : undefined;
    return data ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $1hLZg.default), {
        ...data,
        ...props,
        name: (0, $5kJPq.ElementName).CollaboratorGroup
    }) : null;
};
var $f72c5c0d9ab98503$export$2e2bcd8739ae039 = $f72c5c0d9ab98503$var$CollaboratorGroupElement;

});

parcelRegister("k8wNj", function(module, exports) {
$parcel$export(module.exports, "default", () => $7422b6209fd0bf8a$export$2e2bcd8739ae039);

var $bSJIT = parcelRequire("bSJIT");

var $5kJPq = parcelRequire("5kJPq");

var $7Z1Fb = parcelRequire("7Z1Fb");

var $1s24H = parcelRequire("1s24H");
var $ajXQ9 = parcelRequire("ajXQ9");
const $7422b6209fd0bf8a$var$CommentCountElement = (props)=>{
    var _context$commentCount;
    const context = (0, $7Z1Fb.useFlexibleUiContext)();
    const data = context ? (0, $ajXQ9.toBadgeProps)((_context$commentCount = context.commentCount) === null || _context$commentCount === void 0 ? void 0 : _context$commentCount.toString()) : null;
    const { onRender: onRender, ...restProps } = props || {};
    (0, $bSJIT.useEffect)(()=>{
        onRender === null || onRender === void 0 || onRender(!!data);
    }, [
        data,
        onRender
    ]);
    return data ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $1s24H.default), {
        icon: (0, $5kJPq.IconType).Comment,
        ...data,
        ...restProps,
        name: (0, $5kJPq.ElementName).CommentCount
    }) : null;
};
var $7422b6209fd0bf8a$export$2e2bcd8739ae039 = $7422b6209fd0bf8a$var$CommentCountElement;

});

parcelRegister("lLEGZ", function(module, exports) {
$parcel$export(module.exports, "default", () => $e670044b69ad7632$export$2e2bcd8739ae039);

var $bSJIT = parcelRequire("bSJIT");

var $5kJPq = parcelRequire("5kJPq");

var $7wYyA = parcelRequire("7wYyA");

var $7Z1Fb = parcelRequire("7Z1Fb");

var $7pUjV = parcelRequire("7pUjV");
var $J1wso = parcelRequire("J1wso");
const $e670044b69ad7632$var$CreatedByElement = (props)=>{
    const context = (0, $7Z1Fb.useFlexibleUiContext)();
    const data = context ? (0, $J1wso.toFormattedTextProps)((0, $7wYyA.messages).created_by, context.createdBy) : null;
    return data ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $7pUjV.default), {
        ...data,
        ...props,
        name: (0, $5kJPq.ElementName).CreatedBy
    }) : null;
};
var $e670044b69ad7632$export$2e2bcd8739ae039 = $e670044b69ad7632$var$CreatedByElement;

});

parcelRegister("iTIMD", function(module, exports) {
$parcel$export(module.exports, "default", () => $e78752df296b871d$export$2e2bcd8739ae039);

var $bSJIT = parcelRequire("bSJIT");

var $5kJPq = parcelRequire("5kJPq");

var $7Z1Fb = parcelRequire("7Z1Fb");

var $kQMNw = parcelRequire("kQMNw");
var $lxUke = parcelRequire("lxUke");
const $e78752df296b871d$var$CreatedOnElement = (props)=>{
    const context = (0, $7Z1Fb.useFlexibleUiContext)();
    const data = context ? (0, $lxUke.toDateTimeProps)('created', context.createdOn) : null;
    return data ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $kQMNw.default), {
        ...data,
        ...props,
        name: (0, $5kJPq.ElementName).CreatedOn
    }) : null;
};
var $e78752df296b871d$export$2e2bcd8739ae039 = $e78752df296b871d$var$CreatedOnElement;

});
parcelRegister("kQMNw", function(module, exports) {
$parcel$export(module.exports, "default", () => $c8859664e574ada3$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $bSJIT = parcelRequire("bSJIT");

var $9fU1q = parcelRequire("9fU1q");

var $gv8eX = parcelRequire("gv8eX");

var $5cKiX = parcelRequire("5cKiX");
var $4vLTk = parcelRequire("4vLTk");

var $gdUUy = parcelRequire("gdUUy");

var $7wYyA = parcelRequire("7wYyA");
const $c8859664e574ada3$var$styles = null;
const $c8859664e574ada3$var$ABSOLUTE_DATE_FORMAT = {
    month: 'short',
    day: 'numeric',
    year: 'numeric'
};
const $c8859664e574ada3$var$isValidTimeZone = (timeZone)=>{
    try {
        new Intl.DateTimeFormat(undefined, {
            timeZone: timeZone
        });
        return true;
    } catch  {
        return false;
    }
};
const $c8859664e574ada3$var$formatAbsoluteDateWithOptionalTimeZone = ({ date: date, formatDate: formatDate, timeZone: timeZone })=>{
    if (!timeZone || !$c8859664e574ada3$var$isValidTimeZone(timeZone)) return formatDate(date, $c8859664e574ada3$var$ABSOLUTE_DATE_FORMAT);
    return formatDate(date, {
        ...$c8859664e574ada3$var$ABSOLUTE_DATE_FORMAT,
        timeZone: timeZone
    });
};
const $c8859664e574ada3$var$typeToDescriptorMap = {
    created: {
        relative: (0, $7wYyA.messages).created_on_relative,
        absolute: (0, $7wYyA.messages).created_on_absolute
    },
    modified: {
        relative: (0, $7wYyA.messages).modified_on_relative,
        absolute: (0, $7wYyA.messages).modified_on_absolute
    },
    sent: {
        relative: (0, $7wYyA.messages).sent_on_relative,
        absolute: (0, $7wYyA.messages).sent_on_absolute
    }
};
const $c8859664e574ada3$var$fontOverrideStyleMap = {
    'font.body': "_11c8fhey",
    'font.body.large': "_11c81d4k",
    'font.body.small': "_11c8wadc"
};
/**
 * A base element that displays an ISO Timestamp in text.
 * @internal
 * @param {BaseDateTimeElementProps} BaseDateTimeElementProps - The props necessary for the DateTime element.
 * @see CreatedOn
 * @see ModifiedOn
 * @see SentOn
 */ const $c8859664e574ada3$var$BaseDateTimeElement = ({ date: date, name: name, className: className, type: type, testId: testId = 'smart-element-date-time', text: text, hideDatePrefix: hideDatePrefix = false, color: color, fontSize: fontSize, timeZone: timeZone })=>{
    const { formatRelativeTime: formatRelativeTime, formatDate: formatDate } = (0, $4vLTk.default)();
    if (!type || !date) return null;
    const isLongerThenWeek = Math.abs(date.getTime() - Date.now()) > 604800000;
    let context;
    let typeVariant;
    if (isLongerThenWeek) {
        typeVariant = 'absolute';
        context = (0, $gdUUy.fg)('dfo_issue_view_remote_data_srr_group') ? $c8859664e574ada3$var$formatAbsoluteDateWithOptionalTimeZone({
            date: date,
            formatDate: formatDate,
            timeZone: timeZone
        }) : formatDate(date, {
            month: 'short',
            day: 'numeric',
            year: 'numeric'
        });
    } else {
        const { value: value, unit: unit } = (0, $gv8eX.selectUnit)(date, Date.now());
        typeVariant = 'relative';
        context = formatRelativeTime(value, unit, {
            numeric: 'auto'
        });
    }
    let content;
    if (hideDatePrefix) content = context;
    else if (text) content = `${text} ${context}`;
    else content = /*#__PURE__*/ $bSJIT.createElement((0, $5cKiX.default), {
        ...$c8859664e574ada3$var$typeToDescriptorMap[type][typeVariant],
        values: {
            context: context
        }
    });
    return /*#__PURE__*/ $bSJIT.createElement("span", {
        style: {
            color: color
        },
        "data-separator": true,
        "data-smart-element": name,
        "data-smart-element-date-time": true,
        "data-testid": testId,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
        className: (0, $9fU1q.default)([
            "_11c8wadc _1reo15vq _18m915vq _syazazsu _1e0ccj1k _1ul9idpf _1bto1l2s _1nmz1hna _1yyjkb7n _sudp1e54 _102k7vkz",
            fontSize !== undefined && $c8859664e574ada3$var$fontOverrideStyleMap[fontSize],
            className
        ])
    }, content);
};
var $c8859664e574ada3$export$2e2bcd8739ae039 = $c8859664e574ada3$var$BaseDateTimeElement;

});

parcelRegister("lxUke", function(module, exports) {
$parcel$export(module.exports, "toDateTimeProps", () => $07d9fa30e3f27852$export$2d4384e6b150cbe3);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ const $07d9fa30e3f27852$export$2d4384e6b150cbe3 = (type, dateString)=>{
    return dateString ? {
        date: new Date(dateString),
        type: type
    } : undefined;
};

});


parcelRegister("jZNZe", function(module, exports) {
$parcel$export(module.exports, "default", () => $ae6887c879ce9240$export$2e2bcd8739ae039);

var $bSJIT = parcelRequire("bSJIT");

var $5kJPq = parcelRequire("5kJPq");

var $7Z1Fb = parcelRequire("7Z1Fb");

var $ftIZv = parcelRequire("ftIZv");
var $5H8Tq = parcelRequire("5H8Tq");
const $ae6887c879ce9240$var$DueOnElement = (props)=>{
    const context = (0, $7Z1Fb.useFlexibleUiContext)();
    const data = context ? (0, $5H8Tq.toDateLozengeProps)(context.dueOn) : null;
    return data ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $ftIZv.default), {
        ...data,
        ...props,
        name: (0, $5kJPq.ElementName).DueOn,
        isDateTag: true
    }) : null;
};
var $ae6887c879ce9240$export$2e2bcd8739ae039 = $ae6887c879ce9240$var$DueOnElement;

});
parcelRegister("ftIZv", function(module, exports) {
$parcel$export(module.exports, "default", () => $65e0fd3f1744660d$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $bSJIT = parcelRequire("bSJIT");

var $9fU1q = parcelRequire("9fU1q");

var $1emO3 = parcelRequire("1emO3");

var $gdUUy = parcelRequire("gdUUy");

var $bRgFV = parcelRequire("bRgFV");

var $5kJPq = parcelRequire("5kJPq");

var $3P7qX = parcelRequire("3P7qX");

var $ey2br = parcelRequire("ey2br");
const $65e0fd3f1744660d$var$styles = null;
const $65e0fd3f1744660d$var$dueOnStyles = null;
/**
 * A base element that displays a Lozenge.
 * @internal
 * @param {BaseLozengeElementProps} BaseLozengeElementProps - The props necessary for the Lozenge element.
 * @see State
 */ const $65e0fd3f1744660d$var$BaseLozengeElement = ({ action: action, appearance: appearance = 'default', className: className, maxWidth: maxWidth, name: name, onAfterChanged: onAfterChanged, style: style, text: text, testId: testId = 'smart-element-lozenge', isDateTag: isDateTag, trailingMetric: trailingMetric })=>{
    const ui = (0, $3P7qX.useFlexibleUiOptionContext)();
    if (!text) return null;
    const lozenge = action ? /*#__PURE__*/ $bSJIT.createElement((0, $ey2br.default), {
        action: action,
        appearance: appearance,
        maxWidth: maxWidth,
        testId: testId,
        text: text,
        zIndex: ui === null || ui === void 0 ? void 0 : ui.zIndex,
        shouldRenderToParent: (0, $gdUUy.fg)('billplat_jira_list_dropdown_top_layer') && name === (0, $5kJPq.ElementName).State && Boolean(ui === null || ui === void 0 ? void 0 : ui.shouldRenderStatusToParent),
        onAfterChanged: onAfterChanged,
        ...trailingMetric && (0, $gdUUy.fg)('platform-dst-lozenge-tag-badge-visual-uplifts') ? {
            trailingMetric: trailingMetric
        } : undefined
    }) : isDateTag ? /*#__PURE__*/ $bSJIT.createElement((0, $bRgFV.default), {
        text: text,
        migration_fallback: "lozenge"
    }) : /*#__PURE__*/ $bSJIT.createElement((0, $1emO3.default), {
        appearance: appearance,
        isBold: true,
        maxWidth: maxWidth,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: style,
        testId: `${testId}-lozenge`,
        ...trailingMetric && (0, $gdUUy.fg)('platform-dst-lozenge-tag-badge-visual-uplifts') ? {
            trailingMetric: trailingMetric
        } : undefined
    }, text);
    return /*#__PURE__*/ $bSJIT.createElement("span", {
        "data-smart-element": name,
        "data-smart-element-lozenge": true,
        "data-testid": testId,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
        className: (0, $9fU1q.default)([
            "_1e0c116y _1ul91ns9",
            isDateTag && (0, $gdUUy.fg)('platform-dst-lozenge-tag-badge-visual-uplifts') && "_19pkr5cr _2hwxr5cr _otyrr5cr _18u0r5cr",
            className
        ])
    }, lozenge);
};
var $65e0fd3f1744660d$export$2e2bcd8739ae039 = $65e0fd3f1744660d$var$BaseLozengeElement;

});
parcelRegister("bRgFV", function(module, exports) {
$parcel$export(module.exports, "default", () => $c5264ea95b861890$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $dc70d = parcelRequire("dc70d");

var $bSJIT = parcelRequire("bSJIT");

var $iW5ND = parcelRequire("iW5ND");

var $7d1b3 = parcelRequire("7d1b3");

var $boXhX = parcelRequire("boXhX");
const $c5264ea95b861890$var$SimpleTagComponent = /*#__PURE__*/ (0, $bSJIT.forwardRef)(({ elemBefore: elemBefore = null, color: color = 'standard', href: href, linkComponent: linkComponent, testId: testId, text: text = '', maxWidth: maxWidth, swatchBefore: swatchBefore, swatchBeforeLabel: swatchBeforeLabel, swatchBeforeRole: swatchBeforeRole }, ref)=>{
    const newColor = (0, $iW5ND.colorMapping)[color || 'standard'];
    return /*#__PURE__*/ (0, $dc70d.jsx)((0, $boXhX.default), {
        ref: ref,
        color: newColor,
        text: text,
        elemBefore: elemBefore,
        href: href,
        linkComponent: linkComponent,
        testId: testId,
        isRemovable: false,
        maxWidth: maxWidth,
        swatchBefore: swatchBefore,
        swatchBeforeLabel: swatchBeforeLabel,
        swatchBeforeRole: swatchBeforeRole
    });
});
/**
 * __Simple tag__
 *
 * A tag labels UI objects for quick recognition and navigation.
 *
 * `SimpleTag` is the default form of a tag, where text is required. Tags with static text can be used as a flag or as a reference to an object or attribute.
 *
 * - [Examples](https://atlassian.design/components/tag/examples)
 * - [Code](https://atlassian.design/components/tag/code)
 * - [Usage](https://atlassian.design/components/tag/usage)
 *
 * @deprecated `SimpleTag` is deprecated. Use the default `Tag` export from
 * `@atlaskit/tag` with `isRemovable={false}` instead, e.g. `<Tag text="…" isRemovable={false} />`.
 */ const $c5264ea95b861890$var$SimpleTag = (0, $7d1b3.markAsTagMotionCapable)(/*#__PURE__*/ (0, $bSJIT.memo)($c5264ea95b861890$var$SimpleTagComponent));
var $c5264ea95b861890$export$2e2bcd8739ae039 = $c5264ea95b861890$var$SimpleTag;

});

parcelRegister("ey2br", function(module, exports) {
$parcel$export(module.exports, "default", () => $b841cd3551f8d4a8$export$2e2bcd8739ae039);

var $bSJIT = parcelRequire("bSJIT");

var $lkSXl = parcelRequire("lkSXl");

var $gdUUy = parcelRequire("gdUUy");

var $2fwRK = parcelRequire("2fwRK");

var $3ZXjF = parcelRequire("3ZXjF");

var $bKqb0 = parcelRequire("bKqb0");

var $4mdwW = parcelRequire("4mdwW");

var $1Nceg = parcelRequire("1Nceg");

var $1J70m = parcelRequire("1J70m");

var $2hVNZ = parcelRequire("2hVNZ");

var $kR8nW = parcelRequire("kR8nW");

var $y7ZMp = parcelRequire("y7ZMp");

var $9aPz5 = parcelRequire("9aPz5");

var $fQBmO = parcelRequire("fQBmO");

var $bNyt2 = parcelRequire("bNyt2");

var $7hdiE = parcelRequire("7hdiE");
const $b841cd3551f8d4a8$var$validateItems = (items = [], text)=>{
    return items.filter((item)=>item.text !== text);
};
const $b841cd3551f8d4a8$var$LozengeAction = ({ action: action, appearance: appearance, maxWidth: maxWidth, testId: testId = 'smart-element-lozenge-action', text: text, zIndex: zIndex, onAfterChanged: onAfterChanged, trailingMetric: trailingMetric, shouldRenderToParent: shouldRenderToParent = false })=>{
    var _action$update;
    const [selected, setSelected] = (0, $bSJIT.useState)({
        appearance: appearance,
        text: text
    });
    const [isLoaded, setIsLoaded] = (0, $bSJIT.useState)(false);
    const [isLoading, setIsLoading] = (0, $bSJIT.useState)(false);
    const [isOpen, setIsOpen] = (0, $bSJIT.useState)(false);
    const [items, setItems] = (0, $bSJIT.useState)();
    const [errorMessage, setErrorMessage] = (0, $bSJIT.useState)();
    const reload = (0, $1Nceg.default)();
    const invoke = (0, $bKqb0.default)();
    const { fireEvent: fireEvent } = (0, $2fwRK.useAnalyticsEvents)();
    (0, $bSJIT.useEffect)(()=>{
        setSelected({
            text: text,
            appearance: appearance
        });
    }, [
        text,
        appearance
    ]);
    const { url: url, id: linkId, invokePreviewAction: invokePreviewAction } = (action === null || action === void 0 || (_action$update = action.update) === null || _action$update === void 0 ? void 0 : _action$update.details) || {};
    const handleOpenChange = (0, $bSJIT.useCallback)(async (args)=>{
        setIsOpen(args.isOpen);
        if (args.isOpen) {
            fireEvent('ui.button.clicked.smartLinkStatusLozenge', {});
            fireEvent('track.smartLinkQuickAction.started', {
                smartLinkActionType: (0, $2hVNZ.TrackQuickActionType).StatusUpdate
            });
            if (!isLoaded && action !== null && action !== void 0 && action.read) try {
                setIsLoading(true);
                const responseItems = await invoke(action.read, (0, $3ZXjF.default));
                const validItems = typeof text === 'string' ? $b841cd3551f8d4a8$var$validateItems(responseItems, text) : responseItems;
                setItems(validItems);
                setIsLoaded(true);
                if ((validItems === null || validItems === void 0 ? void 0 : validItems.length) === 0) {
                    fireEvent('track.smartLinkQuickAction.failed', (0, $y7ZMp.permissionLoadErrorAnalyticsPayload));
                    setErrorMessage((0, $gdUUy.fg)('confluence-issue-terminology-refresh') ? (0, $fQBmO.LozengeActionErrorMessages).noDataIssueTermRefresh : (0, $fQBmO.LozengeActionErrorMessages).noData);
                    setIsLoaded(false);
                }
            } catch  {
                setErrorMessage((0, $fQBmO.LozengeActionErrorMessages).unknown);
                setIsLoaded(false);
                fireEvent('track.smartLinkQuickAction.failed', (0, $y7ZMp.unknownLoadErrorAnalyticsPayload));
            } finally{
                setIsLoading(false);
            }
        }
        if (!args.isOpen) setErrorMessage(undefined);
    }, [
        action.read,
        invoke,
        isLoaded,
        text,
        fireEvent
    ]);
    const trigger = (0, $bSJIT.useCallback)((props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $7hdiE.default), {
            ...props,
            appearance: selected.appearance,
            isOpen: isOpen,
            maxWidth: maxWidth,
            testId: testId,
            text: selected.text,
            trailingMetric: trailingMetric
        }), [
        selected.appearance,
        selected.text,
        isOpen,
        maxWidth,
        testId,
        trailingMetric
    ]);
    const handleItemClick = (0, $bSJIT.useCallback)(async (id, text, appearance)=>{
        try {
            fireEvent('ui.button.clicked.smartLinkStatusListItem', {});
            const updateAction = action === null || action === void 0 ? void 0 : action.update;
            if (updateAction && id) {
                setIsLoading(true);
                const request = (0, $1J70m.default)(updateAction, id);
                await invoke(request);
                onAfterChanged === null || onAfterChanged === void 0 || onAfterChanged();
                setSelected({
                    appearance: appearance,
                    text: text
                });
                setIsLoading(false);
                setIsLoaded(false);
                setIsOpen(false);
                setItems([]);
                fireEvent('track.smartLinkQuickAction.success', {
                    smartLinkActionType: (0, $2hVNZ.TrackQuickActionType).StatusUpdate
                });
                if (url) await reload({
                    url: url,
                    isReloading: true,
                    id: linkId
                });
            }
        } catch (err) {
            setIsLoading(false);
            if ((0, $4mdwW.isInvokeCustomError)(err)) {
                setErrorMessage(err.message);
                fireEvent('track.smartLinkQuickAction.failed', (0, $y7ZMp.validationUpdateErrorAnalyticsPayload));
            } else {
                setErrorMessage((0, $fQBmO.LozengeActionErrorMessages).updateFailed);
                fireEvent('track.smartLinkQuickAction.failed', (0, $y7ZMp.unknownUpdateErrorAnalyticsPayload));
            }
        }
    }, [
        action === null || action === void 0 ? void 0 : action.update,
        invoke,
        linkId,
        reload,
        url,
        fireEvent,
        onAfterChanged
    ]);
    const dropdownItemGroup = (0, $bSJIT.useMemo)(()=>{
        if (errorMessage) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $9aPz5.default), {
            errorMessage: errorMessage,
            testId: testId,
            url: url,
            invokePreviewAction: invokePreviewAction
        });
        if (items && items.length > 0) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $bNyt2.default), {
            testId: testId,
            items: items,
            onClick: handleItemClick
        });
    }, [
        errorMessage,
        handleItemClick,
        items,
        invokePreviewAction,
        testId,
        url
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $lkSXl.default), {
        isLoading: isLoading,
        isOpen: isOpen,
        onOpenChange: handleOpenChange,
        testId: testId,
        trigger: trigger,
        zIndex: zIndex,
        shouldRenderToParent: shouldRenderToParent
    }, dropdownItemGroup);
};
const $b841cd3551f8d4a8$var$_default_1 = (0, $kR8nW.default)($b841cd3551f8d4a8$var$LozengeAction);
var $b841cd3551f8d4a8$export$2e2bcd8739ae039 = $b841cd3551f8d4a8$var$_default_1;

});
parcelRegister("3ZXjF", function(module, exports) {
$parcel$export(module.exports, "default", () => $a6660708c7dca636$export$2e2bcd8739ae039);
const $a6660708c7dca636$var$extractLozengeActionItems = (response)=>{
    var _response$transitions;
    const items = (response === null || response === void 0 || (_response$transitions = response.transitions) === null || _response$transitions === void 0 ? void 0 : _response$transitions.map(({ appearance: appearance, id: id, name: name })=>({
            appearance: appearance ?? 'default',
            id: id,
            text: name
        }))) ?? [];
    return items.sort((a, b)=>a.appearance.localeCompare(b.appearance) || a.text.localeCompare(b.text));
};
var $a6660708c7dca636$export$2e2bcd8739ae039 = $a6660708c7dca636$var$extractLozengeActionItems;

});

parcelRegister("1J70m", function(module, exports) {
$parcel$export(module.exports, "default", () => $39f12b33c8048804$export$2e2bcd8739ae039);
const $39f12b33c8048804$var$createStatusUpdateRequest = (request, id)=>({
        providerKey: request.providerKey,
        action: {
            ...request.action,
            payload: {
                newStatusId: id
            }
        }
    });
var $39f12b33c8048804$export$2e2bcd8739ae039 = $39f12b33c8048804$var$createStatusUpdateRequest;

});

parcelRegister("kR8nW", function(module, exports) {
$parcel$export(module.exports, "default", () => $1a21150e21c10ede$export$2e2bcd8739ae039);

var $bSJIT = parcelRequire("bSJIT");

var $eime1 = parcelRequire("eime1");

var $1emO3 = parcelRequire("1emO3");
const $1a21150e21c10ede$var$withErrorBoundary = (Component)=>(props)=>{
        const fallback = (0, $bSJIT.useMemo)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $1emO3.default), {
                appearance: props === null || props === void 0 ? void 0 : props.appearance,
                isBold: true,
                testId: `${(props === null || props === void 0 ? void 0 : props.testId) ?? 'smart-element-lozenge-action'}-fallback`,
                trailingMetric: props === null || props === void 0 ? void 0 : props.trailingMetric
            }, props === null || props === void 0 ? void 0 : props.text), [
            props === null || props === void 0 ? void 0 : props.appearance,
            props === null || props === void 0 ? void 0 : props.testId,
            props === null || props === void 0 ? void 0 : props.text,
            props === null || props === void 0 ? void 0 : props.trailingMetric
        ]);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $eime1.ErrorBoundary), {
            fallback: fallback
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement(Component, props));
    };
var $1a21150e21c10ede$export$2e2bcd8739ae039 = $1a21150e21c10ede$var$withErrorBoundary;

});

parcelRegister("y7ZMp", function(module, exports) {
$parcel$export(module.exports, "unknownLoadErrorAnalyticsPayload", () => $9a3daca78e3e47f1$export$2a568ff99500df53);
$parcel$export(module.exports, "permissionLoadErrorAnalyticsPayload", () => $9a3daca78e3e47f1$export$2de2d0ccc17b915f);
$parcel$export(module.exports, "unknownUpdateErrorAnalyticsPayload", () => $9a3daca78e3e47f1$export$c1c05f9d51f7c467);
$parcel$export(module.exports, "validationUpdateErrorAnalyticsPayload", () => $9a3daca78e3e47f1$export$618660b8f2aa87e2);
const $9a3daca78e3e47f1$export$2a568ff99500df53 = {
    smartLinkActionType: 'StatusUpdate',
    reason: 'UnknownError',
    step: 'load'
};
const $9a3daca78e3e47f1$export$2de2d0ccc17b915f = {
    smartLinkActionType: 'StatusUpdate',
    reason: 'PermissionError',
    step: 'load'
};
const $9a3daca78e3e47f1$export$c1c05f9d51f7c467 = {
    smartLinkActionType: 'StatusUpdate',
    reason: 'UnknownError',
    step: 'update'
};
const $9a3daca78e3e47f1$export$618660b8f2aa87e2 = {
    smartLinkActionType: 'StatusUpdate',
    reason: 'ValidationError',
    step: 'update'
};

});

parcelRegister("9aPz5", function(module, exports) {
$parcel$export(module.exports, "default", () => $311dd5a1d866978e$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $bSJIT = parcelRequire("bSJIT");

var $9fU1q = parcelRequire("9fU1q");
var $3zY6O = parcelRequire("3zY6O");

var $5cKiX = parcelRequire("5cKiX");

var $ag7mU = parcelRequire("ag7mU");

var $ljPIj = parcelRequire("ljPIj");

var $hkLEY = parcelRequire("hkLEY");

var $gdUUy = parcelRequire("gdUUy");

var $gXqq0 = parcelRequire("gXqq0");

var $2fwRK = parcelRequire("2fwRK");

var $7wYyA = parcelRequire("7wYyA");

var $2AqEC = parcelRequire("2AqEC");

var $ctUly = parcelRequire("ctUly");
const $311dd5a1d866978e$var$MAX_LINE_NUMBER = 8;
const $311dd5a1d866978e$var$styles = {
    contentStyles: "_zulpu2gc _11c81d4k _1reo15vq _18m915vq _1e0c1txw _1ul9idpf _2lx2vrvc _19pkv77o _4cvr1y6m _pqmefhey _102efhey _ngc0i7uo _1t4pi7uo",
    linkStyles: "_zulpu2gc _1reo15vq _18m915vq _11c8fhey _1e0c1txw _1ul9idpf _2lx2vrvc _4cvr1h6o _80omtlke _19pku2gc _18u0xy5q _otyrv77o",
    textStylesBase: "_11c81d4k _1reo15vq _18m915vq _o5724jg8 _1e0ccj1k _1bto1l2s _1nmz1hna _sudp1e54",
    dropdownItemGroupStyles: "_14hp1wdt _6pup1kw7 _1eo073ad",
    openIssueInJiraStyles: "_11c8fhey _v564k6bl _bfhk1j28 _1bah1e5h _1e0c1kw7 _syaz13af _ca0qze3t _u5f3ze3t _n3tdze3t _19bvze3t _9oik1r31 _1bnx8stv _jf4cnqa1 _30l312zz"
};
const $311dd5a1d866978e$var$LozengeActionError = ({ errorMessage: errorMessage, testId: testId, maxLineNumber: maxLineNumber = $311dd5a1d866978e$var$MAX_LINE_NUMBER, invokePreviewAction: invokePreviewAction })=>{
    const { fireEvent: fireEvent } = (0, $2fwRK.useAnalyticsEvents)();
    const invoke = (0, $2AqEC.default)({});
    const isPreviewAvailable = invokePreviewAction !== undefined;
    const handlePreviewOpen = (0, $bSJIT.useCallback)(()=>{
        if (isPreviewAvailable) {
            fireEvent('ui.button.clicked.smartLinkStatusOpenPreview', {});
            if (invokePreviewAction) invoke(invokePreviewAction);
        }
    }, [
        isPreviewAvailable,
        invoke,
        invokePreviewAction,
        fireEvent
    ]);
    const dynamicCss = null;
    const content = (0, $bSJIT.useMemo)(()=>{
        return /*#__PURE__*/ $bSJIT.createElement((0, $bSJIT.Fragment), null, /*#__PURE__*/ $bSJIT.createElement("div", {
            className: (0, $9fU1q.default)([
                $311dd5a1d866978e$var$styles.contentStyles
            ])
        }, /*#__PURE__*/ $bSJIT.createElement((0, (/*@__PURE__*/$parcel$interopDefault($hkLEY))), {
            testId: `${testId}-icon`,
            color: "var(--ds-icon-danger, #C9372C)",
            label: 'error',
            spacing: "spacious"
        }), /*#__PURE__*/ $bSJIT.createElement("span", {
            "data-testid": `${testId}-error-message`,
            className: (0, $9fU1q.default)([
                $311dd5a1d866978e$var$styles.textStylesBase,
                "_1yyj1n6p _102k16q4"
            ]),
            style: {
                "--_t4prqe": (0, $3zY6O.default)(maxLineNumber)
            }
        }, typeof errorMessage === 'string' ? errorMessage : (0, $ctUly.getFormattedMessage)(errorMessage))), isPreviewAvailable ? /*#__PURE__*/ $bSJIT.createElement("div", {
            className: (0, $9fU1q.default)([
                $311dd5a1d866978e$var$styles.linkStyles
            ])
        }, /*#__PURE__*/ $bSJIT.createElement((0, $gXqq0.Pressable), {
            testId: `${testId}-open-embed`,
            onClick: handlePreviewOpen,
            xcss: $311dd5a1d866978e$var$styles.openIssueInJiraStyles
        }, (0, $gdUUy.fg)('confluence-issue-terminology-refresh') ? /*#__PURE__*/ $bSJIT.createElement((0, $5cKiX.default), (0, $7wYyA.messages).open_issue_in_jiraIssueTermRefresh) : /*#__PURE__*/ $bSJIT.createElement((0, $5cKiX.default), (0, $7wYyA.messages).open_issue_in_jira))) : null);
    }, [
        errorMessage,
        handlePreviewOpen,
        isPreviewAvailable,
        testId,
        dynamicCss
    ]);
    return /*#__PURE__*/ $bSJIT.createElement("span", {
        "data-testid": `${testId}-error-item-group`,
        className: (0, $9fU1q.default)([
            $311dd5a1d866978e$var$styles.dropdownItemGroupStyles
        ])
    }, /*#__PURE__*/ $bSJIT.createElement((0, $ljPIj.default), null, /*#__PURE__*/ $bSJIT.createElement((0, $ag7mU.default), {
        testId: `${testId}-error`
    }, content)));
};
var $311dd5a1d866978e$export$2e2bcd8739ae039 = $311dd5a1d866978e$var$LozengeActionError;

});

parcelRegister("fQBmO", function(module, exports) {
$parcel$export(module.exports, "LozengeActionErrorMessages", () => $8c9f4e60f2bfcd64$export$4f2e371a667ad688);

var $7wYyA = parcelRequire("7wYyA");
const $8c9f4e60f2bfcd64$export$4f2e371a667ad688 = {
    noData: {
        descriptor: (0, $7wYyA.messages)['status_change_permission_error']
    },
    noDataIssueTermRefresh: {
        descriptor: (0, $7wYyA.messages)['status_change_permission_errorIssueTermRefresh']
    },
    unknown: {
        descriptor: (0, $7wYyA.messages)['status_change_load_error']
    },
    updateFailed: {
        descriptor: (0, $7wYyA.messages)['status_change_update_error']
    }
};

});

parcelRegister("bNyt2", function(module, exports) {
$parcel$export(module.exports, "default", () => $4bcb49c8164080d8$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $bSJIT = parcelRequire("bSJIT");

var $9fU1q = parcelRequire("9fU1q");

var $ljPIj = parcelRequire("ljPIj");

var $2Uxsl = parcelRequire("2Uxsl");
const $4bcb49c8164080d8$var$dropdownItemGroupStyles = null;
const $4bcb49c8164080d8$var$LozengeActionItemsGroup = ({ items: items, testId: testId, onClick: onClick })=>/*#__PURE__*/ $bSJIT.createElement("span", {
        "data-testid": `${testId}-item-group`,
        className: (0, $9fU1q.default)([
            "_c71l1mjv _18m91wug _1pv01r31 _1m1b1r31 _qh55glyw _lt2aglyw _ph3k1o36 _1twe1o36 _1ll71dpa _qprf1dpa _n6y8usvi _109gusvi _z29h1x9r _wlxp1x9r _1gfl12x7 _yhjmutpp _1gqn12x7 _11lvutpp _d4lf1f4h _14hp1wdt _6pup1kw7"
        ])
    }, /*#__PURE__*/ $bSJIT.createElement((0, $ljPIj.default), null, items.map((item, idx)=>/*#__PURE__*/ $bSJIT.createElement((0, $2Uxsl.default), {
            ...item,
            key: idx,
            onClick: onClick,
            testId: `${testId}-item-${idx}`
        }))));
var $4bcb49c8164080d8$export$2e2bcd8739ae039 = $4bcb49c8164080d8$var$LozengeActionItemsGroup;

});
parcelRegister("2Uxsl", function(module, exports) {
$parcel$export(module.exports, "default", () => $0b1fe715402c7f2d$export$2e2bcd8739ae039);

var $bSJIT = parcelRequire("bSJIT");

var $ag7mU = parcelRequire("ag7mU");

var $1emO3 = parcelRequire("1emO3");
const $0b1fe715402c7f2d$var$LozengeActionItem = ({ appearance: appearance, id: id, onClick: onClick, testId: testId, text: text })=>{
    const handleClick = (0, $bSJIT.useCallback)((e)=>{
        // Prevent dropdown to close on select item.
        // We want to show loading screen.
        e.stopPropagation();
        if (onClick) onClick(id, text, appearance);
    }, [
        appearance,
        id,
        onClick,
        text
    ]);
    const handleMouseEnter = (0, $bSJIT.useCallback)((e)=>{
        var _e$currentTarget;
        (_e$currentTarget = e.currentTarget) === null || _e$currentTarget === void 0 || (_e$currentTarget = _e$currentTarget.firstElementChild) === null || _e$currentTarget === void 0 || _e$currentTarget.focus();
    }, []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement("span", {
        onFocus: handleMouseEnter,
        onMouseEnter: handleMouseEnter,
        role: "presentation"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $ag7mU.default), {
        onClick: handleClick,
        testId: testId
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $1emO3.default), {
        appearance: appearance,
        isBold: true
    }, text)));
};
var $0b1fe715402c7f2d$export$2e2bcd8739ae039 = $0b1fe715402c7f2d$var$LozengeActionItem;

});


parcelRegister("7hdiE", function(module, exports) {
$parcel$export(module.exports, "default", () => $49ca484f04e3f969$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v3.0.2 */ /* index.tsx generated by @compiled/babel-plugin v3.0.2 */ /* eslint-disable @atlaskit/design-system/use-tokens-typography */ 
var $bSJIT = parcelRequire("bSJIT");

var $9fU1q = parcelRequire("9fU1q");

var $14TCm = parcelRequire("14TCm");

var $4vLTk = parcelRequire("4vLTk");

var $4GWyU = parcelRequire("4GWyU");

var $bLUmP = parcelRequire("bLUmP");

var $1emO3 = parcelRequire("1emO3");

var $gdUUy = parcelRequire("gdUUy");

var $9PwDt = parcelRequire("9PwDt");

var $7wYyA = parcelRequire("7wYyA");
const $49ca484f04e3f969$var$styles = {
    chevronDown: "_18u012x7 _1e0c1txw",
    lozengeContainer: "_kkk2n7od _2rko12b0 _1dqonqa1 _189ee4h9 _1h6d1j28 _bfhk1j28 _1e0c1txw _4cvr1h6o _4t3i7vkz",
    lozengeContainerSelected: "_1reo15vq _18m915vq _1h6d1v1w",
    lozengeDropdownContainer: "_ca0q1b66 _u5f31b66 _n3td1b66 _19bv1b66"
};
const $49ca484f04e3f969$var$textStyles = null;
const $49ca484f04e3f969$var$triggerLozengeStyles = null;
const $49ca484f04e3f969$var$triggerButtonStyles = null;
const $49ca484f04e3f969$var$LozengeActionTrigger = ({ appearance: appearance, isOpen: isOpen, maxWidth: maxWidth, testId: testId, text: text, triggerRef: triggerRef, trailingMetric: trailingMetric, ...props })=>{
    const intl = (0, $4vLTk.default)();
    const [isPressing, setIsPressing] = (0, $bSJIT.useState)(false);
    const [lozengeBackgroundColor, setLozengeBackgroundColor] = (0, $bSJIT.useState)(undefined);
    const [lozengeForegroundColor, setLozengeForegroundColor] = (0, $bSJIT.useState)(undefined);
    const onMouseOrKeyDown = (0, $bSJIT.useCallback)(()=>setIsPressing(true), []);
    const onMouseOrKeyUp = (0, $bSJIT.useCallback)(()=>setIsPressing(false), []);
    (0, $bSJIT.useEffect)(()=>{
        if (isPressing) {
            setLozengeBackgroundColor("var(--ds-background-selected-pressed, #8FB8F6)");
            setLozengeForegroundColor("var(--ds-text-selected, #1868DB)");
        } else if (isOpen) {
            setLozengeBackgroundColor("var(--ds-background-selected, #E9F2FE)");
            setLozengeForegroundColor("var(--ds-text-selected, #1868DB)");
        } else {
            setLozengeBackgroundColor(undefined);
            setLozengeForegroundColor(undefined);
        }
    }, [
        isPressing,
        isOpen
    ]);
    const lozenge = (0, $bSJIT.useMemo)(()=>{
        return /*#__PURE__*/ $bSJIT.createElement((0, $9PwDt.Box), {
            xcss: (0, $14TCm.cx)($49ca484f04e3f969$var$styles.lozengeContainer, (isOpen || isPressing) && $49ca484f04e3f969$var$styles.lozengeContainerSelected),
            as: "span"
        }, /*#__PURE__*/ $bSJIT.createElement((0, $1emO3.default), {
            appearance: appearance,
            isBold: true,
            maxWidth: maxWidth,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
            style: {
                backgroundColor: lozengeBackgroundColor,
                color: lozengeForegroundColor
            }
        }, /*#__PURE__*/ $bSJIT.createElement("span", {
            className: (0, $9fU1q.default)([
                "_4cvr1h6o _1e0c1txw"
            ])
        }, /*#__PURE__*/ $bSJIT.createElement("span", {
            className: (0, $9fU1q.default)([
                "_1reo15vq _18m915vq _1bto1l2s _o5721q9c"
            ])
        }, text), /*#__PURE__*/ $bSJIT.createElement((0, $9PwDt.Box), {
            as: "span",
            xcss: $49ca484f04e3f969$var$styles.chevronDown
        }, /*#__PURE__*/ $bSJIT.createElement((0, (/*@__PURE__*/$parcel$interopDefault($4GWyU))), {
            color: "currentColor",
            label: "options",
            size: "small",
            "aria-hidden": true
        })))));
    }, [
        appearance,
        isPressing,
        text,
        isOpen,
        lozengeBackgroundColor,
        lozengeForegroundColor,
        maxWidth
    ]);
    return (0, $gdUUy.fg)('platform-dst-lozenge-tag-badge-visual-uplifts') ? /*#__PURE__*/ $bSJIT.createElement((0, $9PwDt.Box), {
        xcss: $49ca484f04e3f969$var$styles.lozengeDropdownContainer
    }, /*#__PURE__*/ $bSJIT.createElement((0, $bLUmP.default), {
        ...props,
        appearance: appearance,
        trailingMetric: trailingMetric,
        "data-action-open": isOpen,
        "data-testid": `${testId}--trigger`,
        maxWidth: maxWidth,
        testId: testId,
        ref: triggerRef,
        "aria-label": // The `as unknown` type cast is needed for react-intl v7 upgrade
        intl.formatMessage((0, $7wYyA.messages).change_status, {
            status: text
        })
    }, text)) : /*#__PURE__*/ $bSJIT.createElement("button", {
        type: "button",
        ...props,
        "data-action-open": isOpen,
        "data-testid": `${testId}--trigger`,
        style: {
            maxWidth: maxWidth
        },
        onMouseDown: onMouseOrKeyDown,
        onMouseUp: onMouseOrKeyUp,
        onKeyDown: onMouseOrKeyDown,
        onKeyUp: onMouseOrKeyUp,
        ref: triggerRef,
        "aria-label": // The `as unknown` type cast is needed for react-intl v7 upgrade
        intl.formatMessage((0, $7wYyA.messages).change_status, {
            status: text
        }),
        className: (0, $9fU1q.default)([
            "_kkk2n7od _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _15vhn7od _1dqonqa1 _189e1dm9 _1h6d1j28 _bfhk1j28 _syazn7od _80omtlke _ect4n7od _1wybn7od _zg8ln7od _k48pn7od _vwz4idpf _1p1dn7od _19pkv77o _2hwxv77o _otyrv77o _18u0v77o _mizu1r31 _1guj1r31 _p8tl1r31 _ra3xglyw _pbhaglyw _1q2vglyw _128m1o36 _11ow1o36 _j8b81o36 _1bas1qi0 _19h61qi0 _1d391qi0 _1ejj1y54 _1u6l1y54 _6ssh1y54"
        ])
    }, lozenge);
};
var $49ca484f04e3f969$export$2e2bcd8739ae039 = $49ca484f04e3f969$var$LozengeActionTrigger;

});
parcelRegister("bLUmP", function(module, exports) {
$parcel$export(module.exports, "default", () => $cc4343bab43d5a25$export$2e2bcd8739ae039);
/* lozenge-dropdown-trigger.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $dc70d = parcelRequire("dc70d");

var $bSJIT = parcelRequire("bSJIT");

var $1OdZP = parcelRequire("1OdZP");

var $mvrOP = parcelRequire("mvrOP");
/**
 * __Lozenge Dropdown Trigger__
 *
 * An interactive lozenge component that acts as a dropdown trigger.
 * Built on LozengeBase with dropdown interaction patterns.
 *
 * - Supports all color variants from the lozenge
 * - Shows selected state with dedicated color tokens
 * - Includes a chevron icon on the right of the text
 * - Built for dropdown menu interactions
 * - Supports analytics events and UFO press interactions
 */ const $cc4343bab43d5a25$var$LozengeDropdownTrigger = /*#__PURE__*/ (0, $bSJIT.memo)(/*#__PURE__*/ (0, $bSJIT.forwardRef)(({ children: children, testId: testId, appearance: appearance = 'neutral', spacing: spacing = 'default', iconBefore: iconBefore, trailingMetric: trailingMetric, trailingMetricAppearance: trailingMetricAppearance, isSelected: isSelected = false, isLoading: isLoading = false, maxWidth: maxWidth = 200, onClick: onClick = (0, $1OdZP.default), style: style, analyticsContext: analyticsContext, interactionName: interactionName, 'aria-controls': ariaControls, 'aria-expanded': ariaExpanded, 'aria-haspopup': ariaHaspopup, 'aria-label': ariaLabel }, ref)=>{
    const baseProps = {
        appearance: appearance,
        spacing: spacing,
        iconBefore: iconBefore,
        trailingMetric: trailingMetric,
        trailingMetricAppearance: trailingMetricAppearance,
        isSelected: isSelected,
        isLoading: isLoading,
        maxWidth: maxWidth,
        style: style,
        testId: testId,
        onClick: onClick,
        analyticsContext: analyticsContext,
        interactionName: interactionName,
        children: children,
        'aria-controls': ariaControls,
        'aria-expanded': ariaExpanded,
        'aria-haspopup': ariaHaspopup,
        'aria-label': ariaLabel
    };
    return /*#__PURE__*/ (0, $dc70d.jsx)((0, $mvrOP.default), {
        ref: ref,
        ...baseProps,
        children: children
    });
}));
$cc4343bab43d5a25$var$LozengeDropdownTrigger.displayName = 'LozengeDropdownTrigger';
var $cc4343bab43d5a25$export$2e2bcd8739ae039 = $cc4343bab43d5a25$var$LozengeDropdownTrigger;

});




parcelRegister("5H8Tq", function(module, exports) {
$parcel$export(module.exports, "toDateLozengeProps", () => $435ff042cef1ab72$export$8f9f58f7bac50fbe);
/* toDateLozengeProps.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $bSJIT = parcelRequire("bSJIT");

var $f0Pt4 = parcelRequire("f0Pt4");
const $435ff042cef1ab72$export$8f9f58f7bac50fbe = (dateString)=>{
    if (dateString) {
        const text = Date.parse(dateString) ? /*#__PURE__*/ $bSJIT.createElement((0, $f0Pt4.FormattedDate), {
            value: new Date(dateString),
            year: "numeric",
            month: "short",
            day: "numeric",
            formatMatcher: "best fit"
        }) : dateString;
        return {
            text: text
        };
    }
};

});


parcelRegister("co4V5", function(module, exports) {
$parcel$export(module.exports, "default", () => $8beadcf08634f020$export$2e2bcd8739ae039);

var $bSJIT = parcelRequire("bSJIT");

var $5kJPq = parcelRequire("5kJPq");

var $eAoOt = parcelRequire("eAoOt");

var $7pUjV = parcelRequire("7pUjV");
const $8beadcf08634f020$var$HostNameElement = (props)=>{
    var _context$data;
    const context = (0, $eAoOt.useFlexibleCardContext)();
    const hostName = context === null || context === void 0 || (_context$data = context.data) === null || _context$data === void 0 ? void 0 : _context$data.hostName;
    return hostName ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $7pUjV.default), {
        content: hostName,
        ...props,
        name: (0, $5kJPq.ElementName).HostName
    }) : null;
};
var $8beadcf08634f020$export$2e2bcd8739ae039 = $8beadcf08634f020$var$HostNameElement;

});

parcelRegister("1YXxS", function(module, exports) {
$parcel$export(module.exports, "default", () => $1e51b6d20efde2ec$export$2e2bcd8739ae039);

var $bSJIT = parcelRequire("bSJIT");

var $5kJPq = parcelRequire("5kJPq");

var $7Z1Fb = parcelRequire("7Z1Fb");

var $1s24H = parcelRequire("1s24H");
var $ajXQ9 = parcelRequire("ajXQ9");
const $1e51b6d20efde2ec$var$LatestCommitElement = (props)=>{
    var _context$latestCommit;
    const context = (0, $7Z1Fb.useFlexibleUiContext)();
    const data = context ? (0, $ajXQ9.toBadgeProps)((_context$latestCommit = context.latestCommit) === null || _context$latestCommit === void 0 ? void 0 : _context$latestCommit.toString()) : null;
    return data ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $1s24H.default), {
        icon: (0, $5kJPq.IconType).Commit,
        ...data,
        ...props,
        name: (0, $5kJPq.ElementName).LatestCommit
    }) : null;
};
var $1e51b6d20efde2ec$export$2e2bcd8739ae039 = $1e51b6d20efde2ec$var$LatestCommitElement;

});

parcelRegister("98x8l", function(module, exports) {
$parcel$export(module.exports, "default", () => $0ac9235b34e24c43$export$2e2bcd8739ae039);

var $bSJIT = parcelRequire("bSJIT");

var $5kJPq = parcelRequire("5kJPq");

var $7Z1Fb = parcelRequire("7Z1Fb");

var $lwqfz = parcelRequire("lwqfz");
const $0ac9235b34e24c43$var$LocationElement = (props)=>{
    const context = (0, $7Z1Fb.useFlexibleUiContext)();
    const data = (context === null || context === void 0 ? void 0 : context.location) ?? null;
    return data ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $lwqfz.default), {
        theme: (0, $5kJPq.SmartLinkInternalTheme).Grey,
        ...data,
        ...props,
        name: (0, $5kJPq.ElementName).Location
    }) : null;
};
var $0ac9235b34e24c43$export$2e2bcd8739ae039 = $0ac9235b34e24c43$var$LocationElement;

});

parcelRegister("whVOD", function(module, exports) {
$parcel$export(module.exports, "default", () => $a0a39103640f85e0$export$2e2bcd8739ae039);

var $bSJIT = parcelRequire("bSJIT");

var $5kJPq = parcelRequire("5kJPq");

var $7wYyA = parcelRequire("7wYyA");

var $7Z1Fb = parcelRequire("7Z1Fb");

var $7pUjV = parcelRequire("7pUjV");
var $J1wso = parcelRequire("J1wso");
const $a0a39103640f85e0$var$ModifiedByElement = (props)=>{
    const context = (0, $7Z1Fb.useFlexibleUiContext)();
    const data = context ? (0, $J1wso.toFormattedTextProps)((0, $7wYyA.messages).modified_by, context.modifiedBy) : null;
    return data ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $7pUjV.default), {
        ...data,
        ...props,
        name: (0, $5kJPq.ElementName).ModifiedBy
    }) : null;
};
var $a0a39103640f85e0$export$2e2bcd8739ae039 = $a0a39103640f85e0$var$ModifiedByElement;

});

parcelRegister("6bVEJ", function(module, exports) {
$parcel$export(module.exports, "default", () => $dd82cf97419f5565$export$2e2bcd8739ae039);

var $bSJIT = parcelRequire("bSJIT");

var $5kJPq = parcelRequire("5kJPq");

var $7Z1Fb = parcelRequire("7Z1Fb");

var $kQMNw = parcelRequire("kQMNw");
var $lxUke = parcelRequire("lxUke");
const $dd82cf97419f5565$var$ModifiedOnElement = (props)=>{
    const context = (0, $7Z1Fb.useFlexibleUiContext)();
    const data = context ? (0, $lxUke.toDateTimeProps)('modified', context.modifiedOn) : null;
    const { onRender: onRender, ...restProps } = props || {};
    (0, $bSJIT.useEffect)(()=>{
        onRender === null || onRender === void 0 || onRender(!!data);
    }, [
        data,
        onRender
    ]);
    return data ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $kQMNw.default), {
        ...data,
        ...restProps,
        name: (0, $5kJPq.ElementName).ModifiedOn
    }) : null;
};
var $dd82cf97419f5565$export$2e2bcd8739ae039 = $dd82cf97419f5565$var$ModifiedOnElement;

});

parcelRegister("79YtU", function(module, exports) {
$parcel$export(module.exports, "default", () => $821ae1d09d84ba66$export$2e2bcd8739ae039);

var $bSJIT = parcelRequire("bSJIT");

var $5kJPq = parcelRequire("5kJPq");

var $7wYyA = parcelRequire("7wYyA");

var $7Z1Fb = parcelRequire("7Z1Fb");

var $7pUjV = parcelRequire("7pUjV");
var $J1wso = parcelRequire("J1wso");
const $821ae1d09d84ba66$var$OwnedByElement = (props)=>{
    const context = (0, $7Z1Fb.useFlexibleUiContext)();
    const { onRender: onRender, textPrefix: textPrefix = 'owned_by', ...restProps } = props || {};
    const data = context ? (0, $J1wso.toFormattedTextProps)((0, $7wYyA.messages)[textPrefix], context === null || context === void 0 ? void 0 : context.ownedBy) : null;
    (0, $bSJIT.useEffect)(()=>{
        onRender === null || onRender === void 0 || onRender(!!data);
    }, [
        data,
        onRender
    ]);
    return data ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $7pUjV.default), {
        ...data,
        ...restProps,
        name: (0, $5kJPq.ElementName).OwnedBy
    }) : null;
};
var $821ae1d09d84ba66$export$2e2bcd8739ae039 = $821ae1d09d84ba66$var$OwnedByElement;

});

parcelRegister("40odn", function(module, exports) {
$parcel$export(module.exports, "default", () => $e902b85296a8358a$export$2e2bcd8739ae039);

var $bSJIT = parcelRequire("bSJIT");

var $5kJPq = parcelRequire("5kJPq");

var $7Z1Fb = parcelRequire("7Z1Fb");

var $1hLZg = parcelRequire("1hLZg");
var $5IWYF = parcelRequire("5IWYF");
const $e902b85296a8358a$var$OwnedByGroupElement = (props)=>{
    const context = (0, $7Z1Fb.useFlexibleUiContext)();
    const data = context ? (0, $5IWYF.toAvatarGroupProps)(context.ownedByGroup, false) : null;
    const { onRender: onRender, ...restProps } = props || {};
    (0, $bSJIT.useEffect)(()=>{
        onRender === null || onRender === void 0 || onRender(!!data);
    }, [
        data,
        onRender
    ]);
    return data ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $1hLZg.default), {
        ...data,
        ...restProps,
        name: (0, $5kJPq.ElementName).OwnedByGroup
    }) : null;
};
var $e902b85296a8358a$export$2e2bcd8739ae039 = $e902b85296a8358a$var$OwnedByGroupElement;

});

parcelRegister("f3OWg", function(module, exports) {
$parcel$export(module.exports, "default", () => $d8eabdc95228f448$export$2e2bcd8739ae039);

var $bSJIT = parcelRequire("bSJIT");

var $5kJPq = parcelRequire("5kJPq");

var $7Z1Fb = parcelRequire("7Z1Fb");

var $jWfN0 = parcelRequire("jWfN0");
const $d8eabdc95228f448$var$PreviewElement = (props)=>{
    const { overrideUrl: overrideUrl, ...rest } = props ?? {};
    const context = (0, $7Z1Fb.useFlexibleUiContext)();
    const data = overrideUrl ? {
        url: overrideUrl,
        type: (0, $5kJPq.MediaType).Image
    } : context === null || context === void 0 ? void 0 : context.preview;
    if (!data) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $jWfN0.default), {
        ...rest,
        ...data
    });
};
var $d8eabdc95228f448$export$2e2bcd8739ae039 = $d8eabdc95228f448$var$PreviewElement;

});
parcelRegister("jWfN0", function(module, exports) {
$parcel$export(module.exports, "default", () => $561024d264579597$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $bSJIT = parcelRequire("bSJIT");

var $9fU1q = parcelRequire("9fU1q");

var $3P7qX = parcelRequire("3P7qX");

var $1kLa3 = parcelRequire("1kLa3");
/**
 * Media: Image
 * [aspect-ratio: 16 / 9] The context box is fixed to aspect ratio of 16:9.
 * [object-fit: cover] The replaced content is sized to maintain
 * its aspect ratio while filling the element's entire content box.
 * If the object's aspect ratio does not match the aspect ratio of its box,
 * then the object will be clipped to fit.
 * [object-position] Center alignment of the selected replaced element's
 * contents within the element's box.
 */ const $561024d264579597$var$styles = null;
/**
 * A base element that displays a Media.
 * @internal
 * @param props - The props necessary for the Media element.
 */ const $561024d264579597$var$MediaElement = ({ name: name, className: className, testId: testId = 'smart-element-media', type: type, url: url, onLoad: onLoad, onError: onError })=>{
    const ui = (0, $3P7qX.useFlexibleUiOptionContext)();
    if (!type || !url) return null;
    return /*#__PURE__*/ $bSJIT.createElement("div", {
        "data-smart-element": name,
        "data-smart-element-media": type,
        "data-testid": testId,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
        className: (0, $9fU1q.default)([
            "_1h1tcq2i _1e0c1txw _1bsb1osq _4t3i1ns9 _jqez1osq _1lg71osq _6slq1osq _x1m21osq _1chb1osq _1usb1osq _5c331osq _l9z01osq _6o691dfr _vr2g1dfr _173baqso _1niwaqso _t0h9stnw _1ulbstnw _byj21ooe _3hvr1ooe _1c0s1ssb _15j31ssb _1npy1ssb _19he1ssb _n3vc1wug _1qj91wug _4fdy1wug _18cv1wug _1aoq15vq _1iqz15vq _6fioj63w _l0jmidpf _12zuh2mm",
            className
        ])
    }, /*#__PURE__*/ $bSJIT.createElement((0, $1kLa3.default), {
        hideLoadingSkeleton: ui === null || ui === void 0 ? void 0 : ui.hideLoadingSkeleton,
        testId: `${testId}-image`,
        url: url,
        onError: onError,
        onLoad: onLoad,
        defaultIcon: null
    }));
};
var $561024d264579597$export$2e2bcd8739ae039 = $561024d264579597$var$MediaElement;

});


parcelRegister("2XIml", function(module, exports) {
$parcel$export(module.exports, "default", () => $1122c125b71e2638$export$2e2bcd8739ae039);

var $bSJIT = parcelRequire("bSJIT");

var $5kJPq = parcelRequire("5kJPq");

var $7Z1Fb = parcelRequire("7Z1Fb");

var $1s24H = parcelRequire("1s24H");
const $1122c125b71e2638$var$PriorityElement = (props)=>{
    const context = (0, $7Z1Fb.useFlexibleUiContext)();
    const data = (context === null || context === void 0 ? void 0 : context.priority) ?? null;
    return data ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $1s24H.default), {
        ...data,
        ...props,
        name: (0, $5kJPq.ElementName).Priority
    }) : null;
};
var $1122c125b71e2638$export$2e2bcd8739ae039 = $1122c125b71e2638$var$PriorityElement;

});

parcelRegister("69cJJ", function(module, exports) {
$parcel$export(module.exports, "default", () => $43dffe8f24a2f885$export$2e2bcd8739ae039);

var $bSJIT = parcelRequire("bSJIT");

var $5kJPq = parcelRequire("5kJPq");

var $7Z1Fb = parcelRequire("7Z1Fb");

var $1s24H = parcelRequire("1s24H");
var $ajXQ9 = parcelRequire("ajXQ9");
const $43dffe8f24a2f885$var$ProgrammingLanguageElement = (props)=>{
    const context = (0, $7Z1Fb.useFlexibleUiContext)();
    const data = context ? (0, $ajXQ9.toBadgeProps)(context.programmingLanguage) : null;
    return data ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $1s24H.default), {
        icon: (0, $5kJPq.IconType).ProgrammingLanguage,
        ...data,
        ...props,
        name: (0, $5kJPq.ElementName).ProgrammingLanguage
    }) : null;
};
var $43dffe8f24a2f885$export$2e2bcd8739ae039 = $43dffe8f24a2f885$var$ProgrammingLanguageElement;

});

parcelRegister("beIZm", function(module, exports) {
$parcel$export(module.exports, "default", () => $f6421932b6c95165$export$2e2bcd8739ae039);

var $bSJIT = parcelRequire("bSJIT");

var $5kJPq = parcelRequire("5kJPq");

var $7Z1Fb = parcelRequire("7Z1Fb");

var $1s24H = parcelRequire("1s24H");
const $f6421932b6c95165$var$ProviderElement = (props)=>{
    const context = (0, $7Z1Fb.useFlexibleUiContext)();
    const data = (context === null || context === void 0 ? void 0 : context.provider) ?? null;
    return data ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $1s24H.default), {
        ...data,
        ...props,
        name: (0, $5kJPq.ElementName).Provider
    }) : null;
};
var $f6421932b6c95165$export$2e2bcd8739ae039 = $f6421932b6c95165$var$ProviderElement;

});

parcelRegister("gIpkO", function(module, exports) {
$parcel$export(module.exports, "default", () => $d82aa7e41be39677$export$2e2bcd8739ae039);

var $bSJIT = parcelRequire("bSJIT");

var $5kJPq = parcelRequire("5kJPq");

var $7Z1Fb = parcelRequire("7Z1Fb");

var $1s24H = parcelRequire("1s24H");
var $ajXQ9 = parcelRequire("ajXQ9");
const $d82aa7e41be39677$var$ReactCountElement = (props)=>{
    var _context$reactCount;
    const context = (0, $7Z1Fb.useFlexibleUiContext)();
    const data = context ? (0, $ajXQ9.toBadgeProps)((_context$reactCount = context.reactCount) === null || _context$reactCount === void 0 ? void 0 : _context$reactCount.toString()) : null;
    const { onRender: onRender, ...restProps } = props || {};
    (0, $bSJIT.useEffect)(()=>{
        onRender === null || onRender === void 0 || onRender(!!data);
    }, [
        data,
        onRender
    ]);
    return data ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $1s24H.default), {
        icon: (0, $5kJPq.IconType).React,
        ...data,
        ...restProps,
        name: (0, $5kJPq.ElementName).ReactCount
    }) : null;
};
var $d82aa7e41be39677$export$2e2bcd8739ae039 = $d82aa7e41be39677$var$ReactCountElement;

});

parcelRegister("1gqay", function(module, exports) {
$parcel$export(module.exports, "default", () => $7ad9a8f4fa88ca1e$export$2e2bcd8739ae039);

var $bSJIT = parcelRequire("bSJIT");

var $5kJPq = parcelRequire("5kJPq");

var $7wYyA = parcelRequire("7wYyA");

var $7Z1Fb = parcelRequire("7Z1Fb");

var $7pUjV = parcelRequire("7pUjV");
var $J1wso = parcelRequire("J1wso");
const $7ad9a8f4fa88ca1e$var$ReadTimeElement = (props)=>{
    const context = (0, $7Z1Fb.useFlexibleUiContext)();
    const data = context ? (0, $J1wso.toFormattedTextProps)((0, $7wYyA.messages).read_time, context.readTime) : null;
    return data ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $7pUjV.default), {
        ...data,
        ...props,
        name: (0, $5kJPq.ElementName).ReadTime
    }) : null;
};
var $7ad9a8f4fa88ca1e$export$2e2bcd8739ae039 = $7ad9a8f4fa88ca1e$var$ReadTimeElement;

});

parcelRegister("8EnvJ", function(module, exports) {
$parcel$export(module.exports, "default", () => $2b14f53f47ca4151$export$2e2bcd8739ae039);

var $bSJIT = parcelRequire("bSJIT");

var $5kJPq = parcelRequire("5kJPq");

var $7Z1Fb = parcelRequire("7Z1Fb");

var $kQMNw = parcelRequire("kQMNw");
var $lxUke = parcelRequire("lxUke");
const $2b14f53f47ca4151$var$SentOnElement = (props)=>{
    const context = (0, $7Z1Fb.useFlexibleUiContext)();
    const data = context ? (0, $lxUke.toDateTimeProps)('sent', context.sentOn) : null;
    return data ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $kQMNw.default), {
        ...data,
        ...props,
        name: (0, $5kJPq.ElementName).SentOn
    }) : null;
};
var $2b14f53f47ca4151$export$2e2bcd8739ae039 = $2b14f53f47ca4151$var$SentOnElement;

});

parcelRegister("3DaZe", function(module, exports) {
$parcel$export(module.exports, "default", () => $6db90b76afb107cf$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $bSJIT = parcelRequire("bSJIT");

var $9fU1q = parcelRequire("9fU1q");

var $7Z1Fb = parcelRequire("7Z1Fb");

var $7pUjV = parcelRequire("7pUjV");
const $6db90b76afb107cf$var$SNIPPET_DEFAULT_MAX_LINES = 3;
const $6db90b76afb107cf$var$snippetBaseStyle = null;
const $6db90b76afb107cf$var$SnippetElement = (props)=>{
    const { content: overrideContent, maxLines: maxLines = $6db90b76afb107cf$var$SNIPPET_DEFAULT_MAX_LINES, className: className, ...restOfProps } = props ?? {};
    const context = (0, $7Z1Fb.useFlexibleUiContext)();
    return /*#__PURE__*/ $bSJIT.createElement((0, $7pUjV.default), {
        content: overrideContent ?? (context === null || context === void 0 ? void 0 : context.snippet),
        maxLines: maxLines,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
        className: (0, $9fU1q.default)([
            "_syazi7uo _1ul9idpf _181u1kdv _1rkw1kdv _te171kdv _uizt1kdv",
            className
        ]),
        ...restOfProps
    });
};
var $6db90b76afb107cf$export$2e2bcd8739ae039 = $6db90b76afb107cf$var$SnippetElement;

});

parcelRegister("4VZZ9", function(module, exports) {
$parcel$export(module.exports, "default", () => $8da3f25539012bf7$export$2e2bcd8739ae039);

var $bSJIT = parcelRequire("bSJIT");

var $5kJPq = parcelRequire("5kJPq");

var $7Z1Fb = parcelRequire("7Z1Fb");

var $7pUjV = parcelRequire("7pUjV");
var $cxXJu = parcelRequire("cxXJu");
const $8da3f25539012bf7$var$SourceBranchElement = (props)=>{
    const context = (0, $7Z1Fb.useFlexibleUiContext)();
    const data = context ? (0, $cxXJu.toTextProps)(context.sourceBranch) : null;
    return data ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $7pUjV.default), {
        ...data,
        ...props,
        name: (0, $5kJPq.ElementName).SourceBranch
    }) : null;
};
var $8da3f25539012bf7$export$2e2bcd8739ae039 = $8da3f25539012bf7$var$SourceBranchElement;

});
parcelRegister("cxXJu", function(module, exports) {
$parcel$export(module.exports, "toTextProps", () => $6910107bb42a47d8$export$f12aecc78be3c7bb);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ const $6910107bb42a47d8$export$f12aecc78be3c7bb = (content)=>{
    return content ? {
        content: content
    } : undefined;
};

});


parcelRegister("i6SML", function(module, exports) {
$parcel$export(module.exports, "default", () => $06e5deb83ba137a1$export$2e2bcd8739ae039);

var $bSJIT = parcelRequire("bSJIT");

var $gdUUy = parcelRequire("gdUUy");

var $5kJPq = parcelRequire("5kJPq");

var $7Z1Fb = parcelRequire("7Z1Fb");

var $ftIZv = parcelRequire("ftIZv");
const $06e5deb83ba137a1$var$STATE_METRIC_REGEX = /^(.+?)\s+-\s+(\d+(?:\.\d+)?)$/;
const $06e5deb83ba137a1$var$StateElement = (props)=>{
    const context = (0, $7Z1Fb.useFlexibleUiContext)();
    const data = (context === null || context === void 0 ? void 0 : context.state) ?? null;
    const metricProps = (0, $gdUUy.fg)('platform-dst-lozenge-tag-badge-visual-uplifts') ? // eslint-disable-next-line react-hooks/rules-of-hooks
    (0, $bSJIT.useMemo)(()=>{
        if (data && typeof data.text === 'string') {
            const match = data.text.match($06e5deb83ba137a1$var$STATE_METRIC_REGEX);
            if (match) return {
                text: match[1],
                trailingMetric: match[2]
            };
        }
        return null;
    }, [
        data
    ]) : undefined;
    if (!data) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $ftIZv.default), {
        ...data,
        ...props,
        ...metricProps,
        name: (0, $5kJPq.ElementName).State
    });
};
var $06e5deb83ba137a1$export$2e2bcd8739ae039 = $06e5deb83ba137a1$var$StateElement;

});

parcelRegister("e5w9n", function(module, exports) {
$parcel$export(module.exports, "default", () => $a92f1aa6aee3996f$export$2e2bcd8739ae039);

var $bSJIT = parcelRequire("bSJIT");

var $5kJPq = parcelRequire("5kJPq");

var $7Z1Fb = parcelRequire("7Z1Fb");

var $23t35 = parcelRequire("23t35");
var $3mCyH = parcelRequire("3mCyH");
const $a92f1aa6aee3996f$var$StoryPointsElement = (props)=>{
    const context = (0, $7Z1Fb.useFlexibleUiContext)();
    const data = context ? (0, $3mCyH.toAtlaskitBadgeProps)(context.storyPoints) : null;
    return data ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $23t35.default), {
        ...data,
        ...props,
        name: (0, $5kJPq.ElementName).StoryPoints
    }) : null;
};
var $a92f1aa6aee3996f$export$2e2bcd8739ae039 = $a92f1aa6aee3996f$var$StoryPointsElement;

});
parcelRegister("23t35", function(module, exports) {
$parcel$export(module.exports, "default", () => $39ac7230e5678334$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $bSJIT = parcelRequire("bSJIT");

var $9fU1q = parcelRequire("9fU1q");

var $8xlF3 = parcelRequire("8xlF3");
const $39ac7230e5678334$var$badgeStyles = null;
/**
 * A base element that displays a visual indicator for a numeric value
 * @internal
 * @see StoryPoints
 * */ const $39ac7230e5678334$var$BaseAtlaskitElementBadge = ({ value: value, name: name, className: className, testId: testId = 'smart-element-atlaskit-badge' })=>{
    if (!value) return null;
    return /*#__PURE__*/ $bSJIT.createElement("span", {
        "data-smart-element": name,
        "data-smart-element-atlaskit-badge": true,
        "data-testid": testId,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
        className: (0, $9fU1q.default)([
            "_4cvr1h6o _1e0c116y _1ul91ns9",
            className
        ])
    }, /*#__PURE__*/ $bSJIT.createElement((0, $8xlF3.default), null, value));
};
var $39ac7230e5678334$export$2e2bcd8739ae039 = $39ac7230e5678334$var$BaseAtlaskitElementBadge;

});

parcelRegister("3mCyH", function(module, exports) {
$parcel$export(module.exports, "toAtlaskitBadgeProps", () => $21abb7a7541c7e04$export$731812b93bd90554);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ const $21abb7a7541c7e04$export$731812b93bd90554 = (value)=>{
    return value ? {
        value: value
    } : undefined;
};

});


parcelRegister("aPBCU", function(module, exports) {
$parcel$export(module.exports, "default", () => $dfee8760fde32893$export$2e2bcd8739ae039);

var $bSJIT = parcelRequire("bSJIT");

var $5kJPq = parcelRequire("5kJPq");

var $7Z1Fb = parcelRequire("7Z1Fb");

var $1s24H = parcelRequire("1s24H");
var $ajXQ9 = parcelRequire("ajXQ9");
const $dfee8760fde32893$var$SubTasksProgressElement = (props)=>{
    var _context$subTasksProg;
    const context = (0, $7Z1Fb.useFlexibleUiContext)();
    const data = context ? (0, $ajXQ9.toBadgeProps)((_context$subTasksProg = context.subTasksProgress) === null || _context$subTasksProg === void 0 ? void 0 : _context$subTasksProg.toString()) : null;
    return data ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $1s24H.default), {
        icon: (0, $5kJPq.IconType).SubTasksProgress,
        ...data,
        ...props,
        name: (0, $5kJPq.ElementName).SubTasksProgress
    }) : null;
};
var $dfee8760fde32893$export$2e2bcd8739ae039 = $dfee8760fde32893$var$SubTasksProgressElement;

});

parcelRegister("6pxsJ", function(module, exports) {
$parcel$export(module.exports, "default", () => $a777a1b92a1f2477$export$2e2bcd8739ae039);

var $bSJIT = parcelRequire("bSJIT");

var $5kJPq = parcelRequire("5kJPq");

var $7Z1Fb = parcelRequire("7Z1Fb");

var $1s24H = parcelRequire("1s24H");
var $ajXQ9 = parcelRequire("ajXQ9");
const $a777a1b92a1f2477$var$SubscriberCountElement = (props)=>{
    var _context$subscriberCo;
    const context = (0, $7Z1Fb.useFlexibleUiContext)();
    const data = context ? (0, $ajXQ9.toBadgeProps)((_context$subscriberCo = context.subscriberCount) === null || _context$subscriberCo === void 0 ? void 0 : _context$subscriberCo.toString()) : null;
    return data ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $1s24H.default), {
        icon: (0, $5kJPq.IconType).Subscriber,
        ...data,
        ...props,
        name: (0, $5kJPq.ElementName).SubscriberCount
    }) : null;
};
var $a777a1b92a1f2477$export$2e2bcd8739ae039 = $a777a1b92a1f2477$var$SubscriberCountElement;

});

parcelRegister("4wkZy", function(module, exports) {
$parcel$export(module.exports, "default", () => $e23491e5e2bfe71e$export$2e2bcd8739ae039);

var $bSJIT = parcelRequire("bSJIT");

var $5kJPq = parcelRequire("5kJPq");

var $7Z1Fb = parcelRequire("7Z1Fb");

var $7pUjV = parcelRequire("7pUjV");
var $cxXJu = parcelRequire("cxXJu");
const $e23491e5e2bfe71e$var$TargetBranchElement = (props)=>{
    const context = (0, $7Z1Fb.useFlexibleUiContext)();
    const data = context ? (0, $cxXJu.toTextProps)(context.targetBranch) : null;
    return data ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $7pUjV.default), {
        ...data,
        ...props,
        name: (0, $5kJPq.ElementName).TargetBranch
    }) : null;
};
var $e23491e5e2bfe71e$export$2e2bcd8739ae039 = $e23491e5e2bfe71e$var$TargetBranchElement;

});

parcelRegister("6M7UH", function(module, exports) {
$parcel$export(module.exports, "default", () => $1a5af5f5eb4cae67$export$2e2bcd8739ae039);

var $bSJIT = parcelRequire("bSJIT");

var $5kJPq = parcelRequire("5kJPq");

var $7wYyA = parcelRequire("7wYyA");

var $7Z1Fb = parcelRequire("7Z1Fb");

var $7pUjV = parcelRequire("7pUjV");
var $J1wso = parcelRequire("J1wso");
const $1a5af5f5eb4cae67$var$MAX_TEAM_MEMBER_LIMIT = 50;
const $1a5af5f5eb4cae67$var$TeamMemberCountElement = (props)=>{
    var _context$teamMemberCo;
    const context = (0, $7Z1Fb.useFlexibleUiContext)();
    if (!(context !== null && context !== void 0 && context.teamMemberCount)) return null;
    const count = context !== null && context !== void 0 && context.teamMemberCount && (context === null || context === void 0 ? void 0 : context.teamMemberCount) > $1a5af5f5eb4cae67$var$MAX_TEAM_MEMBER_LIMIT ? `${$1a5af5f5eb4cae67$var$MAX_TEAM_MEMBER_LIMIT}+` : context === null || context === void 0 || (_context$teamMemberCo = context.teamMemberCount) === null || _context$teamMemberCo === void 0 ? void 0 : _context$teamMemberCo.toString();
    const data = count ? (0, $J1wso.toFormattedTextProps)((0, $7wYyA.messages).team_members_count, count) : null;
    return data ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $7pUjV.default), {
        ...data,
        ...props,
        name: (0, $5kJPq.ElementName).TeamMemberCount
    }) : null;
};
var $1a5af5f5eb4cae67$export$2e2bcd8739ae039 = $1a5af5f5eb4cae67$var$TeamMemberCountElement;

});

parcelRegister("63Pef", function(module, exports) {
$parcel$export(module.exports, "default", () => $2b62afed68026335$export$2e2bcd8739ae039);

var $bSJIT = parcelRequire("bSJIT");

var $5kJPq = parcelRequire("5kJPq");

var $7wYyA = parcelRequire("7wYyA");

var $7Z1Fb = parcelRequire("7Z1Fb");

var $7pUjV = parcelRequire("7pUjV");
var $J1wso = parcelRequire("J1wso");
const $2b62afed68026335$var$UserAttributesElement = (props)=>{
    const context = (0, $7Z1Fb.useFlexibleUiContext)();
    const renderUserAttributes = (userAttributes)=>{
        if (!userAttributes) return null;
        const attributeKeys = [
            'pronouns',
            'role',
            'department',
            'location'
        ];
        const attributes = [];
        attributeKeys.forEach((key)=>{
            if (userAttributes[key]) {
                const data = (0, $J1wso.toFormattedTextProps)((0, $7wYyA.messages).user_attributes, userAttributes[key]);
                if (data) attributes.push(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $7pUjV.default), {
                    key: key,
                    ...data,
                    testId: `smart-element-text-${key}`,
                    ...props,
                    name: (0, $5kJPq.ElementName).UserAttributes
                }));
            }
        });
        return attributes.length > 0 ? attributes : null;
    };
    const elements = context ? renderUserAttributes(context.userAttributes) : null;
    return elements ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).Fragment, null, elements) : null;
};
var $2b62afed68026335$export$2e2bcd8739ae039 = $2b62afed68026335$var$UserAttributesElement;

});

parcelRegister("fJYci", function(module, exports) {
$parcel$export(module.exports, "default", () => $22b0c804d1809e31$export$2e2bcd8739ae039);

var $bSJIT = parcelRequire("bSJIT");

var $5kJPq = parcelRequire("5kJPq");

var $7Z1Fb = parcelRequire("7Z1Fb");

var $1s24H = parcelRequire("1s24H");
var $ajXQ9 = parcelRequire("ajXQ9");
const $22b0c804d1809e31$var$ViewCountElement = (props)=>{
    var _context$viewCount;
    const context = (0, $7Z1Fb.useFlexibleUiContext)();
    const data = context ? (0, $ajXQ9.toBadgeProps)((_context$viewCount = context.viewCount) === null || _context$viewCount === void 0 ? void 0 : _context$viewCount.toString()) : null;
    return data ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $1s24H.default), {
        icon: (0, $5kJPq.IconType).View,
        ...data,
        ...props,
        name: (0, $5kJPq.ElementName).ViewCount
    }) : null;
};
var $22b0c804d1809e31$export$2e2bcd8739ae039 = $22b0c804d1809e31$var$ViewCountElement;

});

parcelRegister("47V1p", function(module, exports) {
$parcel$export(module.exports, "default", () => $b3b37d3f260b27b6$export$2e2bcd8739ae039);

var $bSJIT = parcelRequire("bSJIT");

var $5kJPq = parcelRequire("5kJPq");

var $7Z1Fb = parcelRequire("7Z1Fb");

var $1s24H = parcelRequire("1s24H");
var $ajXQ9 = parcelRequire("ajXQ9");
const $b3b37d3f260b27b6$var$VoteCountElement = (props)=>{
    var _context$voteCount;
    const context = (0, $7Z1Fb.useFlexibleUiContext)();
    const data = context ? (0, $ajXQ9.toBadgeProps)((_context$voteCount = context.voteCount) === null || _context$voteCount === void 0 ? void 0 : _context$voteCount.toString()) : null;
    return data ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $1s24H.default), {
        icon: (0, $5kJPq.IconType).Vote,
        ...data,
        ...props,
        name: (0, $5kJPq.ElementName).VoteCount
    }) : null;
};
var $b3b37d3f260b27b6$export$2e2bcd8739ae039 = $b3b37d3f260b27b6$var$VoteCountElement;

});

parcelRegister("eaAgR", function(module, exports) {
$parcel$export(module.exports, "isStyleCacheProvider", () => $fe83f208cea55026$export$14ff825bfe645006);
parcelRequire("bSJIT");
const $fe83f208cea55026$export$14ff825bfe645006 = (node)=>{
    var _node$type, _node$type2;
    if (typeof node.type !== 'string' && ((_node$type = node.type) === null || _node$type === void 0 ? void 0 : _node$type.name) === 'StyleCacheProvider' && node.props.children) return true;
    else if (typeof node.type !== 'string' && ((_node$type2 = node.type) === null || _node$type2 === void 0 ? void 0 : _node$type2.name) === 'CC' && node.props.children) return true;
    return false;
};

});


parcelRegister("94O41", function(module, exports) {
$parcel$export(module.exports, "default", () => $a8827e73ae6f3e78$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v3.0.2 */ /* eslint-disable @atlaskit/design-system/use-tokens-typography */ 
var $bSJIT = parcelRequire("bSJIT");

var $9fU1q = parcelRequire("9fU1q");

var $5kJPq = parcelRequire("5kJPq");

var $b4upk = parcelRequire("b4upk");
const $a8827e73ae6f3e78$var$alignmentStyleMap = {
    right: "_1dthh9n0 _r291h9n0 _1bahesu3 _y3gnusic",
    left: "_1dthv2br _r291v2br _1bah1y6m _y3gn1e5h"
};
const $a8827e73ae6f3e78$var$baseStyleBySize = {
    xlarge: "_zulpv47k _1reo15vq _18m915vq _4cvr1h6o _1e0c1txw _1ul9idpf",
    large: "_zulppxbi _1reo15vq _18m915vq _4cvr1h6o _1e0c1txw _1ul9idpf",
    medium: "_zulpu2gc _1reo15vq _18m915vq _4cvr1h6o _1e0c1txw _1ul9idpf",
    small: "_zulp1b66 _1reo15vq _18m915vq _4cvr1h6o _1e0c1txw _1ul9idpf"
};
const $a8827e73ae6f3e78$var$baseStyleByDirection = {
    horizontal: "_2lx2vrvc _4cvr1h6o",
    vertical: "_2lx21bp4 _4cvr1y6m"
};
const $a8827e73ae6f3e78$var$baseStyles = null;
const $a8827e73ae6f3e78$var$widthStyle = {
    flexible: "_16jlkb7n _1o9z11wp _i0dlf1ug",
    'fit-to-content': ""
};
const $a8827e73ae6f3e78$var$positionStyle = {
    top: "_1wpz1y6m",
    center: ""
};
const $a8827e73ae6f3e78$var$horizontalStyleBase = null;
const $a8827e73ae6f3e78$var$horizontalStyleByHeight = {
    xlarge: "_1e0ccj1k _102k125z",
    large: "_1e0ccj1k _102k125z",
    medium: "_1e0ccj1k _102kz42d",
    small: "_1e0ccj1k _102kz42d"
};
const $a8827e73ae6f3e78$var$gapStylesLeft = {
    xlarge: "_7yhbv47k _m6ukidpf",
    large: "_7yhbpxbi _m6ukidpf",
    medium: "_7yhbu2gc _m6ukidpf",
    small: "_7yhb1b66 _m6ukidpf"
};
const $a8827e73ae6f3e78$var$gapStylesRight = {
    xlarge: "_24rcv47k _3dveidpf",
    large: "_24rcpxbi _3dveidpf",
    medium: "_24rcu2gc _3dveidpf",
    small: "_24rc1b66 _3dveidpf"
};
const $a8827e73ae6f3e78$var$minWidthStyle = null;
/**
 * Creates a group of Action components. Accepts an array of Actions, in addition to some styling
 * preferences.
 * @internal
 * @param {ActionGroupProps} ActionGroupProps
 * @see Action
 */ const $a8827e73ae6f3e78$var$ElementGroup = ({ align: align = (0, $5kJPq.SmartLinkAlignment).Left, children: children, direction: direction = (0, $5kJPq.SmartLinkDirection).Horizontal, size: size = (0, $5kJPq.SmartLinkSize).Medium, testId: testId = 'smart-element-group', width: width = (0, $5kJPq.SmartLinkWidth).FitToContent, position: position = (0, $5kJPq.SmartLinkPosition).Center, className: className })=>{
    const isHorizontal = direction === (0, $5kJPq.SmartLinkDirection).Horizontal;
    return /*#__PURE__*/ $bSJIT.createElement("div", {
        "data-smart-element-group": true,
        "data-testid": testId,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
        className: (0, $9fU1q.default)([
            $a8827e73ae6f3e78$var$baseStyleBySize[size],
            $a8827e73ae6f3e78$var$baseStyleByDirection[direction],
            "_fiawglyw",
            $a8827e73ae6f3e78$var$alignmentStyleMap[align],
            "_1ul99by0",
            $a8827e73ae6f3e78$var$widthStyle[width],
            isHorizontal && "_1reo15vq _18m915vq _1e0c1ule _s7n4nkob _1bto1l2s _1nmz1hna _1yyjkb7n _sudp1e54 _1aaynkob _15tynkob _1iu61nu9 _166k1nu9 _1div1nu9 _bmfb1nu9",
            isHorizontal && $a8827e73ae6f3e78$var$horizontalStyleByHeight[size],
            isHorizontal && align === (0, $5kJPq.SmartLinkAlignment).Left && $a8827e73ae6f3e78$var$gapStylesLeft[size],
            isHorizontal && align === (0, $5kJPq.SmartLinkAlignment).Right && $a8827e73ae6f3e78$var$gapStylesRight[size],
            $a8827e73ae6f3e78$var$positionStyle[position],
            className
        ])
    }, (0, $b4upk.renderChildren)(children, size));
};
var $a8827e73ae6f3e78$export$2e2bcd8739ae039 = $a8827e73ae6f3e78$var$ElementGroup;

});





parcelRegister("aHHqC", function(module, exports) {
$parcel$export(module.exports, "default", () => $7bb83babfdd82400$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $bSJIT = parcelRequire("bSJIT");

var $9fU1q = parcelRequire("9fU1q");

var $9PwDt = parcelRequire("9PwDt");

var $5kJPq = parcelRequire("5kJPq");

var $lgzQp = parcelRequire("lgzQp");

var $8dLhi = parcelRequire("8dLhi");

var $94O41 = parcelRequire("94O41");

var $TSDzJ = parcelRequire("TSDzJ");
const $7bb83babfdd82400$var$style = null;
const $7bb83babfdd82400$var$styles = {
    titleBox: "_1e0c1txw _2lx2vrvc _4cvr1h6o _1bsb1osq"
};
/**
 * This renders a fully resolved TitleBlock.
 * This should render when a Smart Link returns a valid response.
 * @see TitleBlock
 */ const $7bb83babfdd82400$var$TitleBlockResolvedView = ({ actionGroup: actionGroup, metadata: metadata = [], position: position, subtitle: subtitle = [], testId: testId, text: _text, icon: icon, title: title, metadataPosition: metadataPosition, hideIcon: hideIcon, CompetitorPrompt: CompetitorPrompt, url: url, hideIconLoadingSkeleton: hideIconLoadingSkeleton, ...blockProps })=>{
    const { size: size } = blockProps;
    const metadataElements = (0, $TSDzJ.renderElementItems)(metadata);
    const subtitleElements = (0, $TSDzJ.renderElementItems)(subtitle);
    return /*#__PURE__*/ $bSJIT.createElement((0, $8dLhi.default), {
        ...blockProps,
        testId: `${testId}-resolved-view`
    }, !hideIcon && /*#__PURE__*/ $bSJIT.createElement((0, $lgzQp.default), {
        overrideIcon: icon,
        position: position,
        size: size,
        hideLoadingSkeleton: hideIconLoadingSkeleton
    }), /*#__PURE__*/ $bSJIT.createElement((0, $94O41.default), {
        direction: (0, $5kJPq.SmartLinkDirection).Vertical,
        width: (0, $5kJPq.SmartLinkWidth).Flexible,
        size: blockProps.size,
        className: (0, $9fU1q.default)([
            "_zulp1b66"
        ])
    }, CompetitorPrompt && url ? /*#__PURE__*/ $bSJIT.createElement((0, $9PwDt.Box), {
        xcss: $7bb83babfdd82400$var$styles.titleBox
    }, title, /*#__PURE__*/ $bSJIT.createElement(CompetitorPrompt, {
        sourceUrl: url,
        linkType: 'card'
    })) : title, subtitleElements && /*#__PURE__*/ $bSJIT.createElement((0, $94O41.default), {
        direction: (0, $5kJPq.SmartLinkDirection).Horizontal
    }, subtitleElements)), metadataElements && /*#__PURE__*/ $bSJIT.createElement((0, $94O41.default), {
        direction: (0, $5kJPq.SmartLinkDirection).Horizontal,
        align: (0, $5kJPq.SmartLinkAlignment).Right,
        position: metadataPosition ?? (0, $5kJPq.SmartLinkPosition).Center,
        size: blockProps.size
    }, metadataElements), actionGroup);
};
var $7bb83babfdd82400$export$2e2bcd8739ae039 = $7bb83babfdd82400$var$TitleBlockResolvedView;

});
parcelRegister("TSDzJ", function(module, exports) {
$parcel$export(module.exports, "renderElementItems", () => $4452988618b7ce27$export$9678d3ca18bd7526);

var $bSJIT = parcelRequire("bSJIT");

var $2TxTu = parcelRequire("2TxTu");

var $4pP1K = parcelRequire("4pP1K");

var $8VhG4 = parcelRequire("8VhG4");

var $jaRTQ = parcelRequire("jaRTQ");

var $lR3MV = parcelRequire("lR3MV");

var $jf7a7 = parcelRequire("jf7a7");

var $iU6l7 = parcelRequire("iU6l7");

var $k8wNj = parcelRequire("k8wNj");

var $lLEGZ = parcelRequire("lLEGZ");

var $iTIMD = parcelRequire("iTIMD");

var $jZNZe = parcelRequire("jZNZe");

var $co4V5 = parcelRequire("co4V5");

var $1YXxS = parcelRequire("1YXxS");

var $lgzQp = parcelRequire("lgzQp");

var $98x8l = parcelRequire("98x8l");

var $whVOD = parcelRequire("whVOD");

var $6bVEJ = parcelRequire("6bVEJ");

var $79YtU = parcelRequire("79YtU");

var $40odn = parcelRequire("40odn");

var $f3OWg = parcelRequire("f3OWg");

var $2XIml = parcelRequire("2XIml");

var $69cJJ = parcelRequire("69cJJ");

var $beIZm = parcelRequire("beIZm");

var $gIpkO = parcelRequire("gIpkO");

var $1gqay = parcelRequire("1gqay");

var $8EnvJ = parcelRequire("8EnvJ");

var $3DaZe = parcelRequire("3DaZe");

var $4VZZ9 = parcelRequire("4VZZ9");

var $i6SML = parcelRequire("i6SML");

var $e5w9n = parcelRequire("e5w9n");

var $aPBCU = parcelRequire("aPBCU");

var $6pxsJ = parcelRequire("6pxsJ");

var $4wkZy = parcelRequire("4wkZy");

var $6M7UH = parcelRequire("6M7UH");

var $7XNox = parcelRequire("7XNox");

var $63Pef = parcelRequire("63Pef");

var $fJYci = parcelRequire("fJYci");

var $47V1p = parcelRequire("47V1p");

var $alXMc = parcelRequire("alXMc");

var $3khWZ = parcelRequire("3khWZ");
const $4452988618b7ce27$var$Elements = {
    AppliedToComponentsCount: $2TxTu.default,
    AssignedTo: $4pP1K.default,
    AssignedToGroup: $8VhG4.default,
    AttachmentCount: $jaRTQ.default,
    AuthorGroup: $lR3MV.default,
    ChecklistProgress: $jf7a7.default,
    CollaboratorGroup: $iU6l7.default,
    CommentCount: $k8wNj.default,
    CreatedBy: $lLEGZ.default,
    CreatedOn: $iTIMD.default,
    DueOn: $jZNZe.default,
    HostName: $co4V5.default,
    LatestCommit: $1YXxS.default,
    LinkIcon: $lgzQp.default,
    Location: $98x8l.default,
    ModifiedBy: $whVOD.default,
    ModifiedOn: $6bVEJ.default,
    OwnedBy: $79YtU.default,
    OwnedByGroup: $40odn.default,
    Preview: $f3OWg.default,
    Priority: $2XIml.default,
    ProgrammingLanguage: $69cJJ.default,
    Provider: $beIZm.default,
    ReactCount: $gIpkO.default,
    ReadTime: $1gqay.default,
    SentOn: $8EnvJ.default,
    Snippet: $3DaZe.default,
    SourceBranch: $4VZZ9.default,
    State: $i6SML.default,
    StoryPoints: $e5w9n.default,
    SubTasksProgress: $aPBCU.default,
    SubscriberCount: $6pxsJ.default,
    TargetBranch: $4wkZy.default,
    TeamMemberCount: $6M7UH.default,
    Title: $7XNox.default,
    UserAttributes: $63Pef.default,
    ViewCount: $fJYci.default,
    VoteCount: $47V1p.default
};
const $4452988618b7ce27$var$isElementDisplayValid = (name, display)=>{
    var _ElementDisplaySchema;
    return ((_ElementDisplaySchema = (0, $3khWZ.ElementDisplaySchema)[name]) === null || _ElementDisplaySchema === void 0 ? void 0 : _ElementDisplaySchema.includes(display)) ?? false;
};
const $4452988618b7ce27$export$9678d3ca18bd7526 = (items = [], display = 'inline')=>{
    const elements = items.reduce((acc, curr, idx)=>{
        const { name: name, ...props } = curr;
        const Element = $4452988618b7ce27$var$Elements[name];
        const typedProps = props;
        if (Element && $4452988618b7ce27$var$isElementDisplayValid(name, display)) {
            const element = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement(Element, {
                key: idx,
                ...typedProps
            });
            if (!(0, $alXMc.isJSXElementNull)(element)) return [
                ...acc,
                element
            ];
        }
        return acc;
    }, []);
    if (elements.length) return elements;
};

});
parcelRegister("alXMc", function(module, exports) {
$parcel$export(module.exports, "isJSXElementNull", () => $bc8ba15eaa5bc5cf$export$f2c7ad0961800b16);
const $bc8ba15eaa5bc5cf$export$f2c7ad0961800b16 = (children)=>{
    return Boolean(children.type() === null);
};

});

parcelRegister("3khWZ", function(module, exports) {
$parcel$export(module.exports, "ElementDisplaySchema", () => $e6d1beb4c0cefb0f$export$f942619ce67b1a41);

var $5kJPq = parcelRequire("5kJPq");
const $e6d1beb4c0cefb0f$export$f942619ce67b1a41 = {
    [(0, $5kJPq.ElementName).AssignedTo]: [
        'inline'
    ],
    [(0, $5kJPq.ElementName).AssignedToGroup]: [
        'inline'
    ],
    [(0, $5kJPq.ElementName).AttachmentCount]: [
        'inline'
    ],
    [(0, $5kJPq.ElementName).AuthorGroup]: [
        'inline'
    ],
    [(0, $5kJPq.ElementName).AppliedToComponentsCount]: [
        'inline'
    ],
    [(0, $5kJPq.ElementName).ChecklistProgress]: [
        'inline'
    ],
    [(0, $5kJPq.ElementName).CollaboratorGroup]: [
        'inline'
    ],
    [(0, $5kJPq.ElementName).CommentCount]: [
        'inline'
    ],
    [(0, $5kJPq.ElementName).CreatedBy]: [
        'inline'
    ],
    [(0, $5kJPq.ElementName).CreatedOn]: [
        'inline'
    ],
    [(0, $5kJPq.ElementName).DueOn]: [
        'inline'
    ],
    [(0, $5kJPq.ElementName).LatestCommit]: [
        'inline'
    ],
    [(0, $5kJPq.ElementName).LinkIcon]: [
        'inline'
    ],
    [(0, $5kJPq.ElementName).Location]: [
        'inline'
    ],
    [(0, $5kJPq.ElementName).ModifiedBy]: [
        'inline'
    ],
    [(0, $5kJPq.ElementName).ModifiedOn]: [
        'inline'
    ],
    [(0, $5kJPq.ElementName).OwnedBy]: [
        'inline'
    ],
    [(0, $5kJPq.ElementName).OwnedByGroup]: [
        'inline'
    ],
    [(0, $5kJPq.ElementName).Preview]: [
        'block'
    ],
    [(0, $5kJPq.ElementName).Priority]: [
        'inline'
    ],
    [(0, $5kJPq.ElementName).ProgrammingLanguage]: [
        'inline'
    ],
    [(0, $5kJPq.ElementName).Provider]: [
        'inline'
    ],
    [(0, $5kJPq.ElementName).ReactCount]: [
        'inline'
    ],
    [(0, $5kJPq.ElementName).ReadTime]: [
        'inline'
    ],
    [(0, $5kJPq.ElementName).Snippet]: [
        'block'
    ],
    [(0, $5kJPq.ElementName).SourceBranch]: [
        'inline'
    ],
    [(0, $5kJPq.ElementName).SentOn]: [
        'inline'
    ],
    [(0, $5kJPq.ElementName).State]: [
        'inline'
    ],
    [(0, $5kJPq.ElementName).SubscriberCount]: [
        'inline'
    ],
    [(0, $5kJPq.ElementName).TeamMemberCount]: [
        'inline'
    ],
    [(0, $5kJPq.ElementName).SubTasksProgress]: [
        'inline'
    ],
    [(0, $5kJPq.ElementName).StoryPoints]: [
        'inline'
    ],
    [(0, $5kJPq.ElementName).TargetBranch]: [
        'inline'
    ],
    [(0, $5kJPq.ElementName).Title]: [
        'inline'
    ],
    [(0, $5kJPq.ElementName).UserAttributes]: [
        'inline'
    ],
    [(0, $5kJPq.ElementName).ViewCount]: [
        'inline'
    ],
    [(0, $5kJPq.ElementName).VoteCount]: [
        'inline'
    ],
    [(0, $5kJPq.ElementName).HostName]: [
        'inline'
    ]
};

});



parcelRegister("ay88c", function(module, exports) {
$parcel$export(module.exports, "default", () => $a0e6bab95a349289$export$2e2bcd8739ae039);
/* eslint-disable @atlaskit/ui-styling-standard/no-unsafe-values */ 
var $bSJIT = parcelRequire("bSJIT");

var $5kJPq = parcelRequire("5kJPq");

var $18x1K = parcelRequire("18x1K");

var $lgzQp = parcelRequire("lgzQp");

var $b2mmI = parcelRequire("b2mmI");

var $8dLhi = parcelRequire("8dLhi");
/**
 * This represents a TitleBlock for a Smart Link that is currently waiting
 * for a request to finish.
 * This should render when a Smart Link has sent a request.
 * @see TitleBlock
 */ const $a0e6bab95a349289$var$TitleBlockResolvingView = ({ actionGroup: actionGroup, icon: icon, position: position, testId: testId, title: title, hideIcon: hideIcon, ...blockProps })=>{
    const { size: size = (0, $5kJPq.SmartLinkSize).Medium } = blockProps;
    const iconWidth = (0, $b2mmI.getIconWidth)(size);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $8dLhi.default), {
        ...blockProps,
        testId: `${testId}-resolving-view`
    }, !hideIcon && icon && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $lgzQp.default), {
        overrideIcon: icon,
        position: position,
        size: size,
        hideLoadingSkeleton: true
    }), !hideIcon && !icon && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement("span", {
        style: {
            width: iconWidth,
            height: iconWidth
        },
        "data-testid": `${testId}-icon`
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $18x1K.LoadingSkeleton), {
        width: iconWidth,
        height: iconWidth,
        testId: `${testId}-icon-loading`
    })), title, actionGroup);
};
var $a0e6bab95a349289$export$2e2bcd8739ae039 = $a0e6bab95a349289$var$TitleBlockResolvingView;

});





parcelRegister("1xHS2", function(module, exports) {
$parcel$export(module.exports, "LoadingCardLink", () => $11cc3cc8399d222e$export$1ca0544321134ad6);

var $bSJIT = parcelRequire("bSJIT");

var $kUIsB = parcelRequire("kUIsB");

var $j33qf = parcelRequire("j33qf");
const $11cc3cc8399d222e$export$1ca0544321134ad6 = ({ isSelected: isSelected, url: url, placeholder: placeholder })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $j33qf.CardLinkView), {
        key: 'lazy-render-key',
        testId: 'lazy-render-placeholder',
        "data-trello-do-not-use-override": "lazy-render-placeholder-trello",
        isSelected: isSelected,
        link: url,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: (0, $kUIsB.loadingPlaceholderClassName),
        placeholder: placeholder
    });
};

});
parcelRegister("kUIsB", function(module, exports) {
$parcel$export(module.exports, "loadingPlaceholderClassName", () => $de64feaf3c119a0b$export$4b2b7d155f69aed4);
/* eslint-disable @repo/internal/deprecations/deprecation-ticket-required -- VOLTC-139 tracks removal of these deprecated re-export shims. */ 
var $8sqBF = parcelRequire("8sqBF");
const $de64feaf3c119a0b$export$889f1c7c5c7ba2f = 'smart-link-content-footer';
const $de64feaf3c119a0b$export$9747a645aa1216c7 = 'smart-link-metadata-list';
const $de64feaf3c119a0b$export$d4b64e3ae38899a3 = 'block-card-resolving-view';
const $de64feaf3c119a0b$export$7b62853ead5e547c = 'block-card-resolved-view';
const $de64feaf3c119a0b$export$3f9f9653bc75f33d = 'block-card-resolved-view-by';
const $de64feaf3c119a0b$export$a21bb776ab2c28b5 = 'block-card-forbidden-view';
const $de64feaf3c119a0b$export$e9fa69ca91e22a09 = 'block-card-forbidden-view-link';
const $de64feaf3c119a0b$export$d17e5383afeb158c = 'block-card-content';
const $de64feaf3c119a0b$export$8c59795ed52e92b3 = 'block-card-content-header';
const $de64feaf3c119a0b$export$a76ed4d75b5db5f = 'block-card-content-header-name';
const $de64feaf3c119a0b$export$7fbeca230aee4e1a = 'block-card-not-found-view';
const $de64feaf3c119a0b$export$38dcd9bf8c681d21 = 'block-card-errored-view';
const $de64feaf3c119a0b$export$4b2b7d155f69aed4 = 'smart-link-loading-placeholder';

});
parcelRegister("8sqBF", function(module, exports) {
$parcel$export(module.exports, "blockCardIconImageClassName", () => $e0c79f94b92d2b5a$export$f3ef6db93b5dfd7a);
$parcel$export(module.exports, "Icon", () => $e0c79f94b92d2b5a$export$f04a61298a47a40f);
/* Icon.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $9fU1q = parcelRequire("9fU1q");

var $bSJIT = parcelRequire("bSJIT");

var $ktg9Z = parcelRequire("ktg9Z");

var $gRfjb = parcelRequire("gRfjb");
const $e0c79f94b92d2b5a$export$f3ef6db93b5dfd7a = 'block-card-icon-image';
const $e0c79f94b92d2b5a$var$imageStyles = null;
const $e0c79f94b92d2b5a$var$spanStyles = null;
const $e0c79f94b92d2b5a$export$f04a61298a47a40f = ({ url: url, icon: icon, defaultIcon: defaultIcon, testId: testId = 'block-card-icon', isFlexibleUi: isFlexibleUi = false })=>{
    const placeholder = defaultIcon || /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($gRfjb))), {
        label: "link",
        testId: `${testId}-default`,
        color: "currentColor"
    });
    const image = url && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($ktg9Z))), {
        src: url,
        loaded: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement("img", {
            src: url,
            alt: "",
            "data-testid": `${testId}-image`,
            className: (0, $9fU1q.default)([
                isFlexibleUi && "_4t3i7vkz _1bsb7vkz"
            ])
        }),
        errored: placeholder
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement("span", {
        "data-testid": testId,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: (0, $9fU1q.default)([
            isFlexibleUi && "_4t3igktf _1bsb7vkz _1e0c1txw _4cvr1h6o _1bah1h6o",
            $e0c79f94b92d2b5a$export$f3ef6db93b5dfd7a
        ])
    }, icon || image || placeholder);
};

});


parcelRegister("j33qf", function(module, exports) {
$parcel$export(module.exports, "CardLinkView", () => $66fa4fe74b933989$export$ce508304ed2dd145);

var $bSJIT = parcelRequire("bSJIT");

var $gd4UU = parcelRequire("gd4UU");
class $66fa4fe74b933989$export$ce508304ed2dd145 extends (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).PureComponent {
    render() {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $gd4UU.Frame), {
            withoutBackground: true,
            ...this.props
        }, this.props.placeholder || this.props.link);
    }
}

});
parcelRegister("gd4UU", function(module, exports) {
$parcel$export(module.exports, "Frame", () => $1b92f167e3468b2e$export$b89a827e9254211a);

var $bSJIT = parcelRequire("bSJIT");

var $e6VxI = parcelRequire("e6VxI");

var $eo1MP = parcelRequire("eo1MP");
const $1b92f167e3468b2e$export$b89a827e9254211a = /*#__PURE__*/ (0, $bSJIT.forwardRef)((props, ref)=>{
    const { isSelected: isSelected, children: children, onClick: onClick, onAuxClick: onAuxClick, onContextMenu: onContextMenu, link: link, viewType: viewType, withoutBackground: withoutBackground, testId: testId, className: className, isHovered: isHovered, truncateInline: truncateInline } = props;
    const handleClick = (0, $bSJIT.useCallback)((event)=>{
        if (onClick) {
            event.preventDefault();
            event.stopPropagation();
            onClick(event);
        }
    }, [
        onClick
    ]);
    const handleKeyPress = (0, $bSJIT.useCallback)((event)=>{
        if (event.key !== ' ' && event.key !== 'Enter') return;
        if (onClick) {
            event.preventDefault();
            event.stopPropagation();
            onClick(event);
        }
    }, [
        onClick
    ]);
    const handleMouseDown = (0, $e6VxI.useMouseDownEvent)();
    const isInteractive = Boolean(onClick);
    const isAnchor = Boolean(link || onClick);
    // Depending on whenever Frame was given onClick or link itself we display span or anchor elements
    const Wrapper = isAnchor ? (0, $eo1MP.WrapperAnchor) : (0, $eo1MP.WrapperSpan);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement(Wrapper, {
        href: link,
        withoutBackground: withoutBackground,
        isSelected: isSelected,
        isInteractive: isInteractive,
        tabIndex: isInteractive && !link ? 0 : undefined,
        role: isInteractive && !link ? 'button' : undefined,
        onClick: handleClick,
        onAuxClick: onAuxClick,
        onContextMenu: onContextMenu,
        onMouseDown: handleMouseDown,
        onKeyPress: handleKeyPress,
        "data-testid": testId,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: className,
        ref: ref,
        isHovered: isHovered,
        truncateInline: truncateInline,
        viewType: viewType
    }, children);
});

});
parcelRegister("eo1MP", function(module, exports) {
$parcel$export(module.exports, "WrapperSpan", () => $a2fc8eb10b63499d$export$8b5c95e985c4ec9a);
$parcel$export(module.exports, "WrapperAnchor", () => $a2fc8eb10b63499d$export$6e4bde711df5c2ab);
/* styled.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $9fU1q = parcelRequire("9fU1q");

var $bSJIT = parcelRequire("bSJIT");
const $a2fc8eb10b63499d$export$8b5c95e985c4ec9a = /*#__PURE__*/ (0, $bSJIT.forwardRef)(({ truncateInline: truncateInline, withoutBackground: withoutBackground, isHovered: isHovered, isInteractive: _isInteractive, isSelected: isSelected, viewType: viewType, ...props }, ref)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement("span", {
        ref: ref,
        ...props,
        className: (0, $9fU1q.default)([
            "_1yt4x7n9 _2rko1ssi _v56415x0 _1e0c1nu9 _16d9qvcn _syaz13af _1rkwglyw _4cvx1w55",
            truncateInline && "_1reo15vq _18m915vq _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _1bto1l2s _1nmz9jpi _1e0c1abx _1yyjkb7n _sudp1e54 _nr8z1o8l _1voyv77o _3kwxidpf _jqg5v77o _6vwiidpf",
            truncateInline && viewType === 'unauthorised' && "_syaz15cr",
            withoutBackground ? "_19bvidpf _18u01i6y" : "_19itia51 _bfhkhp5a _1a3b1r31 _4fprglyw _5goinqa1 _9oik1r31 _1bnxglyw _jf4cnqa1 _1nrm1r31 _c2waglyw _1iohnqa1",
            isHovered && "_1h6d1w55",
            isHovered && !withoutBackground && "_4bfu1r31 _1hmsglyw _ajmmnqa1",
            isSelected ? "_12ji1r31 _1qu2glyw _12y31o36 _80omtlke _16qsw5lj _uiztglyw _1a3b1r31 _4fprglyw _5goinqa1 _9oik1r31 _1bnxglyw _jf4cnqa1 _bfw7ia51 _1nrm1r31 _c2waglyw _1iohnqa1" : "_uizt1kdv"
        ])
    }, props.children);
});
const $a2fc8eb10b63499d$export$6e4bde711df5c2ab = /*#__PURE__*/ (0, $bSJIT.forwardRef)(({ truncateInline: truncateInline, withoutBackground: withoutBackground, isHovered: isHovered, isInteractive: isInteractive, isSelected: isSelected, href: href, viewType: viewType, ...props }, ref)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement("a", {
        href: href,
        ref: ref,
        ...props,
        className: (0, $9fU1q.default)([
            "_1yt4x7n9 _2rko1ssi _v56415x0 _1e0c1nu9 _16d9qvcn _syaz13af _1rkwglyw _4cvx1w55",
            truncateInline && "_1reo15vq _18m915vq _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _1bto1l2s _1nmz9jpi _1e0c1abx _1yyjkb7n _sudp1e54 _nr8z1o8l _1voyv77o _3kwxidpf _jqg5v77o _6vwiidpf",
            truncateInline && viewType === 'unauthorised' && "_syaz15cr",
            withoutBackground ? "_19bvidpf _18u01i6y" : "_19itia51 _bfhkhp5a _1a3b1r31 _4fprglyw _5goinqa1 _9oik1r31 _1bnxglyw _jf4cnqa1 _1nrm1r31 _c2waglyw _1iohnqa1",
            isHovered && "_1h6d1w55",
            isHovered && !withoutBackground && "_4bfu1r31 _1hmsglyw _ajmmnqa1",
            isSelected ? "_12ji1r31 _1qu2glyw _12y31o36 _80omtlke _16qsw5lj _uiztglyw _1a3b1r31 _4fprglyw _5goinqa1 _9oik1r31 _1bnxglyw _jf4cnqa1 _bfw7ia51 _1nrm1r31 _c2waglyw _1iohnqa1" : "_uizt1kdv",
            isInteractive && "_nt751r31 _49pcglyw _1hvw1o36 _1372tlke _7ehiw5lj _1j5pglyw _1di615s3",
            viewType === 'errored' && "_4bfu1r31 _1hms8stv _ajmmnqa1 _9oik1r31 _1bnxglyw _jf4cnqa1"
        ])
    }, props.children);
});
const $a2fc8eb10b63499d$var$baseWrapperStyles = null;
// if the parent instruct the wrapper to be interactive, and the wrapper is in focus, apply selectedStyles
const $a2fc8eb10b63499d$var$interactiveStyles = null;
const $a2fc8eb10b63499d$var$hoveredStyles = null;
const $a2fc8eb10b63499d$var$hoveredWithBackgroundStyles = null;
const $a2fc8eb10b63499d$var$errorViewTypeStyles = null;
const $a2fc8eb10b63499d$var$withoutBackgroundStyles = null;
const $a2fc8eb10b63499d$var$withBackgroundStyles = null;
const $a2fc8eb10b63499d$var$truncateStyles = null;
const $a2fc8eb10b63499d$var$unauthorisedTruncateStyles = null;
const $a2fc8eb10b63499d$var$notSelectedStyle = null;
const $a2fc8eb10b63499d$var$selectedStyles = null;

});





//# sourceMappingURL=shared.a158bb4a.js.map
